import { useQuery, UseQueryOptions, useMutation, UseMutationOptions } from 'react-query';
import { graphqlFetcher } from '../util/graphql-fetch-config';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  ISO8601Date: string;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: string;
  /** Arbitrary JSON data */
  Json: any;
  /** A valid URL, transported as a string */
  Url: string;
};

export type ActiveClientOrder = {
  __typename?: 'ActiveClientOrder';
  clientOrder: ClientOrder;
  id: Scalars['ID'];
};

/** Autogenerated input type of AddSkusToClientOrder */
export type AddSkusToClientOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The client project to add these skus to */
  clientOrderId: Scalars['ID'];
  /** The client order product to add these skus to */
  clientOrderProductId?: InputMaybe<Scalars['ID']>;
  /** Export port */
  exportShippingPortId?: InputMaybe<Scalars['ID']>;
  /** Import port */
  importShippingPortId?: InputMaybe<Scalars['ID']>;
  /** Should the cost include duty costs */
  includeDutyCosts: Scalars['Boolean'];
  /** Should the cost include shipping costs */
  includeShippingCosts: Scalars['Boolean'];
  makerOrders?: InputMaybe<Array<MakerOrderInput>>;
  /** List of skus and quantities to add to client project */
  skus: Array<SkuQuantityInput>;
};

/** Autogenerated return type of AddSkusToClientOrder */
export type AddSkusToClientOrderPayload = {
  __typename?: 'AddSkusToClientOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  clientOrder: ClientOrder;
  errors: Array<ValidationError>;
};

export type Addon = {
  __typename?: 'Addon';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  addressType: Scalars['String'];
  contactEmail?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  deliveryAppointmentRequired: Scalars['Boolean'];
  dock: Scalars['Boolean'];
  id: Scalars['ID'];
  label: Scalars['String'];
  plain: Scalars['String'];
  selectLabel: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  warehouseAddressNotes?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  contactName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  plain?: InputMaybe<Scalars['String']>;
};

export type Attachment = {
  __typename?: 'Attachment';
  attachmentUrl: Scalars['String'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  imgixUrl: Scalars['Url'];
  url: Scalars['Url'];
};


export type AttachmentUrlArgs = {
  download?: InputMaybe<Scalars['Boolean']>;
};

export type Certification = {
  __typename?: 'Certification';
  icon: Attachment;
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** The connection type for Certification. */
export type CertificationConnection = {
  __typename?: 'CertificationConnection';
  /** A list of edges. */
  edges: Array<CertificationEdge>;
  /** A list of nodes. */
  nodes: Array<Certification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CertificationEdge = {
  __typename?: 'CertificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Certification>;
};

export type Client = {
  __typename?: 'Client';
  createdAt: Scalars['ISO8601DateTime'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  humanId: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  showUrl: Scalars['Url'];
  slug?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ClientApprovalOrder = {
  __typename?: 'ClientApprovalOrder';
  createdAt: Scalars['ISO8601DateTime'];
  humanId: Scalars['String'];
  humanStatus: Scalars['String'];
  id: Scalars['ID'];
  showUrl: Scalars['String'];
  status: Scalars['String'];
};

/** The connection type for ClientApprovalOrder. */
export type ClientApprovalOrderConnection = {
  __typename?: 'ClientApprovalOrderConnection';
  /** A list of edges. */
  edges: Array<ClientApprovalOrderEdge>;
  /** A list of nodes. */
  nodes: Array<ClientApprovalOrder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ClientApprovalOrderEdge = {
  __typename?: 'ClientApprovalOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ClientApprovalOrder>;
};

/** The connection type for Client. */
export type ClientConnection = {
  __typename?: 'ClientConnection';
  /** A list of edges. */
  edges: Array<ClientEdge>;
  /** A list of nodes. */
  nodes: Array<Client>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ClientEdge = {
  __typename?: 'ClientEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Client>;
};

export type ClientLegalAgreement = {
  __typename?: 'ClientLegalAgreement';
  content: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ClientOrder = {
  __typename?: 'ClientOrder';
  acceptedByClient: Scalars['Boolean'];
  addressOptions: Array<Address>;
  archived: Scalars['Boolean'];
  billingAddress?: Maybe<Address>;
  billingAddressId?: Maybe<Scalars['ID']>;
  client: Client;
  clientApprovalOrders: ClientApprovalOrderConnection;
  clientApprovalOrdersUrl: Scalars['Url'];
  clientLegalAgreementId?: Maybe<Scalars['ID']>;
  clientLegalAgreementOptions: Array<ClientLegalAgreement>;
  clientOrderProducts: ClientOrderProductConnection;
  clientSoPo?: Maybe<Array<Attachment>>;
  contacts: Array<Contact>;
  createdAt: Scalars['ISO8601DateTime'];
  creatorUser?: Maybe<User>;
  deliveryWindow?: Maybe<Scalars['Json']>;
  description: Scalars['String'];
  designLeads?: Maybe<Array<Contact>>;
  duplicateUrl: Scalars['Url'];
  editUrl: Scalars['Url'];
  externalPoReference?: Maybe<Scalars['String']>;
  financialLeads: Array<Contact>;
  hasAcceptedMakerOrders: Scalars['Boolean'];
  humanId: Scalars['String'];
  id: Scalars['ID'];
  impactLeads: Array<Contact>;
  impactReport?: Maybe<ImpactReport>;
  internalNotes?: Maybe<Scalars['String']>;
  leadOptions: Array<Contact>;
  makerOrders: MakerOrderConnection;
  makerOrdersUrl: Scalars['Url'];
  makers: MakerConnection;
  msrpRange?: Maybe<Scalars['String']>;
  newClientApprovalOrderUrl: Scalars['Url'];
  newClientOrderProductUrl: Scalars['Url'];
  newImpactReportUrl: Scalars['String'];
  newMakerOrderUrl: Scalars['Url'];
  newReferenceImageUrl: Scalars['String'];
  newSalesPresentationUrl: Scalars['Url'];
  newTimeAndActionUrl: Scalars['Url'];
  operationsLeads: Array<Contact>;
  orderChanges: Array<OrderChange>;
  paymentTerms?: Maybe<Scalars['String']>;
  perItemPriceRange?: Maybe<Scalars['String']>;
  productCount: Scalars['Int'];
  productionLeads?: Maybe<Array<Contact>>;
  referenceImages: Array<Attachment>;
  salesLeads: Array<Contact>;
  salesPresentations: SalesPresentationConnection;
  salesPresentationsUrl: Scalars['Url'];
  shippingAddress?: Maybe<Address>;
  shippingAddressId?: Maybe<Scalars['ID']>;
  showUrl: Scalars['String'];
  status?: Maybe<ClientOrderStatus>;
  statusOptions: Array<ClientOrderStatus>;
  timeAndActions: TimeAndActionConnection;
  timeAndActionsUrl: Scalars['Url'];
  totalCostCents?: Maybe<Scalars['Int']>;
  totalMargin?: Maybe<Scalars['Float']>;
  totalPriceLooseCents: Scalars['Int'];
  totalQuantity: Scalars['Int'];
  totalSkuUnits: Scalars['Int'];
  totalUniqueProducts: Scalars['Int'];
  totalUnits: Scalars['Int'];
};


export type ClientOrderClientApprovalOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ClientOrderClientOrderProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ClientOrderMakerOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ClientOrderMakersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ClientOrderMsrpRangeArgs = {
  productId: Scalars['ID'];
};


export type ClientOrderPerItemPriceRangeArgs = {
  productId: Scalars['ID'];
};


export type ClientOrderSalesPresentationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ClientOrderTimeAndActionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ClientOrderTotalQuantityArgs = {
  productId: Scalars['ID'];
};

/** The connection type for ClientOrder. */
export type ClientOrderConnection = {
  __typename?: 'ClientOrderConnection';
  /** A list of edges. */
  edges: Array<ClientOrderEdge>;
  /** A list of nodes. */
  nodes: Array<ClientOrder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ClientOrderEdge = {
  __typename?: 'ClientOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ClientOrder>;
};

export type ClientOrderProduct = {
  __typename?: 'ClientOrderProduct';
  clientOrderProductAddons: Array<ClientOrderProductAddon>;
  clientOrderProductCustomizations: Array<ClientOrderProductCustomization>;
  clientOrderProductLineItems: Array<ClientOrderProductLineItem>;
  clientOrderProductSkus: Array<ClientOrderProductSku>;
  editUrl: Scalars['Url'];
  exportShippingPort?: Maybe<ShippingPort>;
  id: Scalars['ID'];
  image?: Maybe<Image>;
  importShippingPort?: Maybe<ShippingPort>;
  includeDutyCosts: Scalars['Boolean'];
  includeShippingCosts: Scalars['Boolean'];
  makerId: Scalars['ID'];
  product: Product;
  totalCostCents?: Maybe<Scalars['Int']>;
  totalEmissionsAvoidedKg?: Maybe<Scalars['Float']>;
  totalEnergyConservedKwh?: Maybe<Scalars['Float']>;
  totalFairWageHoursWorked?: Maybe<Scalars['Float']>;
  totalPesticidesAvoidedG?: Maybe<Scalars['Float']>;
  totalPriceCents?: Maybe<Scalars['Int']>;
  totalRecycledWaterBottles?: Maybe<Scalars['Float']>;
  totalWaterSavedLiters?: Maybe<Scalars['Float']>;
};

export type ClientOrderProductAddon = {
  __typename?: 'ClientOrderProductAddon';
  addon: Addon;
  calculatedMargin?: Maybe<Scalars['Float']>;
  calculatedPerItemPrice?: Maybe<Scalars['Float']>;
  editCostUrl: Scalars['Url'];
  id: Scalars['ID'];
  margin?: Maybe<Scalars['Float']>;
  perItemAmountCents?: Maybe<Scalars['Int']>;
  perItemPrice?: Maybe<Scalars['Float']>;
  perItemPriceCents?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  totalPriceCents?: Maybe<Scalars['Int']>;
};

export type ClientOrderProductAddonInput = {
  addonId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  margin?: InputMaybe<Scalars['String']>;
  perItemPrice?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  remove?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for ClientOrderProduct. */
export type ClientOrderProductConnection = {
  __typename?: 'ClientOrderProductConnection';
  /** A list of edges. */
  edges: Array<ClientOrderProductEdge>;
  /** A list of nodes. */
  nodes: Array<ClientOrderProduct>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ClientOrderProductCustomization = {
  __typename?: 'ClientOrderProductCustomization';
  calculatedMargin?: Maybe<Scalars['Float']>;
  calculatedPerItemPrice?: Maybe<Scalars['Float']>;
  customization: Customization;
  customizationArtworks: Array<CustomizationArtwork>;
  editCostUrl: Scalars['Url'];
  editUrl: Scalars['Url'];
  id: Scalars['ID'];
  margin?: Maybe<Scalars['Float']>;
  perItemAmountCents?: Maybe<Scalars['Int']>;
  perItemPrice?: Maybe<Scalars['Float']>;
  perItemPriceCents?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  totalPriceCents?: Maybe<Scalars['Int']>;
};

export type ClientOrderProductCustomizationInput = {
  customizationId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  margin?: InputMaybe<Scalars['String']>;
  perItemPrice?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  remove?: InputMaybe<Scalars['Boolean']>;
};

/** An edge in a connection. */
export type ClientOrderProductEdge = {
  __typename?: 'ClientOrderProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ClientOrderProduct>;
};

export type ClientOrderProductInput = {
  clientOrderProductAddons?: InputMaybe<Array<ClientOrderProductAddonInput>>;
  clientOrderProductCustomizations?: InputMaybe<Array<ClientOrderProductCustomizationInput>>;
  clientOrderProductLineItems?: InputMaybe<Array<ClientOrderProductLineItemInput>>;
  clientOrderProductSkus?: InputMaybe<Array<ClientOrderProductSkuInput>>;
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<ImageInput>;
  productId?: InputMaybe<Scalars['ID']>;
  remove?: InputMaybe<Scalars['Boolean']>;
};

export type ClientOrderProductLineItem = {
  __typename?: 'ClientOrderProductLineItem';
  calculatedMargin?: Maybe<Scalars['Float']>;
  calculatedPerItemPrice?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  margin?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  perItemCost?: Maybe<Scalars['Float']>;
  perItemCostCents?: Maybe<Scalars['Int']>;
  perItemPrice?: Maybe<Scalars['Float']>;
  perItemPriceCents?: Maybe<Scalars['Int']>;
  quantity: Scalars['Int'];
  totalPriceCents?: Maybe<Scalars['Int']>;
};

export type ClientOrderProductLineItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  margin?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  perItemCost?: InputMaybe<Scalars['String']>;
  perItemPrice?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  remove?: InputMaybe<Scalars['Boolean']>;
};

export type ClientOrderProductSku = {
  __typename?: 'ClientOrderProductSku';
  calculatedMargin?: Maybe<Scalars['Float']>;
  calculatedPerItemPrice?: Maybe<Scalars['Float']>;
  cogsPerItemAmountCents?: Maybe<Scalars['Int']>;
  /** Used to calculate duty, based on product country */
  countryOfOrigin?: Maybe<Country>;
  dutyCostsCents?: Maybe<Scalars['Int']>;
  editCostUrl: Scalars['Url'];
  id: Scalars['ID'];
  margin?: Maybe<Scalars['Float']>;
  msrp?: Maybe<Scalars['Float']>;
  msrpCents?: Maybe<Scalars['Int']>;
  perItemAmountCents?: Maybe<Scalars['Int']>;
  perItemPrice?: Maybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  shippingCostsCents?: Maybe<Scalars['Int']>;
  sku: Sku;
  totalBulbEnergySavedHours?: Maybe<Scalars['Float']>;
  totalCarbonOffsetKg?: Maybe<Scalars['Float']>;
  totalDrinkingWaterSavedDays?: Maybe<Scalars['Float']>;
  totalDrivingEmissionsAvoidedKm?: Maybe<Scalars['Float']>;
  totalEmissionsAvoidedKg?: Maybe<Scalars['Float']>;
  totalEnergyConservedKwh?: Maybe<Scalars['Float']>;
  totalFairWageHoursWorked?: Maybe<Scalars['Float']>;
  totalLandSavedFromPesticidesM2?: Maybe<Scalars['Float']>;
  totalPesticidesAvoidedG?: Maybe<Scalars['Float']>;
  totalPriceCents?: Maybe<Scalars['Int']>;
  totalRecycledWaterBottles?: Maybe<Scalars['Float']>;
  totalWasteDivertedG?: Maybe<Scalars['Float']>;
  totalWaterSavedLiters?: Maybe<Scalars['Float']>;
};

export type ClientOrderProductSkuInput = {
  addAllNpaVariantIds?: InputMaybe<Array<Scalars['ID']>>;
  editableVariant?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  margin?: InputMaybe<Scalars['String']>;
  msrp?: InputMaybe<Scalars['String']>;
  npaVariantOptions?: InputMaybe<Array<Scalars['ID']>>;
  perItemPrice?: InputMaybe<Scalars['String']>;
  perItemPriceCents?: InputMaybe<Scalars['Int']>;
  performLookupSku?: InputMaybe<Scalars['Boolean']>;
  quantity?: InputMaybe<Scalars['Int']>;
  remove?: InputMaybe<Scalars['Boolean']>;
};

export type ClientOrderSearchFilterOptions = {
  __typename?: 'ClientOrderSearchFilterOptions';
  clientOrderStatuses: Array<SelectOption>;
  clients: Array<Client>;
  customsStatuses: Array<SelectOption>;
  exportPorts: Array<ShippingPort>;
  finalMileDeliveries: Array<SelectOption>;
  importPorts: Array<ShippingPort>;
  makers: Array<Maker>;
  owners: Array<User>;
  parcelCarriers: Array<ParcelCarrier>;
  productionStatuses: Array<SelectOption>;
  shipmentStatuses: Array<SelectOption>;
  shippingModes: Array<SelectOption>;
  vesselStatuses: Array<SelectOption>;
};

export type ClientOrderSort = {
  attribute?: InputMaybe<ClientOrderSortField>;
  order?: InputMaybe<SortOrder>;
};

export enum ClientOrderSortField {
  /** Client Order Created At */
  CreatedAt = 'CREATED_AT',
  /** Client Order Delivery Window */
  DeliveryWindow = 'DELIVERY_WINDOW'
}

export enum ClientOrderStatus {
  AwaitingClientApproval = 'AWAITING_CLIENT_APPROVAL',
  AwaitingMakerOrderApprovals = 'AWAITING_MAKER_ORDER_APPROVALS',
  AwaitingPresentation = 'AWAITING_PRESENTATION',
  Complete = 'COMPLETE',
  Converted = 'CONVERTED',
  Delivered = 'DELIVERED',
  InProduction = 'IN_PRODUCTION',
  InTransit = 'IN_TRANSIT',
  LcaDataRequestCompleted = 'LCA_DATA_REQUEST_COMPLETED',
  Lost = 'LOST',
  MakerOrdersApproved = 'MAKER_ORDERS_APPROVED',
  Opportunity = 'OPPORTUNITY',
  PendingCosting = 'PENDING_COSTING',
  PendingMakerOrders = 'PENDING_MAKER_ORDERS'
}

export type ClientSort = {
  attribute?: InputMaybe<ClientSortField>;
  order?: InputMaybe<SortOrder>;
};

export enum ClientSortField {
  /** Most recent client */
  MostRecent = 'MOST_RECENT',
  /** Name of client */
  Name = 'NAME'
}

export type CogsColumn = {
  __typename?: 'CogsColumn';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  unitsMin: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type CogsVariantCell = {
  __typename?: 'CogsVariantCell';
  cogsColumnId: Scalars['ID'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  perItemAmountCents: Scalars['Int'];
  turnaroundTimeString: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  variantId: Scalars['ID'];
};

export type Contact = {
  __typename?: 'Contact';
  createdAt: Scalars['ISO8601DateTime'];
  email?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobTitle?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  preferredContactMethod?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  timezoneLabel?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for Contact. */
export type ContactConnection = {
  __typename?: 'ContactConnection';
  /** A list of edges. */
  edges: Array<ContactEdge>;
  /** A list of nodes. */
  nodes: Array<Contact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ContactEdge = {
  __typename?: 'ContactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Contact>;
};

export type ContactInput = {
  copyToClient?: InputMaybe<Scalars['Boolean']>;
  copyToMaker?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  remove?: InputMaybe<Scalars['Boolean']>;
  timezoneLabel?: InputMaybe<Scalars['String']>;
};

export type Country = {
  __typename?: 'Country';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  iso3166: Scalars['String'];
  name: Scalars['String'];
  nameWithFlag: Scalars['String'];
  region: Region;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for Country. */
export type CountryConnection = {
  __typename?: 'CountryConnection';
  /** A list of edges. */
  edges: Array<CountryEdge>;
  /** A list of nodes. */
  nodes: Array<Country>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type CountryEdge = {
  __typename?: 'CountryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Country>;
};

/** Autogenerated input type of CreateMakerOrder */
export type CreateMakerOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientOrderId: Scalars['String'];
  contacts: Array<ContactInput>;
  makerId: Scalars['String'];
  makerLegalAgreementId: Scalars['String'];
  makerSlug?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CreateMakerOrder */
export type CreateMakerOrderPayload = {
  __typename?: 'CreateMakerOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<ValidationError>;
  makerOrder: MakerOrder;
};

export type Customization = {
  __typename?: 'Customization';
  acceptsArtwork: Scalars['Boolean'];
  customizationCategoryName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CustomizationArtwork = {
  __typename?: 'CustomizationArtwork';
  artwork: Attachment;
  designColor: Scalars['String'];
  designLocation: Scalars['String'];
  designName: Scalars['String'];
  designSize: Scalars['String'];
  id: Scalars['ID'];
  imprintType: Scalars['String'];
};

export type Dimension = {
  __typename?: 'Dimension';
  heightCm?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  lengthCm?: Maybe<Scalars['Float']>;
  weightKg?: Maybe<Scalars['Float']>;
  widthCm?: Maybe<Scalars['Float']>;
};

export type DimensionInput = {
  heightCm?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lengthCm?: InputMaybe<Scalars['String']>;
  weightKg?: InputMaybe<Scalars['String']>;
  widthCm?: InputMaybe<Scalars['String']>;
};

export type Image = {
  __typename?: 'Image';
  createdAt: Scalars['ISO8601DateTime'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  imgixUrl: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ImageInput = {
  id?: InputMaybe<Scalars['ID']>;
  remove?: InputMaybe<Scalars['Boolean']>;
  signedId?: InputMaybe<Scalars['ID']>;
};

export type ImpactReport = {
  __typename?: 'ImpactReport';
  carbonOffsettingDescriptionCopyId?: Maybe<Scalars['ID']>;
  certificationOptions: Array<Certification>;
  certifications: CertificationConnection;
  client?: Maybe<Client>;
  clientId?: Maybe<Scalars['ID']>;
  clientOptions: Array<Client>;
  clientOrders: Array<ClientOrder>;
  conclusionCopyId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  disclaimerNotesCopyId?: Maybe<Scalars['ID']>;
  humanId: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  impactDescriptionCopyId?: Maybe<Scalars['ID']>;
  impactReportCopiesUrl: Scalars['String'];
  impactReportCopyOptions: Array<ImpactReportCopy>;
  indexUrl: Scalars['String'];
  makerCertifications: MakerCertificationConnection;
  makerMarketingImage?: Maybe<MakerMarketingImage>;
  /** All possible maker marketing images for this impact report */
  makerMarketingImages: MakerMarketingImageConnection;
  makers: MakerConnection;
  overviewCopyId?: Maybe<Scalars['ID']>;
  productAttributes: ProductAttributeConnection;
  showUrl: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  typeOptions: Array<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};


export type ImpactReportCertificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ImpactReportMakerCertificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ImpactReportMakerMarketingImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ImpactReportMakersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ImpactReportProductAttributesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for ImpactReport. */
export type ImpactReportConnection = {
  __typename?: 'ImpactReportConnection';
  /** A list of edges. */
  edges: Array<ImpactReportEdge>;
  /** A list of nodes. */
  nodes: Array<ImpactReport>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ImpactReportCopy = {
  __typename?: 'ImpactReportCopy';
  content: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  type: Scalars['String'];
};

/** An edge in a connection. */
export type ImpactReportEdge = {
  __typename?: 'ImpactReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ImpactReport>;
};

export type ImpactReportImage = {
  __typename?: 'ImpactReportImage';
  className: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  imgixUrl: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ImpactReportImageInput = {
  id?: InputMaybe<Scalars['ID']>;
  imageSignedId?: InputMaybe<Scalars['String']>;
  remove?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated input type of ImpactReport */
export type ImpactReportInput = {
  carbonOffsettingDescriptionCopyId?: InputMaybe<Scalars['ID']>;
  certificationIds?: InputMaybe<Array<Scalars['ID']>>;
  clientId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientOrderIds?: InputMaybe<Array<Scalars['ID']>>;
  conclusionCopyId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  disclaimerNotesCopyId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  impactDescriptionCopyId?: InputMaybe<Scalars['ID']>;
  makerCertificationIds?: InputMaybe<Array<Scalars['ID']>>;
  makerMarketingImageId?: InputMaybe<Scalars['ID']>;
  makers?: InputMaybe<Array<MakerInput>>;
  overviewCopyId?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ImpactReport */
export type ImpactReportPayload = {
  __typename?: 'ImpactReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<ValidationError>;
  impactReport: ImpactReport;
};

export type ImpactReportSearchFilterOptions = {
  __typename?: 'ImpactReportSearchFilterOptions';
  clients: Array<Client>;
  makers: Array<Maker>;
  types: Array<Scalars['String']>;
};

export type Incoterm = {
  __typename?: 'Incoterm';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for Incoterm. */
export type IncotermConnection = {
  __typename?: 'IncotermConnection';
  /** A list of edges. */
  edges: Array<IncotermEdge>;
  /** A list of nodes. */
  nodes: Array<Incoterm>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type IncotermEdge = {
  __typename?: 'IncotermEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Incoterm>;
};

export type MailCarrier = {
  __typename?: 'MailCarrier';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type Maker = {
  __typename?: 'Maker';
  address?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  capabilities: Array<Scalars['String']>;
  contacts: ContactConnection;
  costRangeEstimate?: Maybe<Scalars['String']>;
  countries: CountryConnection;
  countriesOptions: Array<Country>;
  createdAt: Scalars['ISO8601DateTime'];
  /** AKA Clients External to you */
  customers: Array<Scalars['String']>;
  customersOptions: Array<Scalars['String']>;
  defaultAirShippingPort?: Maybe<ShippingPort>;
  defaultSeaShippingPort?: Maybe<ShippingPort>;
  editUrl: Scalars['Url'];
  environmentalImpactDescription?: Maybe<Scalars['String']>;
  environments: Array<Scalars['String']>;
  exportExperience?: Maybe<Scalars['String']>;
  exportExperienceOptions: Array<Scalars['String']>;
  exportingCountries: CountryConnection;
  fallbackLogoUrl: Scalars['String'];
  /** AKA Notable fact */
  funFact?: Maybe<Scalars['String']>;
  hangTagLanguage?: Maybe<Scalars['String']>;
  humanId: Scalars['ID'];
  id: Scalars['ID'];
  impactReportClientOrderProducts: Array<ClientOrderProduct>;
  impactReportImage?: Maybe<ImpactReportImage>;
  incoterms: IncotermConnection;
  incotermsOptions: Array<Incoterm>;
  internalNotes?: Maybe<Scalars['String']>;
  internalOperationNotes?: Maybe<Scalars['String']>;
  licenses: Array<Scalars['String']>;
  licensesOptions: Array<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  logoUrlWithFallback: Scalars['String'];
  makerAttributes: MakerAttributeConnection;
  makerAudits: MakerAuditConnection;
  makerCapabilitiesOptions: Array<Scalars['String']>;
  makerCertificationTypes: Array<Scalars['String']>;
  makerCertifications: MakerCertificationConnection;
  makerContacts: MakerContactConnection;
  makerDocuments: MakerDocumentConnection;
  makerEnvironmentsOptions: Array<Scalars['String']>;
  makerMakerAttributes: MakerMakerAttributeConnection;
  makerMakerQuestions: MakerMakerQuestionConnection;
  makerMarketingImages: MakerMarketingImageConnection;
  makerMaterials: MakerMaterialConnection;
  makerNdas: MakerNdaConnection;
  makerOrders: MakerOrderConnection;
  makerProductCategories: MakerProductCategoryConnection;
  makerQuestions: MakerQuestionConnection;
  makerScore?: Maybe<MakerScore>;
  makerShippingPorts: MakerShippingPortConnection;
  makerTypeOptions: Array<Scalars['String']>;
  makerTypes: Array<Scalars['String']>;
  makerVettingSurveys: MakerVettingSurveyConnection;
  materials: MaterialConnection;
  minimumOrderQuantity?: Maybe<Scalars['String']>;
  moqNotes?: Maybe<Scalars['String']>;
  moqPriceCents?: Maybe<Scalars['Int']>;
  moqUnits?: Maybe<Scalars['Int']>;
  mostRecentOrderDate?: Maybe<Scalars['ISO8601DateTime']>;
  name: Scalars['String'];
  newMakerAuditUrl: Scalars['Url'];
  newMakerCertificationUrl: Scalars['String'];
  newMakerContactUrl: Scalars['Url'];
  newMakerDocumentUrl: Scalars['Url'];
  newMakerMarketingImageUrl: Scalars['Url'];
  newMakerMaterialUrl: Scalars['Url'];
  newMakerNdaUrl: Scalars['Url'];
  newMakerProductCategoryUrl: Scalars['Url'];
  newMakerShippingPortUrl: Scalars['Url'];
  newMakerVettingSurveyUrl: Scalars['Url'];
  numberOfEmployees?: Maybe<Scalars['String']>;
  numberOfWomenEmployees?: Maybe<Scalars['Int']>;
  orderMinimumCents: Scalars['Int'];
  orderStatus?: Maybe<Scalars['String']>;
  orderStatusOptions: Array<Scalars['String']>;
  parcelCarriers: ParcelCarrierConnection;
  parcelCarriersOptions: Array<ParcelCarrier>;
  pricePoint?: Maybe<Scalars['String']>;
  productCategories: Array<ProductCategory>;
  productSubcategories?: Maybe<ProductSubcategoryConnection>;
  productionCapacity?: Maybe<Scalars['String']>;
  productionCapacityNotes?: Maybe<Scalars['String']>;
  productionCapacityOptions: Array<Scalars['String']>;
  products: ProductConnection;
  /** General description */
  profile?: Maybe<Scalars['String']>;
  resourceUrl: Scalars['Url'];
  score?: Maybe<Scalars['Float']>;
  shippingPorts: ShippingPortConnection;
  showUrl: Scalars['Url'];
  slug: Scalars['String'];
  socialImpactDescription?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  status: MakerStatus;
  stockInUsa?: Maybe<Scalars['Boolean']>;
  strengths?: Maybe<Scalars['String']>;
  /** @deprecated prefer productSubcategories */
  subcategories: Array<Scalars['String']>;
  ttmMakerSince?: Maybe<Scalars['ISO8601Date']>;
  ttmMakerSinceDeprecated?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  url?: Maybe<Scalars['String']>;
  valueAlignments: Array<ValueAlignment>;
  valueAlignmentsOptions: Array<ValueAlignment>;
  vettingStatus?: Maybe<Scalars['String']>;
  vettingStatusOptions: Array<Scalars['String']>;
};


export type MakerContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerCountriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerExportingCountriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerImpactReportClientOrderProductsArgs = {
  impactReportId: Scalars['ID'];
};


export type MakerImpactReportImageArgs = {
  impactReportId: Scalars['ID'];
};


export type MakerIncotermsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerMakerAttributesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerMakerAuditsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerMakerCertificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerMakerContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerMakerDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerMakerMakerAttributesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerMakerMakerQuestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerMakerMarketingImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerMakerMaterialsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerMakerNdasArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerMakerOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerMakerProductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerMakerQuestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerMakerShippingPortsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerMakerVettingSurveysArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerMaterialsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerParcelCarriersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerProductSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type MakerShippingPortsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type MakerAttribute = {
  __typename?: 'MakerAttribute';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  text: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for MakerAttribute. */
export type MakerAttributeConnection = {
  __typename?: 'MakerAttributeConnection';
  /** A list of edges. */
  edges: Array<MakerAttributeEdge>;
  /** A list of nodes. */
  nodes: Array<MakerAttribute>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MakerAttributeEdge = {
  __typename?: 'MakerAttributeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MakerAttribute>;
};

export type MakerAudit = {
  __typename?: 'MakerAudit';
  createdAt: Scalars['ISO8601DateTime'];
  dateOfCompletion?: Maybe<Scalars['ISO8601DateTime']>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  documents: Array<Attachment>;
  editUrl: Scalars['Url'];
  expirationDate?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  maker: Maker;
  name?: Maybe<Scalars['String']>;
  performedBy?: Maybe<Scalars['String']>;
  renewalNotificationSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  results?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for MakerAudit. */
export type MakerAuditConnection = {
  __typename?: 'MakerAuditConnection';
  /** A list of edges. */
  edges: Array<MakerAuditEdge>;
  /** A list of nodes. */
  nodes: Array<MakerAudit>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MakerAuditEdge = {
  __typename?: 'MakerAuditEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MakerAudit>;
};

export type MakerCertification = {
  __typename?: 'MakerCertification';
  activeFrom?: Maybe<Scalars['ISO8601Date']>;
  certification: Certification;
  /** @deprecated Use certification instead */
  certificationType: Scalars['String'];
  certifier?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  documentUrl?: Maybe<Scalars['String']>;
  editUrl: Scalars['String'];
  expiredAt?: Maybe<Scalars['ISO8601Date']>;
  expiringNotificationSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  maker: Maker;
  updatedAt: Scalars['ISO8601DateTime'];
};


export type MakerCertificationDocumentUrlArgs = {
  download: Scalars['Boolean'];
};

/** The connection type for MakerCertification. */
export type MakerCertificationConnection = {
  __typename?: 'MakerCertificationConnection';
  /** A list of edges. */
  edges: Array<MakerCertificationEdge>;
  /** A list of nodes. */
  nodes: Array<MakerCertification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MakerCertificationEdge = {
  __typename?: 'MakerCertificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MakerCertification>;
};

/** The connection type for Maker. */
export type MakerConnection = {
  __typename?: 'MakerConnection';
  /** A list of edges. */
  edges: Array<MakerEdge>;
  /** A list of nodes. */
  nodes: Array<Maker>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type MakerContact = {
  __typename?: 'MakerContact';
  archived: Scalars['Boolean'];
  contact: Contact;
  createdAt: Scalars['ISO8601DateTime'];
  default: Scalars['Boolean'];
  editUrl: Scalars['Url'];
  id: Scalars['ID'];
  maker: Maker;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for MakerContact. */
export type MakerContactConnection = {
  __typename?: 'MakerContactConnection';
  /** A list of edges. */
  edges: Array<MakerContactEdge>;
  /** A list of nodes. */
  nodes: Array<MakerContact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MakerContactEdge = {
  __typename?: 'MakerContactEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MakerContact>;
};

export type MakerDocument = {
  __typename?: 'MakerDocument';
  createdAt: Scalars['ISO8601DateTime'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  documentType: Scalars['String'];
  documentUrl?: Maybe<Scalars['String']>;
  editUrl: Scalars['Url'];
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  importKey?: Maybe<Scalars['String']>;
  maker: Maker;
  updatedAt: Scalars['ISO8601DateTime'];
};


export type MakerDocumentDocumentUrlArgs = {
  download: Scalars['Boolean'];
};

/** The connection type for MakerDocument. */
export type MakerDocumentConnection = {
  __typename?: 'MakerDocumentConnection';
  /** A list of edges. */
  edges: Array<MakerDocumentEdge>;
  /** A list of nodes. */
  nodes: Array<MakerDocument>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MakerDocumentEdge = {
  __typename?: 'MakerDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MakerDocument>;
};

/** An edge in a connection. */
export type MakerEdge = {
  __typename?: 'MakerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Maker>;
};

export type MakerInput = {
  id: Scalars['ID'];
  impactReportImage?: InputMaybe<ImpactReportImageInput>;
  products?: InputMaybe<Array<ProductInput>>;
};

export type MakerLegalAgreement = {
  __typename?: 'MakerLegalAgreement';
  content: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  status: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type MakerMakerAttribute = {
  __typename?: 'MakerMakerAttribute';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  makerAttributeId: Scalars['ID'];
  response?: Maybe<Scalars['Boolean']>;
  responseText?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for MakerMakerAttribute. */
export type MakerMakerAttributeConnection = {
  __typename?: 'MakerMakerAttributeConnection';
  /** A list of edges. */
  edges: Array<MakerMakerAttributeEdge>;
  /** A list of nodes. */
  nodes: Array<MakerMakerAttribute>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MakerMakerAttributeEdge = {
  __typename?: 'MakerMakerAttributeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MakerMakerAttribute>;
};

export type MakerMakerAttributeInput = {
  id?: InputMaybe<Scalars['ID']>;
  makerAttributeId: Scalars['ID'];
  response?: InputMaybe<Scalars['String']>;
  responseText?: InputMaybe<Scalars['String']>;
};

export type MakerMakerQuestion = {
  __typename?: 'MakerMakerQuestion';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  makerQuestionId: Scalars['ID'];
  response?: Maybe<Scalars['Boolean']>;
  responseText?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for MakerMakerQuestion. */
export type MakerMakerQuestionConnection = {
  __typename?: 'MakerMakerQuestionConnection';
  /** A list of edges. */
  edges: Array<MakerMakerQuestionEdge>;
  /** A list of nodes. */
  nodes: Array<MakerMakerQuestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MakerMakerQuestionEdge = {
  __typename?: 'MakerMakerQuestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MakerMakerQuestion>;
};

export type MakerMakerQuestionInput = {
  id?: InputMaybe<Scalars['ID']>;
  makerQuestionId: Scalars['ID'];
  response?: InputMaybe<Scalars['String']>;
  responseText?: InputMaybe<Scalars['String']>;
};

export type MakerMarketingImage = {
  __typename?: 'MakerMarketingImage';
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  editUrl: Scalars['Url'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  imgixUrl: Scalars['String'];
  includeInImpactReport: Scalars['Boolean'];
  makerId: Maker;
  resourceUrl: Scalars['Url'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for MakerMarketingImage. */
export type MakerMarketingImageConnection = {
  __typename?: 'MakerMarketingImageConnection';
  /** A list of edges. */
  edges: Array<MakerMarketingImageEdge>;
  /** A list of nodes. */
  nodes: Array<MakerMarketingImage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MakerMarketingImageEdge = {
  __typename?: 'MakerMarketingImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MakerMarketingImage>;
};

export type MakerMaterial = {
  __typename?: 'MakerMaterial';
  createdAt: Scalars['ISO8601DateTime'];
  editUrl: Scalars['Url'];
  id: Scalars['ID'];
  maker: Maker;
  material: Material;
  materialSubcategories: MaterialSubcategoryConnection;
  updatedAt: Scalars['ISO8601DateTime'];
};


export type MakerMaterialMaterialSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for MakerMaterial. */
export type MakerMaterialConnection = {
  __typename?: 'MakerMaterialConnection';
  /** A list of edges. */
  edges: Array<MakerMaterialEdge>;
  /** A list of nodes. */
  nodes: Array<MakerMaterial>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MakerMaterialEdge = {
  __typename?: 'MakerMaterialEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MakerMaterial>;
};

export type MakerNda = {
  __typename?: 'MakerNda';
  createdAt: Scalars['ISO8601DateTime'];
  dateOfSignature: Scalars['ISO8601Date'];
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  /** mou or nda */
  documentType: Scalars['String'];
  documentUrl?: Maybe<Scalars['String']>;
  editUrl: Scalars['Url'];
  expirationDate?: Maybe<Scalars['ISO8601Date']>;
  id: Scalars['ID'];
  maker: Maker;
  renewalNotificationSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  signedByName: Scalars['String'];
  signedByPosition: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};


export type MakerNdaDocumentUrlArgs = {
  download: Scalars['Boolean'];
};

/** The connection type for MakerNda. */
export type MakerNdaConnection = {
  __typename?: 'MakerNdaConnection';
  /** A list of edges. */
  edges: Array<MakerNdaEdge>;
  /** A list of nodes. */
  nodes: Array<MakerNda>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MakerNdaEdge = {
  __typename?: 'MakerNdaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MakerNda>;
};

export type MakerOrder = {
  __typename?: 'MakerOrder';
  accepted: Scalars['Boolean'];
  activeTaskCount?: Maybe<Scalars['Int']>;
  addressesUrl: Scalars['String'];
  barcodeResponsibility?: Maybe<Scalars['Int']>;
  billingConsigneeAddress?: Maybe<Address>;
  billingConsigneeAddressOptions: Array<Address>;
  brandTagResponsibility?: Maybe<Scalars['Int']>;
  client: Client;
  clientInfoVisibleToMaker: Scalars['Boolean'];
  clientOrder: ClientOrder;
  clientOrderId: Scalars['ID'];
  contactOptions: Array<Contact>;
  contacts: Array<Contact>;
  countriesOfOrigin?: Maybe<Array<Country>>;
  createdAt: Scalars['ISO8601DateTime'];
  customsStatusOptions: Array<SelectOption>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  editUrl: Scalars['String'];
  exFactoryDate?: Maybe<Scalars['ISO8601Date']>;
  exportShippingPortOptions: Array<ShippingPort>;
  finalMileDeliveryOptions: Array<SelectOption>;
  humanId: Scalars['String'];
  humanStatus: Scalars['String'];
  id: Scalars['ID'];
  importShippingPortOptions: Array<ShippingPort>;
  inHandsOn?: Maybe<Scalars['ISO8601Date']>;
  incoterm?: Maybe<Incoterm>;
  incotermId?: Maybe<Scalars['ID']>;
  incotermOptions: Array<Incoterm>;
  incotermsUrl: Scalars['Url'];
  issuedTo?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  mailCarrier?: Maybe<MailCarrier>;
  mailCarrierId?: Maybe<Scalars['ID']>;
  mailCarrierOptions: Array<MailCarrier>;
  maker: Maker;
  makerId: Scalars['ID'];
  makerLegalAgreementId?: Maybe<Scalars['ID']>;
  makerLegalAgreementOptions: Array<MakerLegalAgreement>;
  makerLegalAgreementsUrl: Scalars['Url'];
  makerShowUrl: Scalars['String'];
  moCutDate?: Maybe<Scalars['ISO8601Date']>;
  mostRecentEmailSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  newTnaUrl: Scalars['String'];
  packingAndShippingNotes?: Maybe<Scalars['String']>;
  parcelCarrierOptions: Array<ParcelCarrier>;
  paymentTerms?: Maybe<Scalars['String']>;
  productCount?: Maybe<Scalars['Int']>;
  productionNotes?: Maybe<Scalars['String']>;
  productionStatus?: Maybe<Array<Scalars['String']>>;
  productionStatusReadable?: Maybe<Scalars['String']>;
  sampleOrders?: Maybe<Array<SampleOrder>>;
  shared: Scalars['Boolean'];
  shipment?: Maybe<Shipment>;
  shipmentStatus: Scalars['String'];
  shipmentStatusOptions: Array<SelectOption>;
  shippingModeOptions: Array<SelectOption>;
  showUrl: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  statusOptions: Array<SelectOption>;
  timeAndAction?: Maybe<TimeAndAction>;
  totalCost?: Maybe<Scalars['Float']>;
  totalUnits?: Maybe<Scalars['Int']>;
  trackingInfo?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  vesselStatusOptions: Array<SelectOption>;
};

/** The connection type for MakerOrder. */
export type MakerOrderConnection = {
  __typename?: 'MakerOrderConnection';
  /** A list of edges. */
  edges: Array<MakerOrderEdge>;
  /** A list of nodes. */
  nodes: Array<MakerOrder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MakerOrderEdge = {
  __typename?: 'MakerOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MakerOrder>;
};

export type MakerOrderInput = {
  id: Scalars['ID'];
  makerOrderNotes?: InputMaybe<Array<MakerOrderNoteInput>>;
};

export type MakerOrderNoteInput = {
  note: Scalars['String'];
};

export type MakerOrderSearchFilterOptions = {
  __typename?: 'MakerOrderSearchFilterOptions';
  clients: Array<Client>;
  makers: Array<Maker>;
  statuses: Array<Scalars['String']>;
};

export type MakerProductCategory = {
  __typename?: 'MakerProductCategory';
  createdAt: Scalars['ISO8601DateTime'];
  editUrl: Scalars['Url'];
  id: Scalars['ID'];
  maker: Maker;
  productCategory: ProductCategory;
  productSubcategories: ProductSubcategoryConnection;
  /** @deprecated prefer productSubcategories */
  subcategories: Array<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};


export type MakerProductCategoryProductSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for MakerProductCategory. */
export type MakerProductCategoryConnection = {
  __typename?: 'MakerProductCategoryConnection';
  /** A list of edges. */
  edges: Array<MakerProductCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<MakerProductCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MakerProductCategoryEdge = {
  __typename?: 'MakerProductCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MakerProductCategory>;
};

export type MakerQuestion = {
  __typename?: 'MakerQuestion';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  question: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for MakerQuestion. */
export type MakerQuestionConnection = {
  __typename?: 'MakerQuestionConnection';
  /** A list of edges. */
  edges: Array<MakerQuestionEdge>;
  /** A list of nodes. */
  nodes: Array<MakerQuestion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MakerQuestionEdge = {
  __typename?: 'MakerQuestionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MakerQuestion>;
};

export type MakerScore = {
  __typename?: 'MakerScore';
  amenitiesAndSocialServices: Scalars['Int'];
  audits: Scalars['Int'];
  bCorp: Scalars['Int'];
  certifications: Scalars['Int'];
  certificationsAndAudits: Scalars['Int'];
  communications?: Maybe<Scalars['Int']>;
  compensationPolicy: Scalars['Int'];
  coreScore: Scalars['Float'];
  coreScorePercentile?: Maybe<Scalars['Float']>;
  correspondence?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  designatedStaff: Scalars['Int'];
  employeePolicies: Scalars['Int'];
  environmentalFacilities: Scalars['Int'];
  environmentalPoliciesAndInitiatives: Scalars['Int'];
  environmentalPolicy: Scalars['Int'];
  environmentallyFriendly: Scalars['Int'];
  fairLaborPractices: Scalars['Int'];
  fairtrade: Scalars['Int'];
  fireAndSafetyPolicy: Scalars['Int'];
  generalServices: Scalars['Int'];
  handbook: Scalars['Int'];
  harassmentPolicy: Scalars['Int'];
  hazardousChemicalRecords: Scalars['Int'];
  healthcare: Scalars['Int'];
  id: Scalars['ID'];
  inclusiveOwnership: Scalars['Int'];
  leavePolicy: Scalars['Int'];
  localCommunityServices: Scalars['Int'];
  makerCommunication?: Maybe<Scalars['Int']>;
  maternityLeave: Scalars['Int'];
  onboardingParticipation: Scalars['Int'];
  operationalPolicies: Scalars['Int'];
  overallScore: Scalars['Float'];
  overallScorePercentile?: Maybe<Scalars['Float']>;
  overallValueAlignment: Scalars['Int'];
  performanceScore?: Maybe<Scalars['Float']>;
  performanceScorePercentile?: Maybe<Scalars['Float']>;
  platformUse?: Maybe<Scalars['Int']>;
  ppe: Scalars['Int'];
  productionCost?: Maybe<Scalars['Int']>;
  productionExperience?: Maybe<Scalars['Int']>;
  productionQuality?: Maybe<Scalars['Int']>;
  productionTiming?: Maybe<Scalars['Int']>;
  qualityControlPolicy: Scalars['Int'];
  recycling: Scalars['Int'];
  reductionTargets: Scalars['Int'];
  riskAssessment: Scalars['Int'];
  samplingCost?: Maybe<Scalars['Int']>;
  samplingExperience?: Maybe<Scalars['Int']>;
  samplingQuality?: Maybe<Scalars['Int']>;
  samplingTiming?: Maybe<Scalars['Int']>;
  showBreakdown: Scalars['Boolean'];
  socialServices: Scalars['Int'];
  specialSocialPrograms: Scalars['Int'];
  sustainabilityFramework: Scalars['Int'];
  sustainableMaterials: Scalars['Int'];
  trackingAndReporting: Scalars['Int'];
  training: Scalars['Int'];
  trainingParticipation: Scalars['Int'];
  ttmAgreements: Scalars['Int'];
  unionGroup: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
  vettingSurveyCurrency: Scalars['Int'];
  womenOwned: Scalars['Int'];
};

export type MakerSearchFilterOptions = {
  __typename?: 'MakerSearchFilterOptions';
  capabilities: Array<Scalars['String']>;
  certifications: CertificationConnection;
  costRangeEstimates: Array<Scalars['String']>;
  environments: Array<Scalars['String']>;
  makerAttributes: Array<MakerAttribute>;
  materials: Array<Material>;
  productCategories: Array<ProductCategory>;
  productionCapacities: Array<Scalars['String']>;
  shippingCountries: Array<Country>;
  valueAlignments: Array<ValueAlignment>;
};


export type MakerSearchFilterOptionsCertificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type MakerShippingPort = {
  __typename?: 'MakerShippingPort';
  createdAt: Scalars['ISO8601DateTime'];
  default: Scalars['Boolean'];
  editUrl: Scalars['Url'];
  id: Scalars['ID'];
  maker: Maker;
  shippingPort: ShippingPort;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for MakerShippingPort. */
export type MakerShippingPortConnection = {
  __typename?: 'MakerShippingPortConnection';
  /** A list of edges. */
  edges: Array<MakerShippingPortEdge>;
  /** A list of nodes. */
  nodes: Array<MakerShippingPort>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MakerShippingPortEdge = {
  __typename?: 'MakerShippingPortEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MakerShippingPort>;
};

export type MakerSort = {
  attribute?: InputMaybe<MakerSortField>;
  order?: InputMaybe<SortOrder>;
};

export enum MakerSortField {
  /** Most recent maker order */
  MostRecentOrder = 'MOST_RECENT_ORDER',
  /** Name of maker */
  Name = 'NAME'
}

export enum MakerStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED',
  Draft = 'DRAFT'
}

export type MakerVettingSurvey = {
  __typename?: 'MakerVettingSurvey';
  approvedAt?: Maybe<Scalars['ISO8601Date']>;
  approvedBy?: Maybe<User>;
  completedAt?: Maybe<Scalars['ISO8601Date']>;
  completedBy?: Maybe<Contact>;
  createdAt: Scalars['ISO8601DateTime'];
  discardedAt?: Maybe<Scalars['ISO8601Date']>;
  editUrl: Scalars['Url'];
  id: Scalars['ID'];
  importKey?: Maybe<Scalars['String']>;
  maker: Maker;
  renewalNotificationSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  surveys: Array<Attachment>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for MakerVettingSurvey. */
export type MakerVettingSurveyConnection = {
  __typename?: 'MakerVettingSurveyConnection';
  /** A list of edges. */
  edges: Array<MakerVettingSurveyEdge>;
  /** A list of nodes. */
  nodes: Array<MakerVettingSurvey>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MakerVettingSurveyEdge = {
  __typename?: 'MakerVettingSurveyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MakerVettingSurvey>;
};

export type Material = {
  __typename?: 'Material';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  materialSubcategories: MaterialSubcategoryConnection;
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};


export type MaterialMaterialSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Material. */
export type MaterialConnection = {
  __typename?: 'MaterialConnection';
  /** A list of edges. */
  edges: Array<MaterialEdge>;
  /** A list of nodes. */
  nodes: Array<Material>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MaterialEdge = {
  __typename?: 'MaterialEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Material>;
};

export type MaterialSubcategory = {
  __typename?: 'MaterialSubcategory';
  createdAt: Scalars['ISO8601DateTime'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  material: Material;
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for MaterialSubcategory. */
export type MaterialSubcategoryConnection = {
  __typename?: 'MaterialSubcategoryConnection';
  /** A list of edges. */
  edges: Array<MaterialSubcategoryEdge>;
  /** A list of nodes. */
  nodes: Array<MaterialSubcategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type MaterialSubcategoryEdge = {
  __typename?: 'MaterialSubcategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<MaterialSubcategory>;
};

export enum ModeOfTransit {
  Air = 'AIR',
  Land = 'LAND',
  Sea = 'SEA'
}

export type Mutation = {
  __typename?: 'Mutation';
  addSkusToClientOrder: AddSkusToClientOrderPayload;
  createMakerOrder: CreateMakerOrderPayload;
  impactReport: ImpactReportPayload;
  updateActiveClientOrder: UpdateActiveClientOrderPayload;
  updateClientOrder: UpdateClientOrderPayload;
  updateClientOrderStatus: UpdateClientOrderStatusPayload;
  updateMaker: UpdateMakerPayload;
  updateMakerOrder: UpdateMakerOrderPayload;
  updateMakerOrderCogs: UpdateMakerOrderCogsPayload;
  updateMakerStatus: UpdateMakerStatusPayload;
  updateProduct: UpdateProductPayload;
  updateProductGroup: UpdateProductGroupPayload;
  updateProductStatus: UpdateProductStatusPayload;
  updateTimeAndAction: UpdateTimeAndActionPayload;
  updateTimeAndActionCalendarTask: UpdateTimeAndActionCalendarTaskPayload;
  updateTimeAndActionCalendarTemplate: UpdateTimeAndActionCalendarTemplatePayload;
};


export type MutationAddSkusToClientOrderArgs = {
  input: AddSkusToClientOrderInput;
};


export type MutationCreateMakerOrderArgs = {
  input: CreateMakerOrderInput;
};


export type MutationImpactReportArgs = {
  input: ImpactReportInput;
};


export type MutationUpdateActiveClientOrderArgs = {
  input: UpdateActiveClientOrderInput;
};


export type MutationUpdateClientOrderArgs = {
  input: UpdateClientOrderInput;
};


export type MutationUpdateClientOrderStatusArgs = {
  input: UpdateClientOrderStatusInput;
};


export type MutationUpdateMakerArgs = {
  input: UpdateMakerInput;
};


export type MutationUpdateMakerOrderArgs = {
  input: UpdateMakerOrderInput;
};


export type MutationUpdateMakerOrderCogsArgs = {
  input: UpdateMakerOrderCogsInput;
};


export type MutationUpdateMakerStatusArgs = {
  input: UpdateMakerStatusInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationUpdateProductGroupArgs = {
  input: UpdateProductGroupInput;
};


export type MutationUpdateProductStatusArgs = {
  input: UpdateProductStatusInput;
};


export type MutationUpdateTimeAndActionArgs = {
  input: UpdateTimeAndActionInput;
};


export type MutationUpdateTimeAndActionCalendarTaskArgs = {
  input: UpdateTimeAndActionCalendarTaskInput;
};


export type MutationUpdateTimeAndActionCalendarTemplateArgs = {
  input: UpdateTimeAndActionCalendarTemplateInput;
};

export type NpaVariant = {
  __typename?: 'NpaVariant';
  editUrl: Scalars['Url'];
  id: Scalars['ID'];
  name: Scalars['String'];
  npaVariantOptions: Array<NpaVariantOption>;
  npaVariantTemplateId?: Maybe<Scalars['ID']>;
};

export type NpaVariantInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  npaVariantOptions?: InputMaybe<Array<NpaVariantOptionInput>>;
  npaVariantTemplateId?: InputMaybe<Scalars['ID']>;
  remove?: InputMaybe<Scalars['Boolean']>;
};

export type NpaVariantOption = {
  __typename?: 'NpaVariantOption';
  id: Scalars['ID'];
  makerName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  npaVariant: NpaVariant;
  npaVariantId: Scalars['ID'];
  position?: Maybe<Scalars['Int']>;
};

export type NpaVariantOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  makerName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  remove?: InputMaybe<Scalars['Boolean']>;
};

export type NpaVariantTemplate = {
  __typename?: 'NpaVariantTemplate';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  npaVariantTemplateOptions: Array<NpaVariantTemplateOption>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type NpaVariantTemplateOption = {
  __typename?: 'NpaVariantTemplateOption';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type OrderChange = {
  __typename?: 'OrderChange';
  createdAt: Scalars['ISO8601DateTime'];
  description: Scalars['String'];
  fullDescription?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  responsible?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

/** The connection type for OrderChange. */
export type OrderChangeConnection = {
  __typename?: 'OrderChangeConnection';
  /** A list of edges. */
  edges: Array<OrderChangeEdge>;
  /** A list of nodes. */
  nodes: Array<OrderChange>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type OrderChangeEdge = {
  __typename?: 'OrderChangeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<OrderChange>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type ParcelCarrier = {
  __typename?: 'ParcelCarrier';
  archived: Scalars['Boolean'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ParcelCarrier. */
export type ParcelCarrierConnection = {
  __typename?: 'ParcelCarrierConnection';
  /** A list of edges. */
  edges: Array<ParcelCarrierEdge>;
  /** A list of nodes. */
  nodes: Array<ParcelCarrier>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ParcelCarrierEdge = {
  __typename?: 'ParcelCarrierEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ParcelCarrier>;
};

export type Product = {
  __typename?: 'Product';
  availableUntil?: Maybe<Scalars['ISO8601Date']>;
  bulbEnergySavedHours?: Maybe<Scalars['Float']>;
  carbonOffsetAsKmOfDriving?: Maybe<Scalars['Float']>;
  carbonOffsetAsPhonesCharged?: Maybe<Scalars['Float']>;
  carbonOffsetAsTransatlanticFlights?: Maybe<Scalars['Float']>;
  carbonOffsetKg?: Maybe<Scalars['Float']>;
  carbonOffsetMetricsEnabled: Scalars['Boolean'];
  certifications: Array<Certification>;
  clientOrders: ClientOrderConnection;
  cogsExpiresOn?: Maybe<Scalars['ISO8601Date']>;
  countryOfOrigin?: Maybe<Country>;
  countryOptions: Array<Country>;
  createdAt: Scalars['ISO8601DateTime'];
  customizations: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dimension?: Maybe<Dimension>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  drinkingWaterSavedDays?: Maybe<Scalars['Float']>;
  drivingEmissionsAvoidedKm?: Maybe<Scalars['Float']>;
  duplicateUrl: Scalars['Url'];
  editCogsVariantCellsUrl: Scalars['Url'];
  editUrl: Scalars['Url'];
  emissionsAvoidedKg?: Maybe<Scalars['Float']>;
  energyConservedKwh?: Maybe<Scalars['Float']>;
  environmentalImpactMetricsEnabled: Scalars['Boolean'];
  environments: Array<Scalars['String']>;
  environmentsOptions: Array<Scalars['String']>;
  equivalencesEnabled: Scalars['Boolean'];
  fabricType?: Maybe<Scalars['String']>;
  fabricTypeOptions: Array<Scalars['String']>;
  fairWagePerHour?: Maybe<Scalars['Float']>;
  htsCode?: Maybe<Scalars['String']>;
  htsCodeOptions: Array<Scalars['String']>;
  humanId: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Image>;
  imageWithFallback: Image;
  images: Array<Image>;
  impactReportImage?: Maybe<ImpactReportImage>;
  infoImages: Array<Image>;
  internalNotes?: Maybe<Scalars['String']>;
  isArchived: Scalars['Boolean'];
  landSavedFromPesticidesM2?: Maybe<Scalars['Float']>;
  maker: Maker;
  makerAttributes: Array<MakerAttribute>;
  makerCapabilities: Array<Scalars['String']>;
  makerCapabilitiesOptions: Array<Scalars['String']>;
  /** @deprecated use certifications instead */
  makerCertificationTypes: Array<Scalars['String']>;
  makerCountry?: Maybe<Country>;
  makerName?: Maybe<Scalars['String']>;
  makerTypeOptions: Array<Scalars['String']>;
  makerTypes: Array<Scalars['String']>;
  marginRounding: Scalars['String'];
  marginValue: Scalars['Float'];
  materialSubcategories: MaterialSubcategoryConnection;
  materials: MaterialConnection;
  maxCapacity?: Maybe<Scalars['Int']>;
  minimumOrderQuantity?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  nameAliases: Array<ProductNameAlias>;
  newNpaVariantUrl: Scalars['Url'];
  newProductCategoryUrl: Scalars['Url'];
  newProductMaterialUrl: Scalars['Url'];
  newProductNameAliasUrl: Scalars['Url'];
  newProductSkuAliasUrl: Scalars['Url'];
  newProductTestUrl: Scalars['Url'];
  npaVariantTemplateOptions: Array<NpaVariantTemplate>;
  npaVariants: Array<NpaVariant>;
  pesticidesAvoidedG?: Maybe<Scalars['Float']>;
  previousBuyers: Array<Scalars['String']>;
  price?: Maybe<ProductPrice>;
  /** List of users that is elligible to be set as a pricing owner */
  pricingOwnerOptions: UserConnection;
  pricingOwners: UserConnection;
  productAttributeOptions: Array<ProductAttribute>;
  productAttributes: Array<ProductAttribute>;
  productCategories: Array<ProductCategory>;
  productGroup: ProductGroup;
  productMaterials: ProductMaterialConnection;
  productProductCategories: ProductProductCategoryConnection;
  productSubcategories: ProductSubcategoryConnection;
  productTests: ProductTestConnection;
  productionMethod?: Maybe<Scalars['String']>;
  productionMethodOptions: Array<Scalars['String']>;
  recycledWaterBottles?: Maybe<Scalars['Float']>;
  resourceUrl: Scalars['Url'];
  selectedMakerAttributes: Array<MakerAttribute>;
  shipsFromCountry?: Maybe<Country>;
  showUrl: Scalars['String'];
  skuAliases: Array<ProductSkuAlias>;
  skus: Array<Sku>;
  socialImpactMetricsEnabled: Scalars['Boolean'];
  status: ProductStatus;
  styleNumber?: Maybe<Scalars['String']>;
  /** @deprecated should be replaced with ProductSubcategory instead of string array */
  subcategories: Array<Scalars['String']>;
  techPack?: Maybe<Attachment>;
  updatedAt: Scalars['ISO8601DateTime'];
  valueAlignments: Array<ValueAlignment>;
  valueAlignmentsOptions: Array<ValueAlignment>;
  variantName?: Maybe<Scalars['String']>;
  variants: Array<Variant>;
  wasteDivertedG?: Maybe<Scalars['Float']>;
  waterSavedLiters?: Maybe<Scalars['Float']>;
};


export type ProductClientOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProductImpactReportImageArgs = {
  impactReportId: Scalars['ID'];
};


export type ProductMaterialSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProductMaterialsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProductPricingOwnerOptionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProductPricingOwnersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProductProductMaterialsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProductProductProductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProductProductSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ProductProductTestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ProductAttribute = {
  __typename?: 'ProductAttribute';
  createdAt: Scalars['ISO8601DateTime'];
  icon: Attachment;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ProductAttribute. */
export type ProductAttributeConnection = {
  __typename?: 'ProductAttributeConnection';
  /** A list of edges. */
  edges: Array<ProductAttributeEdge>;
  /** A list of nodes. */
  nodes: Array<ProductAttribute>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProductAttributeEdge = {
  __typename?: 'ProductAttributeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductAttribute>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  productSubcategories: ProductSubcategoryConnection;
  /** @deprecated productSubcategories is preferred to this, which is a list of strings */
  subcategories: Array<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};


export type ProductCategoryProductSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for Product. */
export type ProductConnection = {
  __typename?: 'ProductConnection';
  /** A list of edges. */
  edges: Array<ProductEdge>;
  /** A list of nodes. */
  nodes: Array<Product>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProductEdge = {
  __typename?: 'ProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Product>;
};

export type ProductGroup = {
  __typename?: 'ProductGroup';
  addons: Array<Addon>;
  cogsColumns: Array<CogsColumn>;
  countries: CountryConnection;
  createdAt: Scalars['ISO8601DateTime'];
  customizationCategories: Array<Scalars['String']>;
  customizations: Array<Customization>;
  description?: Maybe<Scalars['String']>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  editUrl: Scalars['Url'];
  environments: Array<Scalars['String']>;
  fabricTypeOptions: Array<Scalars['String']>;
  htsCode?: Maybe<Scalars['String']>;
  htsCodeOptions: Array<Scalars['String']>;
  humanId: Scalars['String'];
  id: Scalars['ID'];
  images: Array<Image>;
  maker: Maker;
  makerAttributes: Array<MakerAttribute>;
  /** @deprecated Should migrate this to use certifications */
  makerCertificationTypes: Array<Scalars['String']>;
  makerCountries: Array<Country>;
  makerName?: Maybe<Scalars['String']>;
  minimumCogsColumnQuantity?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  nameAliases: Array<ProductGroupNameAlias>;
  newProductGroupNameAliasUrl: Scalars['Url'];
  newProductGroupStyleNumberAliasUrl: Scalars['Url'];
  newProductUrl: Scalars['Url'];
  previousBuyers: Array<Scalars['String']>;
  productCategories: Array<ProductCategory>;
  productionMethods: Array<Scalars['String']>;
  products: Array<Product>;
  screenPrintAddonEnabled: Scalars['Boolean'];
  showUrl: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  sourceId?: Maybe<Scalars['String']>;
  status: ProductGroupStatus;
  styleNumber?: Maybe<Scalars['String']>;
  styleNumberAliases: Array<ProductGroupStyleNumberAlias>;
  techPack?: Maybe<Attachment>;
  updatedAt: Scalars['ISO8601DateTime'];
  valueAlignments: Array<ValueAlignment>;
};


export type ProductGroupCountriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ProductGroupNameAlias = {
  __typename?: 'ProductGroupNameAlias';
  createdAt: Scalars['ISO8601DateTime'];
  editUrl: Scalars['Url'];
  id: Scalars['ID'];
  name: Scalars['String'];
  product: Product;
  resourceUrl: Scalars['Url'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum ProductGroupStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type ProductGroupStyleNumberAlias = {
  __typename?: 'ProductGroupStyleNumberAlias';
  createdAt: Scalars['ISO8601DateTime'];
  editUrl: Scalars['Url'];
  id: Scalars['ID'];
  resourceUrl: Scalars['Url'];
  styleNumber: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ProductInput = {
  id: Scalars['ID'];
  impactReportImage?: InputMaybe<ImpactReportImageInput>;
};

export type ProductMaterial = {
  __typename?: 'ProductMaterial';
  createdAt: Scalars['ISO8601DateTime'];
  editUrl: Scalars['Url'];
  id: Scalars['ID'];
  material: Material;
  materialSubcategories: MaterialSubcategoryConnection;
  product: Product;
  updatedAt: Scalars['ISO8601DateTime'];
};


export type ProductMaterialMaterialSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for ProductMaterial. */
export type ProductMaterialConnection = {
  __typename?: 'ProductMaterialConnection';
  /** A list of edges. */
  edges: Array<ProductMaterialEdge>;
  /** A list of nodes. */
  nodes: Array<ProductMaterial>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProductMaterialEdge = {
  __typename?: 'ProductMaterialEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductMaterial>;
};

export type ProductNameAlias = {
  __typename?: 'ProductNameAlias';
  createdAt: Scalars['ISO8601DateTime'];
  editUrl: Scalars['Url'];
  id: Scalars['ID'];
  name: Scalars['String'];
  product: Product;
  resourceUrl: Scalars['Url'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  amount: Scalars['Int'];
  quantity: Scalars['Int'];
};

export type ProductProductCategory = {
  __typename?: 'ProductProductCategory';
  createdAt: Scalars['ISO8601DateTime'];
  editUrl: Scalars['Url'];
  id: Scalars['ID'];
  product: Product;
  productCategory: ProductCategory;
  productSubcategories: ProductSubcategoryConnection;
  updatedAt: Scalars['ISO8601DateTime'];
};


export type ProductProductCategoryProductSubcategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for ProductProductCategory. */
export type ProductProductCategoryConnection = {
  __typename?: 'ProductProductCategoryConnection';
  /** A list of edges. */
  edges: Array<ProductProductCategoryEdge>;
  /** A list of nodes. */
  nodes: Array<ProductProductCategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProductProductCategoryEdge = {
  __typename?: 'ProductProductCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductProductCategory>;
};

export type ProductSearchFilterOptions = {
  __typename?: 'ProductSearchFilterOptions';
  capabilities: Array<Scalars['String']>;
  certifications: CertificationConnection;
  countries: Array<Country>;
  customizations: Array<Scalars['String']>;
  environments: Array<Scalars['String']>;
  makerAttributes: Array<MakerAttribute>;
  makerCapabilities: Array<Scalars['String']>;
  makerTypes: Array<Scalars['String']>;
  makers: Array<Maker>;
  materials: Array<Material>;
  maxPrice: Scalars['Int'];
  maxUnits: Scalars['Int'];
  minPrice: Scalars['Int'];
  minUnits: Scalars['Int'];
  previousBuyers: Array<Scalars['String']>;
  productAttributes: Array<ProductAttribute>;
  productCategories: Array<ProductCategory>;
  productionCapacities: Array<Scalars['String']>;
  valueAlignments: Array<ValueAlignment>;
};


export type ProductSearchFilterOptionsCertificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type ProductSkuAlias = {
  __typename?: 'ProductSkuAlias';
  createdAt: Scalars['ISO8601DateTime'];
  editUrl: Scalars['Url'];
  id: Scalars['ID'];
  product: Product;
  resourceUrl: Scalars['Url'];
  sku: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ProductSort = {
  attribute?: InputMaybe<ProductSortField>;
  order?: InputMaybe<SortOrder>;
};

export enum ProductSortField {
  /** Minimum Order Quantity - Total Units */
  MinimumOrderQuantity = 'MINIMUM_ORDER_QUANTITY',
  /** Name of product */
  Name = 'NAME',
  /** Price of the product */
  Price = 'PRICE'
}

export enum ProductStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export type ProductSubcategory = {
  __typename?: 'ProductSubcategory';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  productCategory: ProductCategory;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ProductSubcategory. */
export type ProductSubcategoryConnection = {
  __typename?: 'ProductSubcategoryConnection';
  /** A list of edges. */
  edges: Array<ProductSubcategoryEdge>;
  /** A list of nodes. */
  nodes: Array<ProductSubcategory>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProductSubcategoryEdge = {
  __typename?: 'ProductSubcategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductSubcategory>;
};

export type ProductTest = {
  __typename?: 'ProductTest';
  createdAt: Scalars['ISO8601DateTime'];
  dateOfCompletion?: Maybe<Scalars['ISO8601Date']>;
  description?: Maybe<Scalars['String']>;
  document?: Maybe<Attachment>;
  editUrl: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  product: Product;
  result: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ProductTest. */
export type ProductTestConnection = {
  __typename?: 'ProductTestConnection';
  /** A list of edges. */
  edges: Array<ProductTestEdge>;
  /** A list of nodes. */
  nodes: Array<ProductTest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ProductTestEdge = {
  __typename?: 'ProductTestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductTest>;
};

export type Query = {
  __typename?: 'Query';
  /** Active client order */
  activeClientOrder?: Maybe<ActiveClientOrder>;
  activeMakerLegalAgreements: Array<MakerLegalAgreement>;
  clientOrder: ClientOrder;
  /** Client order search filter options */
  clientOrderSearchFilterOptions: ClientOrderSearchFilterOptions;
  /** Client order list */
  clientOrders: ClientOrderConnection;
  /** Client search */
  clients: ClientConnection;
  /** CurrentUser */
  currentUser?: Maybe<User>;
  impactReport: ImpactReport;
  /** Impact report search filter options */
  impactReportSearchFilterOptions: ImpactReportSearchFilterOptions;
  /** Impact report list */
  impactReports: ImpactReportConnection;
  maker: Maker;
  makerOrder: MakerOrder;
  /** Maker order history event list */
  makerOrderHistory: OrderChangeConnection;
  /** Maker order search filter options */
  makerOrderSearchFilterOptions: MakerOrderSearchFilterOptions;
  /** Maker order list */
  makerOrders: MakerOrderConnection;
  /** Maker search filter options */
  makerSearchFilterOptions: MakerSearchFilterOptions;
  /** Maker search */
  makers: MakerConnection;
  product: Product;
  productGroup: ProductGroup;
  /** Product search filter options */
  productSearchFilterOptions: ProductSearchFilterOptions;
  /** Product search */
  products: ProductConnection;
  /** Shipping Port list */
  shippingPorts: Array<ShippingPort>;
  timeAndAction: TimeAndAction;
  timeAndActionCalendarTemplate: TimeAndActionCalendarTemplate;
};


export type QueryClientOrderArgs = {
  id: Scalars['ID'];
};


export type QueryClientOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  bolPodDocsPresent?: InputMaybe<Scalars['Boolean']>;
  clientId?: InputMaybe<Scalars['ID']>;
  clientOrderStatus?: InputMaybe<Array<Scalars['String']>>;
  clients?: InputMaybe<Array<Scalars['ID']>>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  customsStatus?: InputMaybe<Array<Scalars['String']>>;
  designLead?: InputMaybe<Array<Scalars['String']>>;
  exFactoryDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  exFactoryDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  exportPort?: InputMaybe<Array<Scalars['String']>>;
  finalMileDelivery?: InputMaybe<Array<Scalars['String']>>;
  financialLead?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  impactLead?: InputMaybe<Array<Scalars['String']>>;
  importPort?: InputMaybe<Array<Scalars['String']>>;
  last?: InputMaybe<Scalars['Int']>;
  makers?: InputMaybe<Array<Scalars['ID']>>;
  moCutDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  moCutDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  operationsLead?: InputMaybe<Array<Scalars['String']>>;
  parcelCarrier?: InputMaybe<Array<Scalars['String']>>;
  productionLead?: InputMaybe<Array<Scalars['String']>>;
  productionStatus?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  salesLead?: InputMaybe<Array<Scalars['String']>>;
  shipmentStatus?: InputMaybe<Array<Scalars['String']>>;
  shippingDocsPresent?: InputMaybe<Scalars['Boolean']>;
  shippingMode?: InputMaybe<Array<Scalars['String']>>;
  sorts?: InputMaybe<Array<ClientOrderSort>>;
  tracker?: Scalars['String'];
  vesselStatus?: InputMaybe<Array<Scalars['String']>>;
  year?: InputMaybe<Scalars['String']>;
};


export type QueryClientsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  sorts?: InputMaybe<Array<ClientSort>>;
};


export type QueryImpactReportArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryImpactReportsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clients?: InputMaybe<Array<Scalars['ID']>>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  deliveryWindowAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  deliveryWindowBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  impactReportId?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  makers?: InputMaybe<Array<Scalars['ID']>>;
  query?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryMakerArgs = {
  slug: Scalars['String'];
};


export type QueryMakerOrderArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryMakerOrderHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  makerOrderId: Scalars['ID'];
};


export type QueryMakerOrdersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  clients?: InputMaybe<Array<Scalars['ID']>>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  exFactoryDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  exFactoryDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  inHandsAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  inHandsBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  last?: InputMaybe<Scalars['Int']>;
  makerId?: InputMaybe<Scalars['ID']>;
  makers?: InputMaybe<Array<Scalars['ID']>>;
  query?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  year?: InputMaybe<Scalars['String']>;
};


export type QueryMakersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  capabilities?: InputMaybe<Array<Scalars['String']>>;
  certifications?: InputMaybe<Array<Scalars['ID']>>;
  costRangeEstimates?: InputMaybe<Array<Scalars['String']>>;
  environments?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  makerAttributeIds?: InputMaybe<Array<Scalars['ID']>>;
  materialIds?: InputMaybe<Array<Scalars['ID']>>;
  materialSubcategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  productCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  productSubcategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  productionCapacities?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  shippingCountryIds?: InputMaybe<Array<Scalars['ID']>>;
  sorts?: InputMaybe<Array<MakerSort>>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryProductArgs = {
  id: Scalars['ID'];
};


export type QueryProductGroupArgs = {
  id: Scalars['ID'];
};


export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  certifications?: InputMaybe<Array<Scalars['ID']>>;
  countryIds?: InputMaybe<Array<Scalars['ID']>>;
  customizations?: InputMaybe<Array<Scalars['String']>>;
  environments?: InputMaybe<Array<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  makerAttributeIds?: InputMaybe<Array<Scalars['ID']>>;
  makerCapabilities?: InputMaybe<Array<Scalars['String']>>;
  makerIds?: InputMaybe<Array<Scalars['ID']>>;
  makerTypes?: InputMaybe<Array<Scalars['String']>>;
  materialIds?: InputMaybe<Array<Scalars['ID']>>;
  materialSubcategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  maxPrice?: InputMaybe<Scalars['Int']>;
  maxUnits?: InputMaybe<Scalars['Int']>;
  minPrice?: InputMaybe<Scalars['Int']>;
  minUnits?: InputMaybe<Scalars['Int']>;
  previousBuyers?: InputMaybe<Array<Scalars['String']>>;
  productAttributeIds?: InputMaybe<Array<Scalars['ID']>>;
  productCategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  productSubcategoryIds?: InputMaybe<Array<Scalars['ID']>>;
  query?: InputMaybe<Scalars['String']>;
  skus?: InputMaybe<Array<Scalars['String']>>;
  sort?: InputMaybe<ProductSort>;
  statuses?: InputMaybe<Array<Scalars['String']>>;
  styleNumbers?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryShippingPortsArgs = {
  locationType?: InputMaybe<ShippingPortLocation>;
  makerId?: InputMaybe<Scalars['ID']>;
};


export type QueryTimeAndActionArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryTimeAndActionCalendarTemplateArgs = {
  id?: InputMaybe<Scalars['ID']>;
};

export type Region = {
  __typename?: 'Region';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type SalesPresentation = {
  __typename?: 'SalesPresentation';
  createdAt: Scalars['ISO8601DateTime'];
  humanId: Scalars['String'];
  humanPdfStatus: Scalars['String'];
  id: Scalars['ID'];
  pdfStatus: Scalars['String'];
  showUrl: Scalars['String'];
};

/** The connection type for SalesPresentation. */
export type SalesPresentationConnection = {
  __typename?: 'SalesPresentationConnection';
  /** A list of edges. */
  edges: Array<SalesPresentationEdge>;
  /** A list of nodes. */
  nodes: Array<SalesPresentation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type SalesPresentationEdge = {
  __typename?: 'SalesPresentationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<SalesPresentation>;
};

export type SampleOrder = {
  __typename?: 'SampleOrder';
  createdAt: Scalars['ISO8601DateTime'];
  dispatchedOn?: Maybe<Scalars['ISO8601Date']>;
  estimatedToArriveOn?: Maybe<Scalars['ISO8601Date']>;
  humanId: Scalars['String'];
  id: Scalars['ID'];
  mailCarrier?: Maybe<Scalars['String']>;
  makerOrderId: Scalars['ID'];
  notes: Scalars['String'];
  sampleOrderSkus?: Maybe<Array<SampleOrderSku>>;
  sampleOrderType?: Maybe<SampleOrderType>;
  shippingAddress?: Maybe<Address>;
  shipsOn?: Maybe<Scalars['ISO8601Date']>;
  status: Scalars['String'];
  trackingNumber?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type SampleOrderSku = {
  __typename?: 'SampleOrderSku';
  id: Scalars['ID'];
  quantity: Scalars['Int'];
  sku: Sku;
  skuId: Scalars['ID'];
};

export type SampleOrderType = {
  __typename?: 'SampleOrderType';
  displayName: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SelectOption = {
  __typename?: 'SelectOption';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type Shipment = {
  __typename?: 'Shipment';
  arrivalShippingPort?: Maybe<ShippingPort>;
  arrivingPortAt?: Maybe<Scalars['ISO8601Date']>;
  customsStatus?: Maybe<Scalars['String']>;
  deliveredOn?: Maybe<Scalars['ISO8601Date']>;
  departingPortAt?: Maybe<Scalars['ISO8601Date']>;
  departureShippingPort?: Maybe<ShippingPort>;
  finalMileDelivery?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  newShipmentDocumentUrl: Scalars['Url'];
  parcelCarrier?: Maybe<ParcelCarrier>;
  shipmentDocuments: Array<ShipmentDocument>;
  shippingMode?: Maybe<Scalars['String']>;
  trackingNumbers?: Maybe<Scalars['String']>;
  vesselStatus?: Maybe<Scalars['String']>;
};

export type ShipmentDocument = {
  __typename?: 'ShipmentDocument';
  createdAt: Scalars['ISO8601DateTime'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  documentType: Scalars['String'];
  documentUrl?: Maybe<Scalars['String']>;
  editUrl: Scalars['Url'];
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  updatedAt: Scalars['ISO8601DateTime'];
};


export type ShipmentDocumentDocumentUrlArgs = {
  download: Scalars['Boolean'];
};

export type ShipmentInput = {
  arrivalShippingPort?: InputMaybe<ShippingPortInput>;
  arrivalShippingPortId?: InputMaybe<Scalars['String']>;
  arrivingPortAt?: InputMaybe<Scalars['String']>;
  customsStatus?: InputMaybe<Scalars['String']>;
  deliveredOn?: InputMaybe<Scalars['String']>;
  departingPortAt?: InputMaybe<Scalars['String']>;
  departureShippingPort?: InputMaybe<ShippingPortInput>;
  departureShippingPortId?: InputMaybe<Scalars['String']>;
  finalMileDelivery?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  parcelCarrierId?: InputMaybe<Scalars['String']>;
  shippingMode?: InputMaybe<Scalars['String']>;
  trackingNumbers?: InputMaybe<Scalars['String']>;
  vesselStatus?: InputMaybe<Scalars['String']>;
};

export type ShippingPort = {
  __typename?: 'ShippingPort';
  abbreviation?: Maybe<Scalars['String']>;
  country: Country;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  locationType: ShippingPortLocation;
  modeOfTransit: ModeOfTransit;
  /** Name of the port, e.g. El Dorado International Airport (BOG) */
  port: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

/** The connection type for ShippingPort. */
export type ShippingPortConnection = {
  __typename?: 'ShippingPortConnection';
  /** A list of edges. */
  edges: Array<ShippingPortEdge>;
  /** A list of nodes. */
  nodes: Array<ShippingPort>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type ShippingPortEdge = {
  __typename?: 'ShippingPortEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ShippingPort>;
};

export type ShippingPortInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export enum ShippingPortLocation {
  Export = 'EXPORT',
  Import = 'IMPORT'
}

export type Sku = {
  __typename?: 'Sku';
  createdAt: Scalars['ISO8601DateTime'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  humanId: Scalars['String'];
  id: Scalars['ID'];
  npaVariantOptions: Array<NpaVariantOption>;
  updatedAt: Scalars['ISO8601DateTime'];
  variant: Variant;
  /** Shows the variant name, and npa variants */
  variantDisplayName: Scalars['String'];
};

export type SkuQuantityInput = {
  margin?: InputMaybe<Scalars['Float']>;
  msrp?: InputMaybe<Scalars['Float']>;
  price?: InputMaybe<Scalars['Float']>;
  quantity: Scalars['Int'];
  skuId: Scalars['ID'];
};

export enum SortOrder {
  /** Ascending order */
  Asc = 'ASC',
  /** Descending order */
  Desc = 'DESC'
}

export type TechPackInput = {
  remove?: InputMaybe<Scalars['Boolean']>;
  signedId?: InputMaybe<Scalars['ID']>;
};

export type TimeAndAction = {
  __typename?: 'TimeAndAction';
  active: Scalars['Boolean'];
  calendar: TimeAndActionCalendar;
  clientOrder: ClientOrder;
  createdAt: Scalars['ISO8601DateTime'];
  description?: Maybe<Scalars['String']>;
  editUrl: Scalars['String'];
  humanId: Scalars['String'];
  id: Scalars['ID'];
  maker: Maker;
  ownerOptions: Array<User>;
  showUrl: Scalars['String'];
  taskStatusOptions: Array<TimeAndActionCalendarTaskStatusOption>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type TimeAndActionCalendar = {
  __typename?: 'TimeAndActionCalendar';
  calendarChanges: Array<TimeAndActionCalendarChange>;
  id: Scalars['ID'];
  name: Scalars['String'];
  tasks: TimeAndActionCalendarTaskConnection;
};


export type TimeAndActionCalendarTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type TimeAndActionCalendarChange = {
  __typename?: 'TimeAndActionCalendarChange';
  createdAt: Scalars['ISO8601DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  relatedDescription?: Maybe<Scalars['String']>;
  responsible?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type TimeAndActionCalendarChangeInput = {
  id?: InputMaybe<Scalars['ID']>;
  jobPosition?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type TimeAndActionCalendarInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  tasks: Array<TimeAndActionCalendarTaskInput>;
};

export type TimeAndActionCalendarTask = {
  __typename?: 'TimeAndActionCalendarTask';
  activeChangeRequest?: Maybe<TimeAndActionTaskChangeRequest>;
  actualStartDate?: Maybe<Scalars['ISO8601Date']>;
  changeRequests: Array<TimeAndActionTaskChangeRequest>;
  dateCompleted?: Maybe<Scalars['ISO8601Date']>;
  displayToMaker: Scalars['Boolean'];
  dueDate?: Maybe<Scalars['ISO8601Date']>;
  durationDays?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  owners: TimeAndActionCalendarTaskOwnerConnection;
  pastDue?: Maybe<Scalars['Boolean']>;
  position: Scalars['Int'];
  remindersOn: Scalars['Boolean'];
  remindersUrl: Scalars['String'];
  stage: Scalars['String'];
  stageHumanized: Scalars['String'];
  startDate?: Maybe<Scalars['ISO8601Date']>;
  status: Scalars['String'];
  taskChanges: Array<TimeAndActionCalendarChange>;
};


export type TimeAndActionCalendarTaskOwnersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for TimeAndActionCalendarTask. */
export type TimeAndActionCalendarTaskConnection = {
  __typename?: 'TimeAndActionCalendarTaskConnection';
  /** A list of edges. */
  edges: Array<TimeAndActionCalendarTaskEdge>;
  /** A list of nodes. */
  nodes: Array<TimeAndActionCalendarTask>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TimeAndActionCalendarTaskEdge = {
  __typename?: 'TimeAndActionCalendarTaskEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TimeAndActionCalendarTask>;
};

export type TimeAndActionCalendarTaskInput = {
  actualStartDate?: InputMaybe<Scalars['String']>;
  dateCompleted?: InputMaybe<Scalars['String']>;
  displayToMaker: Scalars['Boolean'];
  dueDate?: InputMaybe<Scalars['String']>;
  durationDays?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  owners: Array<TimeAndActionCalendarTaskOwnerInput>;
  position: Scalars['Int'];
  remindersOn: Scalars['Boolean'];
  remove?: InputMaybe<Scalars['Boolean']>;
  stage: Scalars['String'];
  startDate?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
};

export type TimeAndActionCalendarTaskOwner = {
  __typename?: 'TimeAndActionCalendarTaskOwner';
  id: Scalars['ID'];
  maker: Scalars['Boolean'];
  user?: Maybe<User>;
};

/** The connection type for TimeAndActionCalendarTaskOwner. */
export type TimeAndActionCalendarTaskOwnerConnection = {
  __typename?: 'TimeAndActionCalendarTaskOwnerConnection';
  /** A list of edges. */
  edges: Array<TimeAndActionCalendarTaskOwnerEdge>;
  /** A list of nodes. */
  nodes: Array<TimeAndActionCalendarTaskOwner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TimeAndActionCalendarTaskOwnerEdge = {
  __typename?: 'TimeAndActionCalendarTaskOwnerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TimeAndActionCalendarTaskOwner>;
};

export type TimeAndActionCalendarTaskOwnerInput = {
  id?: InputMaybe<Scalars['ID']>;
  maker?: InputMaybe<Scalars['Boolean']>;
  remove?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<UserInput>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type TimeAndActionCalendarTaskStatusOption = {
  __typename?: 'TimeAndActionCalendarTaskStatusOption';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type TimeAndActionCalendarTemplate = {
  __typename?: 'TimeAndActionCalendarTemplate';
  id: Scalars['ID'];
  name: Scalars['String'];
  tasks: TimeAndActionCalendarTaskConnection;
};


export type TimeAndActionCalendarTemplateTasksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The connection type for TimeAndAction. */
export type TimeAndActionConnection = {
  __typename?: 'TimeAndActionConnection';
  /** A list of edges. */
  edges: Array<TimeAndActionEdge>;
  /** A list of nodes. */
  nodes: Array<TimeAndAction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type TimeAndActionEdge = {
  __typename?: 'TimeAndActionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<TimeAndAction>;
};

export type TimeAndActionTaskChangeRequest = {
  __typename?: 'TimeAndActionTaskChangeRequest';
  cancellationJobPosition?: Maybe<Scalars['String']>;
  cancellationResponsible?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['ISO8601DateTime']>;
  existingDueDate?: Maybe<Scalars['ISO8601DateTime']>;
  existingStartDate?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  jobPosition?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  rejectionNotes?: Maybe<Scalars['String']>;
  responsible?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['ISO8601DateTime']>;
  status: Scalars['String'];
};

export type TimeAndActionTaskChangeRequestInput = {
  id?: InputMaybe<Scalars['ID']>;
  rejectionNotes?: InputMaybe<Scalars['String']>;
  remove?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateActiveClientOrder */
export type UpdateActiveClientOrderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientOrderId: Scalars['ID'];
};

/** Autogenerated return type of UpdateActiveClientOrder */
export type UpdateActiveClientOrderPayload = {
  __typename?: 'UpdateActiveClientOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  clientOrder: ClientOrder;
  errors: Array<ValidationError>;
};

/** Autogenerated input type of UpdateClientOrder */
export type UpdateClientOrderInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  billingAddress?: InputMaybe<AddressInput>;
  billingAddressId?: InputMaybe<Scalars['ID']>;
  clientLegalAgreementId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  clientOrderProducts?: InputMaybe<Array<ClientOrderProductInput>>;
  clientSoPo?: InputMaybe<Array<Scalars['String']>>;
  contacts?: InputMaybe<Array<ContactInput>>;
  deliveryWindow?: InputMaybe<Scalars['Json']>;
  description?: InputMaybe<Scalars['String']>;
  designLeadIds?: InputMaybe<Array<Scalars['ID']>>;
  externalPoReference?: InputMaybe<Scalars['String']>;
  financialLeadIds?: InputMaybe<Array<Scalars['ID']>>;
  id: Scalars['ID'];
  impactLeadIds?: InputMaybe<Array<Scalars['ID']>>;
  internalNotes?: InputMaybe<Scalars['String']>;
  makerOrders?: InputMaybe<Array<MakerOrderInput>>;
  operationsLeadIds?: InputMaybe<Array<Scalars['ID']>>;
  paymentTerms?: InputMaybe<Scalars['String']>;
  productionLeadIds?: InputMaybe<Array<Scalars['ID']>>;
  salesLeadIds?: InputMaybe<Array<Scalars['ID']>>;
  shippingAddress?: InputMaybe<AddressInput>;
  shippingAddressId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of UpdateClientOrder */
export type UpdateClientOrderPayload = {
  __typename?: 'UpdateClientOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  clientOrder: ClientOrder;
  errors: Array<ValidationError>;
};

/** Autogenerated input type of UpdateClientOrderStatus */
export type UpdateClientOrderStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  status?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateClientOrderStatus */
export type UpdateClientOrderStatusPayload = {
  __typename?: 'UpdateClientOrderStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  clientOrder: ClientOrder;
  errors: Array<ValidationError>;
};

/** Autogenerated input type of UpdateMaker */
export type UpdateMakerInput = {
  address?: InputMaybe<Scalars['String']>;
  capabilities?: InputMaybe<Array<Scalars['String']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  countryIds?: InputMaybe<Array<Scalars['ID']>>;
  customers?: InputMaybe<Array<Scalars['String']>>;
  environmentalImpactDescription?: InputMaybe<Scalars['String']>;
  environments?: InputMaybe<Array<Scalars['String']>>;
  exportExperience?: InputMaybe<Scalars['String']>;
  exportingCountryIds?: InputMaybe<Array<Scalars['ID']>>;
  funFact?: InputMaybe<Scalars['String']>;
  hangTagLanguage?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imageSignedId?: InputMaybe<Scalars['String']>;
  incotermIds?: InputMaybe<Array<Scalars['ID']>>;
  internalNotes?: InputMaybe<Scalars['String']>;
  internalOperationNotes?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Array<Scalars['String']>>;
  makerCertificationTypes?: InputMaybe<Array<Scalars['String']>>;
  makerMakerAttributes?: InputMaybe<Array<MakerMakerAttributeInput>>;
  makerMakerQuestions?: InputMaybe<Array<MakerMakerQuestionInput>>;
  makerTypes?: InputMaybe<Array<Scalars['String']>>;
  moqNotes?: InputMaybe<Scalars['String']>;
  moqPriceCents?: InputMaybe<Scalars['Int']>;
  moqUnits?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  numberOfEmployees?: InputMaybe<Scalars['String']>;
  numberOfWomenEmployees?: InputMaybe<Scalars['String']>;
  orderStatus?: InputMaybe<Scalars['String']>;
  parcelCarrierIds?: InputMaybe<Array<Scalars['ID']>>;
  productionCapacity?: InputMaybe<Scalars['String']>;
  productionCapacityNotes?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<Scalars['String']>;
  removeImage?: InputMaybe<Scalars['Boolean']>;
  score?: InputMaybe<Scalars['String']>;
  socialImpactDescription?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  ttmMakerSince?: InputMaybe<Scalars['ISO8601Date']>;
  url?: InputMaybe<Scalars['String']>;
  valueAlignmentIds?: InputMaybe<Array<Scalars['ID']>>;
  vettingStatus?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateMakerOrderCogs */
export type UpdateMakerOrderCogsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  makerOrderNotes?: InputMaybe<Array<MakerOrderNoteInput>>;
  status?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateMakerOrderCogs */
export type UpdateMakerOrderCogsPayload = {
  __typename?: 'UpdateMakerOrderCogsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<ValidationError>;
  makerOrder: MakerOrder;
};

/** Autogenerated input type of UpdateMakerOrder */
export type UpdateMakerOrderInput = {
  billingConsigneeAddressContactName?: InputMaybe<Scalars['String']>;
  billingConsigneeAddressContactPhone?: InputMaybe<Scalars['String']>;
  billingConsigneeAddressId?: InputMaybe<Scalars['String']>;
  billingConsigneeAddressLabel?: InputMaybe<Scalars['String']>;
  billingConsigneeAddressPlain?: InputMaybe<Scalars['String']>;
  clientInfoVisibleToMaker?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contacts?: InputMaybe<Array<ContactInput>>;
  copyLegalAgreementContentBeforeSave?: InputMaybe<Scalars['Boolean']>;
  exFactoryDate?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  inHandsOn?: InputMaybe<Scalars['String']>;
  incotermId?: InputMaybe<Scalars['String']>;
  issuedTo?: InputMaybe<Scalars['String']>;
  mailCarrierId?: InputMaybe<Scalars['String']>;
  makerLegalAgreementId?: InputMaybe<Scalars['String']>;
  makerOrderNotes?: InputMaybe<Array<MakerOrderNoteInput>>;
  moCutDate?: InputMaybe<Scalars['String']>;
  packingAndShippingNotes?: InputMaybe<Scalars['String']>;
  paymentTerms?: InputMaybe<Scalars['String']>;
  productionNotes?: InputMaybe<Scalars['String']>;
  shipment?: InputMaybe<ShipmentInput>;
  shipmentStatus?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  trackingInfo?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateMakerOrder */
export type UpdateMakerOrderPayload = {
  __typename?: 'UpdateMakerOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<ValidationError>;
  makerOrder: MakerOrder;
};

/** Autogenerated return type of UpdateMaker */
export type UpdateMakerPayload = {
  __typename?: 'UpdateMakerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<ValidationError>;
  maker: Maker;
};

/** Autogenerated input type of UpdateMakerStatus */
export type UpdateMakerStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  status?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateMakerStatus */
export type UpdateMakerStatusPayload = {
  __typename?: 'UpdateMakerStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<ValidationError>;
  maker: Maker;
};

/** Autogenerated input type of UpdateProductGroup */
export type UpdateProductGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  htsCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  images?: InputMaybe<Array<ImageInput>>;
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ProductStatus>;
  techPack?: InputMaybe<TechPackInput>;
};

/** Autogenerated return type of UpdateProductGroup */
export type UpdateProductGroupPayload = {
  __typename?: 'UpdateProductGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<ValidationError>;
  productGroup: ProductGroup;
};

/** Autogenerated input type of UpdateProduct */
export type UpdateProductInput = {
  availableUntil?: InputMaybe<Scalars['String']>;
  bulbEnergySavedHours?: InputMaybe<Scalars['String']>;
  carbonOffsetAsKmOfDriving?: InputMaybe<Scalars['String']>;
  carbonOffsetAsPhonesCharged?: InputMaybe<Scalars['String']>;
  carbonOffsetAsTransatlanticFlights?: InputMaybe<Scalars['String']>;
  carbonOffsetKg?: InputMaybe<Scalars['String']>;
  carbonOffsetMetricsEnabled?: InputMaybe<Scalars['Boolean']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  cogsExpiresOn?: InputMaybe<Scalars['ISO8601Date']>;
  countryOfOriginId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  dimension?: InputMaybe<DimensionInput>;
  drinkingWaterSavedDays?: InputMaybe<Scalars['String']>;
  drivingEmissionsAvoidedKm?: InputMaybe<Scalars['String']>;
  emissionsAvoidedKg?: InputMaybe<Scalars['String']>;
  energyConservedKwh?: InputMaybe<Scalars['String']>;
  environmentalImpactMetricsEnabled?: InputMaybe<Scalars['Boolean']>;
  environments?: InputMaybe<Array<Scalars['String']>>;
  equivalencesEnabled?: InputMaybe<Scalars['Boolean']>;
  fabricType?: InputMaybe<Scalars['String']>;
  fairWagePerHour?: InputMaybe<Scalars['String']>;
  htsCode?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  images?: InputMaybe<Array<ImageInput>>;
  internalNotes?: InputMaybe<Scalars['String']>;
  landSavedFromPesticidesM2?: InputMaybe<Scalars['String']>;
  makerCapabilities?: InputMaybe<Array<Scalars['String']>>;
  makerCountryId?: InputMaybe<Scalars['ID']>;
  makerName?: InputMaybe<Scalars['String']>;
  makerTypes?: InputMaybe<Array<Scalars['String']>>;
  maxCapacity?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  npaVariants?: InputMaybe<Array<NpaVariantInput>>;
  pesticidesAvoidedG?: InputMaybe<Scalars['String']>;
  /** List of the people who are notified about cogs expiry */
  pricingOwnerIds?: InputMaybe<Array<Scalars['ID']>>;
  productAttributeIds?: InputMaybe<Array<Scalars['ID']>>;
  productionMethod?: InputMaybe<Scalars['String']>;
  recycledWaterBottles?: InputMaybe<Scalars['String']>;
  selectedMakerAttributeIds?: InputMaybe<Array<Scalars['ID']>>;
  shipsFromCountryId?: InputMaybe<Scalars['ID']>;
  socialImpactMetricsEnabled?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ProductStatus>;
  styleNumber?: InputMaybe<Scalars['String']>;
  techPack?: InputMaybe<TechPackInput>;
  valueAlignmentIds?: InputMaybe<Array<Scalars['ID']>>;
  variantName?: InputMaybe<Scalars['String']>;
  variants?: InputMaybe<Array<VariantInput>>;
  wasteDivertedG?: InputMaybe<Scalars['String']>;
  waterSavedLiters?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateProduct */
export type UpdateProductPayload = {
  __typename?: 'UpdateProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<ValidationError>;
  product: Product;
};

/** Autogenerated input type of UpdateProductStatus */
export type UpdateProductStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  status?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateProductStatus */
export type UpdateProductStatusPayload = {
  __typename?: 'UpdateProductStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<ValidationError>;
  product: Product;
};

/** Autogenerated input type of UpdateTimeAndActionCalendarTask */
export type UpdateTimeAndActionCalendarTaskInput = {
  actualStartDate?: InputMaybe<Scalars['String']>;
  calendarChangeAttributes?: InputMaybe<TimeAndActionCalendarChangeInput>;
  changeRequests?: InputMaybe<Array<TimeAndActionTaskChangeRequestInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  dateCompleted?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  status?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateTimeAndActionCalendarTask */
export type UpdateTimeAndActionCalendarTaskPayload = {
  __typename?: 'UpdateTimeAndActionCalendarTaskPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<ValidationError>;
  timeAndActionCalendarTask: TimeAndActionCalendarTask;
};

/** Autogenerated input type of UpdateTimeAndActionCalendarTemplate */
export type UpdateTimeAndActionCalendarTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  tasks?: InputMaybe<Array<TimeAndActionCalendarTaskInput>>;
};

/** Autogenerated return type of UpdateTimeAndActionCalendarTemplate */
export type UpdateTimeAndActionCalendarTemplatePayload = {
  __typename?: 'UpdateTimeAndActionCalendarTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<ValidationError>;
  timeAndActionCalendarTemplate: TimeAndActionCalendarTemplate;
};

/** Autogenerated input type of UpdateTimeAndAction */
export type UpdateTimeAndActionInput = {
  calendar?: InputMaybe<TimeAndActionCalendarInput>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UpdateTimeAndAction */
export type UpdateTimeAndActionPayload = {
  __typename?: 'UpdateTimeAndActionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<ValidationError>;
  timeAndAction: TimeAndAction;
};

export type User = {
  __typename?: 'User';
  displayName: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['ID'];
  role: Scalars['String'];
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** A list of nodes. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type UserInput = {
  fullName: Scalars['String'];
  id: Scalars['ID'];
};

/** A user-readable error */
export type ValidationError = {
  __typename?: 'ValidationError';
  /** A description of the error */
  message: Scalars['String'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']>>;
};

export type ValueAlignment = {
  __typename?: 'ValueAlignment';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type Variant = {
  __typename?: 'Variant';
  automatic: Scalars['Boolean'];
  cogsVariantCells: Array<CogsVariantCell>;
  /** Per-item amount of money paid to a maker for this SKU */
  costCents?: Maybe<Scalars['Int']>;
  createdAt: Scalars['ISO8601DateTime'];
  dimension?: Maybe<Dimension>;
  discardedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Per-item cost of duty */
  dutyCostCents?: Maybe<Scalars['Int']>;
  heightCm?: Maybe<Scalars['Float']>;
  htsCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lengthCm?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  productd: Product;
  /** Per-item cost of shipping */
  shippingCostCents?: Maybe<Scalars['Int']>;
  shippingPriceBy?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
  weightKg?: Maybe<Scalars['Float']>;
  widthCm?: Maybe<Scalars['Float']>;
};


export type VariantCostCentsArgs = {
  units?: InputMaybe<Scalars['Int']>;
};


export type VariantDutyCostCentsArgs = {
  exportShippingPortId?: InputMaybe<Scalars['ID']>;
  importShippingPortId?: InputMaybe<Scalars['ID']>;
  units?: InputMaybe<Scalars['Int']>;
};


export type VariantShippingCostCentsArgs = {
  exportShippingPortId?: InputMaybe<Scalars['ID']>;
  importShippingPortId?: InputMaybe<Scalars['ID']>;
  units?: InputMaybe<Scalars['Int']>;
};

export type VariantInput = {
  dimension?: InputMaybe<DimensionInput>;
  htsCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  remove?: InputMaybe<Scalars['Boolean']>;
};

export type ActiveClientOrderQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveClientOrderQuery = { __typename?: 'Query', activeClientOrder?: { __typename?: 'ActiveClientOrder', id: string, clientOrder: { __typename?: 'ClientOrder', id: string, showUrl: string, newClientOrderProductUrl: string, makerOrders: { __typename?: 'MakerOrderConnection', nodes: Array<{ __typename?: 'MakerOrder', id: string, humanId: string, accepted: boolean, maker: { __typename?: 'Maker', id: string, name: string } }> } } } | null | undefined };

export type ActiveClientOrderMakerFragment = { __typename?: 'ClientOrder', id: string, showUrl: string, newClientOrderProductUrl: string, makerOrders: { __typename?: 'MakerOrderConnection', nodes: Array<{ __typename?: 'MakerOrder', id: string, humanId: string, accepted: boolean, maker: { __typename?: 'Maker', id: string, name: string } }> } };

export type ActiveMakerLegalAgreementsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveMakerLegalAgreementsQuery = { __typename?: 'Query', activeMakerLegalAgreements: Array<{ __typename?: 'MakerLegalAgreement', id: string, name: string }> };

export type AddProductsToClientOrderFormQueryVariables = Exact<{
  id: Scalars['ID'];
  clientOrderId: Scalars['ID'];
  unitCount?: InputMaybe<Scalars['Int']>;
  exportShippingPortId?: InputMaybe<Scalars['ID']>;
  importShippingPortId?: InputMaybe<Scalars['ID']>;
}>;


export type AddProductsToClientOrderFormQuery = { __typename?: 'Query', product: { __typename?: 'Product', variantName?: string | null | undefined, maker: { __typename?: 'Maker', id: string }, npaVariants: Array<{ __typename?: 'NpaVariant', id: string, name: string, npaVariantTemplateId?: string | null | undefined, npaVariantOptions: Array<{ __typename?: 'NpaVariantOption', id: string, name: string, position?: number | null | undefined }> }>, variants: Array<{ __typename?: 'Variant', id: string, name: string }>, skus: Array<{ __typename?: 'Sku', id: string, humanId: string, variantDisplayName: string, variant: { __typename?: 'Variant', id: string, name: string, costCents?: number | null | undefined, shippingCostCents?: number | null | undefined, dutyCostCents?: number | null | undefined }, npaVariantOptions: Array<{ __typename?: 'NpaVariantOption', id: string, npaVariant: { __typename?: 'NpaVariant', id: string } }> }> }, clientOrder: { __typename?: 'ClientOrder', showUrl: string } };

export type ClientOrderEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClientOrderEditQuery = { __typename?: 'Query', clientOrder: { __typename?: 'ClientOrder', id: string, humanId: string, description: string, createdAt: string, editUrl: string, duplicateUrl: string, totalPriceLooseCents: number, totalUnits: number, totalSkuUnits: number, totalUniqueProducts: number, paymentTerms?: string | null | undefined, acceptedByClient: boolean, hasAcceptedMakerOrders: boolean, internalNotes?: string | null | undefined, externalPoReference?: string | null | undefined, deliveryWindow?: any | null | undefined, totalCostCents?: number | null | undefined, totalMargin?: number | null | undefined, status?: ClientOrderStatus | null | undefined, statusOptions: Array<ClientOrderStatus>, salesPresentationsUrl: string, newSalesPresentationUrl: string, clientApprovalOrdersUrl: string, newClientApprovalOrderUrl: string, makerOrdersUrl: string, newMakerOrderUrl: string, timeAndActionsUrl: string, newTimeAndActionUrl: string, newImpactReportUrl: string, billingAddressId?: string | null | undefined, shippingAddressId?: string | null | undefined, newReferenceImageUrl: string, showUrl: string, clientLegalAgreementId?: string | null | undefined, clientSoPo?: Array<{ __typename?: 'Attachment', imgixUrl: string, filename: string, attachmentUrl: string, url: string }> | null | undefined, creatorUser?: { __typename?: 'User', id: string, fullName: string } | null | undefined, referenceImages: Array<{ __typename?: 'Attachment', imgixUrl: string, filename: string, attachmentUrl: string, url: string }>, salesPresentations: { __typename?: 'SalesPresentationConnection', nodes: Array<{ __typename?: 'SalesPresentation', id: string, humanId: string, pdfStatus: string, humanPdfStatus: string, showUrl: string, createdAt: string }> }, clientApprovalOrders: { __typename?: 'ClientApprovalOrderConnection', nodes: Array<{ __typename?: 'ClientApprovalOrder', id: string, humanId: string, status: string, humanStatus: string, showUrl: string, createdAt: string }> }, salesLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, designLeads?: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }> | null | undefined, productionLeads?: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }> | null | undefined, impactLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, operationsLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, financialLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, leadOptions: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, client: { __typename?: 'Client', id: string, showUrl: string, name?: string | null | undefined }, makerOrders: { __typename?: 'MakerOrderConnection', nodes: Array<{ __typename?: 'MakerOrder', id: string, humanId: string, status?: string | null | undefined, humanStatus: string, accepted: boolean, showUrl: string, createdAt: string, maker: { __typename?: 'Maker', id: string, name: string } }> }, timeAndActions: { __typename?: 'TimeAndActionConnection', nodes: Array<{ __typename?: 'TimeAndAction', id: string, humanId: string, showUrl: string, active: boolean, createdAt: string, maker: { __typename?: 'Maker', id: string, name: string } }> }, contacts: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, jobTitle?: string | null | undefined }>, makers: { __typename?: 'MakerConnection', nodes: Array<{ __typename?: 'Maker', id: string, name: string, logoUrlWithFallback: string, showUrl: string, orderMinimumCents: number }> }, clientLegalAgreementOptions: Array<{ __typename?: 'ClientLegalAgreement', id: string, name: string }>, addressOptions: Array<{ __typename?: 'Address', id: string, selectLabel: string }>, clientOrderProducts: { __typename?: 'ClientOrderProductConnection', nodes: Array<{ __typename?: 'ClientOrderProduct', id: string, makerId: string, totalCostCents?: number | null | undefined, totalPriceCents?: number | null | undefined, includeShippingCosts: boolean, includeDutyCosts: boolean, importShippingPort?: { __typename?: 'ShippingPort', id: string, abbreviation?: string | null | undefined, modeOfTransit: ModeOfTransit } | null | undefined, exportShippingPort?: { __typename?: 'ShippingPort', id: string, abbreviation?: string | null | undefined, modeOfTransit: ModeOfTransit } | null | undefined, image?: { __typename?: 'Image', id: string, imgixUrl: string } | null | undefined, product: { __typename?: 'Product', name?: string | null | undefined, description?: string | null | undefined, variantName?: string | null | undefined, showUrl: string, countryOfOrigin?: { __typename?: 'Country', name: string } | null | undefined, dimension?: { __typename?: 'Dimension', widthCm?: number | null | undefined, heightCm?: number | null | undefined, lengthCm?: number | null | undefined } | null | undefined, materials: { __typename?: 'MaterialConnection', nodes: Array<{ __typename?: 'Material', name: string }> }, materialSubcategories: { __typename?: 'MaterialSubcategoryConnection', nodes: Array<{ __typename?: 'MaterialSubcategory', name: string, material: { __typename?: 'Material', name: string } }> }, imageWithFallback: { __typename?: 'Image', imgixUrl: string }, image?: { __typename?: 'Image', id: string, imgixUrl: string } | null | undefined, skus: Array<{ __typename?: 'Sku', id: string, variantDisplayName: string }>, npaVariants: Array<{ __typename?: 'NpaVariant', id: string, name: string, npaVariantTemplateId?: string | null | undefined, npaVariantOptions: Array<{ __typename?: 'NpaVariantOption', id: string, name: string, position?: number | null | undefined }> }>, variants: Array<{ __typename?: 'Variant', id: string, name: string }>, productGroup: { __typename?: 'ProductGroup', name: string, showUrl: string, customizationCategories: Array<string>, minimumCogsColumnQuantity?: number | null | undefined, addons: Array<{ __typename?: 'Addon', id: string, name: string }>, customizations: Array<{ __typename?: 'Customization', id: string, name: string, customizationCategoryName: string }> } }, clientOrderProductSkus: Array<{ __typename?: 'ClientOrderProductSku', id: string, quantity: number, perItemAmountCents?: number | null | undefined, cogsPerItemAmountCents?: number | null | undefined, margin?: number | null | undefined, calculatedMargin?: number | null | undefined, perItemPrice?: number | null | undefined, calculatedPerItemPrice?: number | null | undefined, totalPriceCents?: number | null | undefined, msrp?: number | null | undefined, shippingCostsCents?: number | null | undefined, dutyCostsCents?: number | null | undefined, totalEnergyConservedKwh?: number | null | undefined, totalWaterSavedLiters?: number | null | undefined, totalEmissionsAvoidedKg?: number | null | undefined, totalFairWageHoursWorked?: number | null | undefined, totalPesticidesAvoidedG?: number | null | undefined, totalCarbonOffsetKg?: number | null | undefined, totalWasteDivertedG?: number | null | undefined, totalRecycledWaterBottles?: number | null | undefined, editCostUrl: string, countryOfOrigin?: { __typename?: 'Country', id: string, shortName: string } | null | undefined, sku: { __typename?: 'Sku', humanId: string, variant: { __typename?: 'Variant', id: string, name: string }, npaVariantOptions: Array<{ __typename?: 'NpaVariantOption', id: string, name: string, npaVariantId: string, position?: number | null | undefined }> } }>, clientOrderProductCustomizations: Array<{ __typename?: 'ClientOrderProductCustomization', id: string, quantity?: number | null | undefined, perItemAmountCents?: number | null | undefined, margin?: number | null | undefined, calculatedMargin?: number | null | undefined, perItemPrice?: number | null | undefined, calculatedPerItemPrice?: number | null | undefined, totalPriceCents?: number | null | undefined, editUrl: string, editCostUrl: string, customization: { __typename?: 'Customization', name: string, customizationCategoryName: string, acceptsArtwork: boolean }, customizationArtworks: Array<{ __typename?: 'CustomizationArtwork', id: string, designName: string, imprintType: string, designLocation: string, designSize: string, designColor: string, artwork: { __typename?: 'Attachment', url: string } }> }>, clientOrderProductAddons: Array<{ __typename?: 'ClientOrderProductAddon', id: string, quantity?: number | null | undefined, perItemAmountCents?: number | null | undefined, margin?: number | null | undefined, calculatedMargin?: number | null | undefined, perItemPrice?: number | null | undefined, calculatedPerItemPrice?: number | null | undefined, totalPriceCents?: number | null | undefined, editCostUrl: string, addon: { __typename?: 'Addon', name: string } }>, clientOrderProductLineItems: Array<{ __typename?: 'ClientOrderProductLineItem', id: string, name: string, quantity: number, perItemCost?: number | null | undefined, margin?: number | null | undefined, calculatedMargin?: number | null | undefined, perItemPrice?: number | null | undefined, calculatedPerItemPrice?: number | null | undefined, totalPriceCents?: number | null | undefined }> }> } } };

export type ClientOrderEditMakerFragment = { __typename?: 'ClientOrder', id: string, humanId: string, description: string, createdAt: string, editUrl: string, duplicateUrl: string, totalPriceLooseCents: number, totalUnits: number, totalSkuUnits: number, totalUniqueProducts: number, paymentTerms?: string | null | undefined, acceptedByClient: boolean, hasAcceptedMakerOrders: boolean, internalNotes?: string | null | undefined, externalPoReference?: string | null | undefined, deliveryWindow?: any | null | undefined, totalCostCents?: number | null | undefined, totalMargin?: number | null | undefined, status?: ClientOrderStatus | null | undefined, statusOptions: Array<ClientOrderStatus>, salesPresentationsUrl: string, newSalesPresentationUrl: string, clientApprovalOrdersUrl: string, newClientApprovalOrderUrl: string, makerOrdersUrl: string, newMakerOrderUrl: string, timeAndActionsUrl: string, newTimeAndActionUrl: string, newImpactReportUrl: string, billingAddressId?: string | null | undefined, shippingAddressId?: string | null | undefined, newReferenceImageUrl: string, showUrl: string, clientLegalAgreementId?: string | null | undefined, clientSoPo?: Array<{ __typename?: 'Attachment', imgixUrl: string, filename: string, attachmentUrl: string, url: string }> | null | undefined, creatorUser?: { __typename?: 'User', id: string, fullName: string } | null | undefined, referenceImages: Array<{ __typename?: 'Attachment', imgixUrl: string, filename: string, attachmentUrl: string, url: string }>, salesPresentations: { __typename?: 'SalesPresentationConnection', nodes: Array<{ __typename?: 'SalesPresentation', id: string, humanId: string, pdfStatus: string, humanPdfStatus: string, showUrl: string, createdAt: string }> }, clientApprovalOrders: { __typename?: 'ClientApprovalOrderConnection', nodes: Array<{ __typename?: 'ClientApprovalOrder', id: string, humanId: string, status: string, humanStatus: string, showUrl: string, createdAt: string }> }, salesLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, designLeads?: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }> | null | undefined, productionLeads?: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }> | null | undefined, impactLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, operationsLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, financialLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, leadOptions: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, client: { __typename?: 'Client', id: string, showUrl: string, name?: string | null | undefined }, makerOrders: { __typename?: 'MakerOrderConnection', nodes: Array<{ __typename?: 'MakerOrder', id: string, humanId: string, status?: string | null | undefined, humanStatus: string, accepted: boolean, showUrl: string, createdAt: string, maker: { __typename?: 'Maker', id: string, name: string } }> }, timeAndActions: { __typename?: 'TimeAndActionConnection', nodes: Array<{ __typename?: 'TimeAndAction', id: string, humanId: string, showUrl: string, active: boolean, createdAt: string, maker: { __typename?: 'Maker', id: string, name: string } }> }, contacts: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, jobTitle?: string | null | undefined }>, makers: { __typename?: 'MakerConnection', nodes: Array<{ __typename?: 'Maker', id: string, name: string, logoUrlWithFallback: string, showUrl: string, orderMinimumCents: number }> }, clientLegalAgreementOptions: Array<{ __typename?: 'ClientLegalAgreement', id: string, name: string }>, addressOptions: Array<{ __typename?: 'Address', id: string, selectLabel: string }>, clientOrderProducts: { __typename?: 'ClientOrderProductConnection', nodes: Array<{ __typename?: 'ClientOrderProduct', id: string, makerId: string, totalCostCents?: number | null | undefined, totalPriceCents?: number | null | undefined, includeShippingCosts: boolean, includeDutyCosts: boolean, importShippingPort?: { __typename?: 'ShippingPort', id: string, abbreviation?: string | null | undefined, modeOfTransit: ModeOfTransit } | null | undefined, exportShippingPort?: { __typename?: 'ShippingPort', id: string, abbreviation?: string | null | undefined, modeOfTransit: ModeOfTransit } | null | undefined, image?: { __typename?: 'Image', id: string, imgixUrl: string } | null | undefined, product: { __typename?: 'Product', name?: string | null | undefined, description?: string | null | undefined, variantName?: string | null | undefined, showUrl: string, countryOfOrigin?: { __typename?: 'Country', name: string } | null | undefined, dimension?: { __typename?: 'Dimension', widthCm?: number | null | undefined, heightCm?: number | null | undefined, lengthCm?: number | null | undefined } | null | undefined, materials: { __typename?: 'MaterialConnection', nodes: Array<{ __typename?: 'Material', name: string }> }, materialSubcategories: { __typename?: 'MaterialSubcategoryConnection', nodes: Array<{ __typename?: 'MaterialSubcategory', name: string, material: { __typename?: 'Material', name: string } }> }, imageWithFallback: { __typename?: 'Image', imgixUrl: string }, image?: { __typename?: 'Image', id: string, imgixUrl: string } | null | undefined, skus: Array<{ __typename?: 'Sku', id: string, variantDisplayName: string }>, npaVariants: Array<{ __typename?: 'NpaVariant', id: string, name: string, npaVariantTemplateId?: string | null | undefined, npaVariantOptions: Array<{ __typename?: 'NpaVariantOption', id: string, name: string, position?: number | null | undefined }> }>, variants: Array<{ __typename?: 'Variant', id: string, name: string }>, productGroup: { __typename?: 'ProductGroup', name: string, showUrl: string, customizationCategories: Array<string>, minimumCogsColumnQuantity?: number | null | undefined, addons: Array<{ __typename?: 'Addon', id: string, name: string }>, customizations: Array<{ __typename?: 'Customization', id: string, name: string, customizationCategoryName: string }> } }, clientOrderProductSkus: Array<{ __typename?: 'ClientOrderProductSku', id: string, quantity: number, perItemAmountCents?: number | null | undefined, cogsPerItemAmountCents?: number | null | undefined, margin?: number | null | undefined, calculatedMargin?: number | null | undefined, perItemPrice?: number | null | undefined, calculatedPerItemPrice?: number | null | undefined, totalPriceCents?: number | null | undefined, msrp?: number | null | undefined, shippingCostsCents?: number | null | undefined, dutyCostsCents?: number | null | undefined, totalEnergyConservedKwh?: number | null | undefined, totalWaterSavedLiters?: number | null | undefined, totalEmissionsAvoidedKg?: number | null | undefined, totalFairWageHoursWorked?: number | null | undefined, totalPesticidesAvoidedG?: number | null | undefined, totalCarbonOffsetKg?: number | null | undefined, totalWasteDivertedG?: number | null | undefined, totalRecycledWaterBottles?: number | null | undefined, editCostUrl: string, countryOfOrigin?: { __typename?: 'Country', id: string, shortName: string } | null | undefined, sku: { __typename?: 'Sku', humanId: string, variant: { __typename?: 'Variant', id: string, name: string }, npaVariantOptions: Array<{ __typename?: 'NpaVariantOption', id: string, name: string, npaVariantId: string, position?: number | null | undefined }> } }>, clientOrderProductCustomizations: Array<{ __typename?: 'ClientOrderProductCustomization', id: string, quantity?: number | null | undefined, perItemAmountCents?: number | null | undefined, margin?: number | null | undefined, calculatedMargin?: number | null | undefined, perItemPrice?: number | null | undefined, calculatedPerItemPrice?: number | null | undefined, totalPriceCents?: number | null | undefined, editUrl: string, editCostUrl: string, customization: { __typename?: 'Customization', name: string, customizationCategoryName: string, acceptsArtwork: boolean }, customizationArtworks: Array<{ __typename?: 'CustomizationArtwork', id: string, designName: string, imprintType: string, designLocation: string, designSize: string, designColor: string, artwork: { __typename?: 'Attachment', url: string } }> }>, clientOrderProductAddons: Array<{ __typename?: 'ClientOrderProductAddon', id: string, quantity?: number | null | undefined, perItemAmountCents?: number | null | undefined, margin?: number | null | undefined, calculatedMargin?: number | null | undefined, perItemPrice?: number | null | undefined, calculatedPerItemPrice?: number | null | undefined, totalPriceCents?: number | null | undefined, editCostUrl: string, addon: { __typename?: 'Addon', name: string } }>, clientOrderProductLineItems: Array<{ __typename?: 'ClientOrderProductLineItem', id: string, name: string, quantity: number, perItemCost?: number | null | undefined, margin?: number | null | undefined, calculatedMargin?: number | null | undefined, perItemPrice?: number | null | undefined, calculatedPerItemPrice?: number | null | undefined, totalPriceCents?: number | null | undefined }> }> } };

export type AddSkusToClientOrderMutationVariables = Exact<{
  input: AddSkusToClientOrderInput;
}>;


export type AddSkusToClientOrderMutation = { __typename?: 'Mutation', addSkusToClientOrder: { __typename?: 'AddSkusToClientOrderPayload', clientOrder: { __typename?: 'ClientOrder', showUrl: string } } };

export type ClientOrderSearchQueryVariables = Exact<{
  tracker?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  sorts?: InputMaybe<Array<ClientOrderSort> | ClientOrderSort>;
  makers?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  clients?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  exFactoryDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  exFactoryDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  moCutDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  moCutDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  salesLead?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  productionLead?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  operationsLead?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  financialLead?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  impactLead?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  designLead?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  clientOrderStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  productionStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shipmentStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shippingMode?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  vesselStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  customsStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  finalMileDelivery?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  importPort?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  exportPort?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  shippingDocsPresent?: InputMaybe<Scalars['Boolean']>;
  bolPodDocsPresent?: InputMaybe<Scalars['Boolean']>;
  parcelCarrier?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ClientOrderSearchQuery = { __typename?: 'Query', clientOrders: { __typename?: 'ClientOrderConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined }, nodes: Array<{ __typename?: 'ClientOrder', id: string, humanId: string, showUrl: string, description: string, productCount: number, status?: ClientOrderStatus | null | undefined, createdAt: string, externalPoReference?: string | null | undefined, deliveryWindow?: any | null | undefined, salesLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, productionLeads?: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }> | null | undefined, operationsLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, designLeads?: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }> | null | undefined, financialLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, impactLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, impactReport?: { __typename?: 'ImpactReport', id?: string | null | undefined } | null | undefined, client: { __typename?: 'Client', name?: string | null | undefined, showUrl: string }, makers: { __typename?: 'MakerConnection', nodes: Array<{ __typename?: 'Maker', id: string, name: string, showUrl: string }> }, makerOrders: { __typename?: 'MakerOrderConnection', nodes: Array<{ __typename?: 'MakerOrder', id: string, humanId: string, makerId: string, status?: string | null | undefined, showUrl: string, productionStatus?: Array<string> | null | undefined, shipmentStatus: string, moCutDate?: string | null | undefined, exFactoryDate?: string | null | undefined, activeTaskCount?: number | null | undefined, timeAndAction?: { __typename?: 'TimeAndAction', id: string, humanId: string, showUrl: string } | null | undefined, countriesOfOrigin?: Array<{ __typename?: 'Country', id: string, name: string }> | null | undefined, shipment?: { __typename?: 'Shipment', id: string, shippingMode?: string | null | undefined, departingPortAt?: string | null | undefined, arrivingPortAt?: string | null | undefined, vesselStatus?: string | null | undefined, customsStatus?: string | null | undefined, deliveredOn?: string | null | undefined, finalMileDelivery?: string | null | undefined, trackingNumbers?: string | null | undefined, departureShippingPort?: { __typename?: 'ShippingPort', id: string, port: string } | null | undefined, arrivalShippingPort?: { __typename?: 'ShippingPort', id: string, port: string } | null | undefined, shipmentDocuments: Array<{ __typename?: 'ShipmentDocument', id: string, documentType: string, fileName?: string | null | undefined }>, parcelCarrier?: { __typename?: 'ParcelCarrier', id: string, name: string } | null | undefined } | null | undefined }> } }> } };

export type ClientProjectListItemFragment = { __typename?: 'ClientOrder', id: string, humanId: string, showUrl: string, description: string, productCount: number, status?: ClientOrderStatus | null | undefined, createdAt: string, externalPoReference?: string | null | undefined, deliveryWindow?: any | null | undefined, salesLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, productionLeads?: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }> | null | undefined, operationsLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, designLeads?: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }> | null | undefined, financialLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, impactLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, impactReport?: { __typename?: 'ImpactReport', id?: string | null | undefined } | null | undefined, client: { __typename?: 'Client', name?: string | null | undefined, showUrl: string }, makers: { __typename?: 'MakerConnection', nodes: Array<{ __typename?: 'Maker', id: string, name: string, showUrl: string }> }, makerOrders: { __typename?: 'MakerOrderConnection', nodes: Array<{ __typename?: 'MakerOrder', id: string, humanId: string, makerId: string, status?: string | null | undefined, showUrl: string, productionStatus?: Array<string> | null | undefined, shipmentStatus: string, moCutDate?: string | null | undefined, exFactoryDate?: string | null | undefined, activeTaskCount?: number | null | undefined, timeAndAction?: { __typename?: 'TimeAndAction', id: string, humanId: string, showUrl: string } | null | undefined, countriesOfOrigin?: Array<{ __typename?: 'Country', id: string, name: string }> | null | undefined, shipment?: { __typename?: 'Shipment', id: string, shippingMode?: string | null | undefined, departingPortAt?: string | null | undefined, arrivingPortAt?: string | null | undefined, vesselStatus?: string | null | undefined, customsStatus?: string | null | undefined, deliveredOn?: string | null | undefined, finalMileDelivery?: string | null | undefined, trackingNumbers?: string | null | undefined, departureShippingPort?: { __typename?: 'ShippingPort', id: string, port: string } | null | undefined, arrivalShippingPort?: { __typename?: 'ShippingPort', id: string, port: string } | null | undefined, shipmentDocuments: Array<{ __typename?: 'ShipmentDocument', id: string, documentType: string, fileName?: string | null | undefined }>, parcelCarrier?: { __typename?: 'ParcelCarrier', id: string, name: string } | null | undefined } | null | undefined }> } };

export type ClientOrderHistoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClientOrderHistoryQuery = { __typename?: 'Query', clientOrder: { __typename?: 'ClientOrder', id: string, orderChanges: Array<{ __typename?: 'OrderChange', description: string, createdAt: string, ownerName?: string | null | undefined }> } };

export type ClientOrderHistoryMakerFragment = { __typename?: 'ClientOrder', id: string, orderChanges: Array<{ __typename?: 'OrderChange', description: string, createdAt: string, ownerName?: string | null | undefined }> };

export type ClientOrderSearchFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientOrderSearchFilterOptionsQuery = { __typename?: 'Query', clientOrderSearchFilterOptions: { __typename?: 'ClientOrderSearchFilterOptions', makers: Array<{ __typename?: 'Maker', id: string, name: string }>, clients: Array<{ __typename?: 'Client', id: string, name?: string | null | undefined }>, owners: Array<{ __typename?: 'User', id: string, fullName: string }>, clientOrderStatuses: Array<{ __typename?: 'SelectOption', value: string, label: string }>, productionStatuses: Array<{ __typename?: 'SelectOption', value: string, label: string }>, shipmentStatuses: Array<{ __typename?: 'SelectOption', value: string, label: string }>, vesselStatuses: Array<{ __typename?: 'SelectOption', value: string, label: string }>, customsStatuses: Array<{ __typename?: 'SelectOption', value: string, label: string }>, finalMileDeliveries: Array<{ __typename?: 'SelectOption', value: string, label: string }>, shippingModes: Array<{ __typename?: 'SelectOption', value: string, label: string }>, importPorts: Array<{ __typename?: 'ShippingPort', id: string, port: string }>, exportPorts: Array<{ __typename?: 'ShippingPort', id: string, port: string }>, parcelCarriers: Array<{ __typename?: 'ParcelCarrier', id: string, name: string }> } };

export type ClientOrderShowQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClientOrderShowQuery = { __typename?: 'Query', clientOrder: { __typename?: 'ClientOrder', id: string, humanId: string, description: string, createdAt: string, editUrl: string, duplicateUrl: string, totalPriceLooseCents: number, totalUnits: number, totalSkuUnits: number, totalUniqueProducts: number, paymentTerms?: string | null | undefined, acceptedByClient: boolean, hasAcceptedMakerOrders: boolean, internalNotes?: string | null | undefined, totalCostCents?: number | null | undefined, totalMargin?: number | null | undefined, status?: ClientOrderStatus | null | undefined, showUrl: string, statusOptions: Array<ClientOrderStatus>, salesPresentationsUrl: string, newSalesPresentationUrl: string, clientApprovalOrdersUrl: string, newClientApprovalOrderUrl: string, makerOrdersUrl: string, timeAndActionsUrl: string, newTimeAndActionUrl: string, newMakerOrderUrl: string, newImpactReportUrl: string, externalPoReference?: string | null | undefined, deliveryWindow?: any | null | undefined, clientSoPo?: Array<{ __typename?: 'Attachment', imgixUrl: string, filename: string, attachmentUrl: string, url: string }> | null | undefined, creatorUser?: { __typename?: 'User', id: string, fullName: string } | null | undefined, salesLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, productionLeads?: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }> | null | undefined, operationsLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, impactLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, designLeads?: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }> | null | undefined, financialLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, leadOptions: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, impactReport?: { __typename?: 'ImpactReport', id?: string | null | undefined, showUrl: string } | null | undefined, referenceImages: Array<{ __typename?: 'Attachment', filename: string, url: string, imgixUrl: string, attachmentUrl: string }>, salesPresentations: { __typename?: 'SalesPresentationConnection', nodes: Array<{ __typename?: 'SalesPresentation', id: string, humanId: string, pdfStatus: string, humanPdfStatus: string, showUrl: string, createdAt: string }> }, clientApprovalOrders: { __typename?: 'ClientApprovalOrderConnection', nodes: Array<{ __typename?: 'ClientApprovalOrder', id: string, humanId: string, status: string, humanStatus: string, showUrl: string, createdAt: string }> }, makerOrders: { __typename?: 'MakerOrderConnection', nodes: Array<{ __typename?: 'MakerOrder', id: string, humanId: string, status?: string | null | undefined, humanStatus: string, accepted: boolean, showUrl: string, createdAt: string, maker: { __typename?: 'Maker', id: string, name: string } }> }, timeAndActions: { __typename?: 'TimeAndActionConnection', nodes: Array<{ __typename?: 'TimeAndAction', id: string, humanId: string, showUrl: string, active: boolean, createdAt: string, maker: { __typename?: 'Maker', id: string, name: string } }> }, client: { __typename?: 'Client', id: string, showUrl: string, name?: string | null | undefined }, shippingAddress?: { __typename?: 'Address', plain: string, label: string, contactName?: string | null | undefined, contactPhone?: string | null | undefined, contactEmail?: string | null | undefined, addressType: string, deliveryAppointmentRequired: boolean, dock: boolean, warehouseAddressNotes?: string | null | undefined } | null | undefined, billingAddress?: { __typename?: 'Address', plain: string, label: string, contactName?: string | null | undefined, contactPhone?: string | null | undefined, contactEmail?: string | null | undefined, addressType: string, deliveryAppointmentRequired: boolean, dock: boolean, warehouseAddressNotes?: string | null | undefined } | null | undefined, contacts: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined, jobTitle?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined }>, makers: { __typename?: 'MakerConnection', nodes: Array<{ __typename?: 'Maker', id: string, name: string, logoUrlWithFallback: string, showUrl: string, orderMinimumCents: number }> }, clientOrderProducts: { __typename?: 'ClientOrderProductConnection', nodes: Array<{ __typename?: 'ClientOrderProduct', id: string, makerId: string, totalCostCents?: number | null | undefined, totalPriceCents?: number | null | undefined, includeShippingCosts: boolean, includeDutyCosts: boolean, importShippingPort?: { __typename?: 'ShippingPort', id: string, abbreviation?: string | null | undefined, modeOfTransit: ModeOfTransit } | null | undefined, exportShippingPort?: { __typename?: 'ShippingPort', id: string, abbreviation?: string | null | undefined, modeOfTransit: ModeOfTransit } | null | undefined, image?: { __typename?: 'Image', id: string, imgixUrl: string } | null | undefined, product: { __typename?: 'Product', name?: string | null | undefined, description?: string | null | undefined, variantName?: string | null | undefined, showUrl: string, countryOfOrigin?: { __typename?: 'Country', name: string } | null | undefined, dimension?: { __typename?: 'Dimension', widthCm?: number | null | undefined, heightCm?: number | null | undefined, lengthCm?: number | null | undefined } | null | undefined, materials: { __typename?: 'MaterialConnection', nodes: Array<{ __typename?: 'Material', name: string }> }, materialSubcategories: { __typename?: 'MaterialSubcategoryConnection', nodes: Array<{ __typename?: 'MaterialSubcategory', name: string, material: { __typename?: 'Material', name: string } }> }, imageWithFallback: { __typename?: 'Image', imgixUrl: string }, image?: { __typename?: 'Image', id: string, imgixUrl: string } | null | undefined, skus: Array<{ __typename?: 'Sku', id: string, variantDisplayName: string }>, npaVariants: Array<{ __typename?: 'NpaVariant', id: string, name: string, npaVariantTemplateId?: string | null | undefined, npaVariantOptions: Array<{ __typename?: 'NpaVariantOption', id: string, name: string, position?: number | null | undefined }> }>, variants: Array<{ __typename?: 'Variant', id: string, name: string }>, productGroup: { __typename?: 'ProductGroup', name: string, showUrl: string, customizationCategories: Array<string>, minimumCogsColumnQuantity?: number | null | undefined, addons: Array<{ __typename?: 'Addon', id: string, name: string }>, customizations: Array<{ __typename?: 'Customization', id: string, name: string, customizationCategoryName: string }> } }, clientOrderProductSkus: Array<{ __typename?: 'ClientOrderProductSku', id: string, quantity: number, perItemAmountCents?: number | null | undefined, cogsPerItemAmountCents?: number | null | undefined, margin?: number | null | undefined, calculatedMargin?: number | null | undefined, perItemPrice?: number | null | undefined, calculatedPerItemPrice?: number | null | undefined, totalPriceCents?: number | null | undefined, msrp?: number | null | undefined, shippingCostsCents?: number | null | undefined, dutyCostsCents?: number | null | undefined, totalEnergyConservedKwh?: number | null | undefined, totalWaterSavedLiters?: number | null | undefined, totalEmissionsAvoidedKg?: number | null | undefined, totalFairWageHoursWorked?: number | null | undefined, totalPesticidesAvoidedG?: number | null | undefined, totalCarbonOffsetKg?: number | null | undefined, totalWasteDivertedG?: number | null | undefined, totalRecycledWaterBottles?: number | null | undefined, totalBulbEnergySavedHours?: number | null | undefined, totalDrivingEmissionsAvoidedKm?: number | null | undefined, totalDrinkingWaterSavedDays?: number | null | undefined, totalLandSavedFromPesticidesM2?: number | null | undefined, editCostUrl: string, countryOfOrigin?: { __typename?: 'Country', id: string, shortName: string } | null | undefined, sku: { __typename?: 'Sku', humanId: string, variant: { __typename?: 'Variant', id: string, name: string }, npaVariantOptions: Array<{ __typename?: 'NpaVariantOption', id: string, name: string, npaVariantId: string, position?: number | null | undefined }> } }>, clientOrderProductCustomizations: Array<{ __typename?: 'ClientOrderProductCustomization', id: string, quantity?: number | null | undefined, perItemAmountCents?: number | null | undefined, margin?: number | null | undefined, calculatedMargin?: number | null | undefined, perItemPrice?: number | null | undefined, calculatedPerItemPrice?: number | null | undefined, totalPriceCents?: number | null | undefined, editUrl: string, editCostUrl: string, customization: { __typename?: 'Customization', name: string, customizationCategoryName: string, acceptsArtwork: boolean }, customizationArtworks: Array<{ __typename?: 'CustomizationArtwork', id: string, designName: string, imprintType: string, designLocation: string, designSize: string, designColor: string, artwork: { __typename?: 'Attachment', url: string } }> }>, clientOrderProductAddons: Array<{ __typename?: 'ClientOrderProductAddon', id: string, quantity?: number | null | undefined, perItemAmountCents?: number | null | undefined, margin?: number | null | undefined, calculatedMargin?: number | null | undefined, perItemPrice?: number | null | undefined, calculatedPerItemPrice?: number | null | undefined, totalPriceCents?: number | null | undefined, editCostUrl: string, addon: { __typename?: 'Addon', name: string } }>, clientOrderProductLineItems: Array<{ __typename?: 'ClientOrderProductLineItem', id: string, name: string, quantity: number, perItemCost?: number | null | undefined, margin?: number | null | undefined, calculatedMargin?: number | null | undefined, perItemPrice?: number | null | undefined, calculatedPerItemPrice?: number | null | undefined, totalPriceCents?: number | null | undefined }> }> } } };

export type ClientOrderShowMakerFragment = { __typename?: 'ClientOrder', id: string, humanId: string, description: string, createdAt: string, editUrl: string, duplicateUrl: string, totalPriceLooseCents: number, totalUnits: number, totalSkuUnits: number, totalUniqueProducts: number, paymentTerms?: string | null | undefined, acceptedByClient: boolean, hasAcceptedMakerOrders: boolean, internalNotes?: string | null | undefined, totalCostCents?: number | null | undefined, totalMargin?: number | null | undefined, status?: ClientOrderStatus | null | undefined, showUrl: string, statusOptions: Array<ClientOrderStatus>, salesPresentationsUrl: string, newSalesPresentationUrl: string, clientApprovalOrdersUrl: string, newClientApprovalOrderUrl: string, makerOrdersUrl: string, timeAndActionsUrl: string, newTimeAndActionUrl: string, newMakerOrderUrl: string, newImpactReportUrl: string, externalPoReference?: string | null | undefined, deliveryWindow?: any | null | undefined, clientSoPo?: Array<{ __typename?: 'Attachment', imgixUrl: string, filename: string, attachmentUrl: string, url: string }> | null | undefined, creatorUser?: { __typename?: 'User', id: string, fullName: string } | null | undefined, salesLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, productionLeads?: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }> | null | undefined, operationsLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, impactLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, designLeads?: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }> | null | undefined, financialLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, leadOptions: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, impactReport?: { __typename?: 'ImpactReport', id?: string | null | undefined, showUrl: string } | null | undefined, referenceImages: Array<{ __typename?: 'Attachment', filename: string, url: string, imgixUrl: string, attachmentUrl: string }>, salesPresentations: { __typename?: 'SalesPresentationConnection', nodes: Array<{ __typename?: 'SalesPresentation', id: string, humanId: string, pdfStatus: string, humanPdfStatus: string, showUrl: string, createdAt: string }> }, clientApprovalOrders: { __typename?: 'ClientApprovalOrderConnection', nodes: Array<{ __typename?: 'ClientApprovalOrder', id: string, humanId: string, status: string, humanStatus: string, showUrl: string, createdAt: string }> }, makerOrders: { __typename?: 'MakerOrderConnection', nodes: Array<{ __typename?: 'MakerOrder', id: string, humanId: string, status?: string | null | undefined, humanStatus: string, accepted: boolean, showUrl: string, createdAt: string, maker: { __typename?: 'Maker', id: string, name: string } }> }, timeAndActions: { __typename?: 'TimeAndActionConnection', nodes: Array<{ __typename?: 'TimeAndAction', id: string, humanId: string, showUrl: string, active: boolean, createdAt: string, maker: { __typename?: 'Maker', id: string, name: string } }> }, client: { __typename?: 'Client', id: string, showUrl: string, name?: string | null | undefined }, shippingAddress?: { __typename?: 'Address', plain: string, label: string, contactName?: string | null | undefined, contactPhone?: string | null | undefined, contactEmail?: string | null | undefined, addressType: string, deliveryAppointmentRequired: boolean, dock: boolean, warehouseAddressNotes?: string | null | undefined } | null | undefined, billingAddress?: { __typename?: 'Address', plain: string, label: string, contactName?: string | null | undefined, contactPhone?: string | null | undefined, contactEmail?: string | null | undefined, addressType: string, deliveryAppointmentRequired: boolean, dock: boolean, warehouseAddressNotes?: string | null | undefined } | null | undefined, contacts: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined, jobTitle?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined }>, makers: { __typename?: 'MakerConnection', nodes: Array<{ __typename?: 'Maker', id: string, name: string, logoUrlWithFallback: string, showUrl: string, orderMinimumCents: number }> }, clientOrderProducts: { __typename?: 'ClientOrderProductConnection', nodes: Array<{ __typename?: 'ClientOrderProduct', id: string, makerId: string, totalCostCents?: number | null | undefined, totalPriceCents?: number | null | undefined, includeShippingCosts: boolean, includeDutyCosts: boolean, importShippingPort?: { __typename?: 'ShippingPort', id: string, abbreviation?: string | null | undefined, modeOfTransit: ModeOfTransit } | null | undefined, exportShippingPort?: { __typename?: 'ShippingPort', id: string, abbreviation?: string | null | undefined, modeOfTransit: ModeOfTransit } | null | undefined, image?: { __typename?: 'Image', id: string, imgixUrl: string } | null | undefined, product: { __typename?: 'Product', name?: string | null | undefined, description?: string | null | undefined, variantName?: string | null | undefined, showUrl: string, countryOfOrigin?: { __typename?: 'Country', name: string } | null | undefined, dimension?: { __typename?: 'Dimension', widthCm?: number | null | undefined, heightCm?: number | null | undefined, lengthCm?: number | null | undefined } | null | undefined, materials: { __typename?: 'MaterialConnection', nodes: Array<{ __typename?: 'Material', name: string }> }, materialSubcategories: { __typename?: 'MaterialSubcategoryConnection', nodes: Array<{ __typename?: 'MaterialSubcategory', name: string, material: { __typename?: 'Material', name: string } }> }, imageWithFallback: { __typename?: 'Image', imgixUrl: string }, image?: { __typename?: 'Image', id: string, imgixUrl: string } | null | undefined, skus: Array<{ __typename?: 'Sku', id: string, variantDisplayName: string }>, npaVariants: Array<{ __typename?: 'NpaVariant', id: string, name: string, npaVariantTemplateId?: string | null | undefined, npaVariantOptions: Array<{ __typename?: 'NpaVariantOption', id: string, name: string, position?: number | null | undefined }> }>, variants: Array<{ __typename?: 'Variant', id: string, name: string }>, productGroup: { __typename?: 'ProductGroup', name: string, showUrl: string, customizationCategories: Array<string>, minimumCogsColumnQuantity?: number | null | undefined, addons: Array<{ __typename?: 'Addon', id: string, name: string }>, customizations: Array<{ __typename?: 'Customization', id: string, name: string, customizationCategoryName: string }> } }, clientOrderProductSkus: Array<{ __typename?: 'ClientOrderProductSku', id: string, quantity: number, perItemAmountCents?: number | null | undefined, cogsPerItemAmountCents?: number | null | undefined, margin?: number | null | undefined, calculatedMargin?: number | null | undefined, perItemPrice?: number | null | undefined, calculatedPerItemPrice?: number | null | undefined, totalPriceCents?: number | null | undefined, msrp?: number | null | undefined, shippingCostsCents?: number | null | undefined, dutyCostsCents?: number | null | undefined, totalEnergyConservedKwh?: number | null | undefined, totalWaterSavedLiters?: number | null | undefined, totalEmissionsAvoidedKg?: number | null | undefined, totalFairWageHoursWorked?: number | null | undefined, totalPesticidesAvoidedG?: number | null | undefined, totalCarbonOffsetKg?: number | null | undefined, totalWasteDivertedG?: number | null | undefined, totalRecycledWaterBottles?: number | null | undefined, totalBulbEnergySavedHours?: number | null | undefined, totalDrivingEmissionsAvoidedKm?: number | null | undefined, totalDrinkingWaterSavedDays?: number | null | undefined, totalLandSavedFromPesticidesM2?: number | null | undefined, editCostUrl: string, countryOfOrigin?: { __typename?: 'Country', id: string, shortName: string } | null | undefined, sku: { __typename?: 'Sku', humanId: string, variant: { __typename?: 'Variant', id: string, name: string }, npaVariantOptions: Array<{ __typename?: 'NpaVariantOption', id: string, name: string, npaVariantId: string, position?: number | null | undefined }> } }>, clientOrderProductCustomizations: Array<{ __typename?: 'ClientOrderProductCustomization', id: string, quantity?: number | null | undefined, perItemAmountCents?: number | null | undefined, margin?: number | null | undefined, calculatedMargin?: number | null | undefined, perItemPrice?: number | null | undefined, calculatedPerItemPrice?: number | null | undefined, totalPriceCents?: number | null | undefined, editUrl: string, editCostUrl: string, customization: { __typename?: 'Customization', name: string, customizationCategoryName: string, acceptsArtwork: boolean }, customizationArtworks: Array<{ __typename?: 'CustomizationArtwork', id: string, designName: string, imprintType: string, designLocation: string, designSize: string, designColor: string, artwork: { __typename?: 'Attachment', url: string } }> }>, clientOrderProductAddons: Array<{ __typename?: 'ClientOrderProductAddon', id: string, quantity?: number | null | undefined, perItemAmountCents?: number | null | undefined, margin?: number | null | undefined, calculatedMargin?: number | null | undefined, perItemPrice?: number | null | undefined, calculatedPerItemPrice?: number | null | undefined, totalPriceCents?: number | null | undefined, editCostUrl: string, addon: { __typename?: 'Addon', name: string } }>, clientOrderProductLineItems: Array<{ __typename?: 'ClientOrderProductLineItem', id: string, name: string, quantity: number, perItemCost?: number | null | undefined, margin?: number | null | undefined, calculatedMargin?: number | null | undefined, perItemPrice?: number | null | undefined, calculatedPerItemPrice?: number | null | undefined, totalPriceCents?: number | null | undefined }> }> } };

export type ClientOrdersQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['ID']>;
  year?: InputMaybe<Scalars['String']>;
}>;


export type ClientOrdersQuery = { __typename?: 'Query', clientOrders: { __typename?: 'ClientOrderConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined }, nodes: Array<{ __typename?: 'ClientOrder', id: string, humanId: string, showUrl: string, description: string, productCount: number, status?: ClientOrderStatus | null | undefined, createdAt: string, externalPoReference?: string | null | undefined, deliveryWindow?: any | null | undefined, salesLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, productionLeads?: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }> | null | undefined, operationsLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, designLeads?: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }> | null | undefined, financialLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, impactLeads: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined }>, impactReport?: { __typename?: 'ImpactReport', id?: string | null | undefined } | null | undefined, client: { __typename?: 'Client', name?: string | null | undefined, showUrl: string }, makers: { __typename?: 'MakerConnection', nodes: Array<{ __typename?: 'Maker', id: string, name: string, showUrl: string }> }, makerOrders: { __typename?: 'MakerOrderConnection', nodes: Array<{ __typename?: 'MakerOrder', id: string, humanId: string, makerId: string, status?: string | null | undefined, showUrl: string, productionStatus?: Array<string> | null | undefined, shipmentStatus: string, moCutDate?: string | null | undefined, exFactoryDate?: string | null | undefined, activeTaskCount?: number | null | undefined, timeAndAction?: { __typename?: 'TimeAndAction', id: string, humanId: string, showUrl: string } | null | undefined, countriesOfOrigin?: Array<{ __typename?: 'Country', id: string, name: string }> | null | undefined, shipment?: { __typename?: 'Shipment', id: string, shippingMode?: string | null | undefined, departingPortAt?: string | null | undefined, arrivingPortAt?: string | null | undefined, vesselStatus?: string | null | undefined, customsStatus?: string | null | undefined, deliveredOn?: string | null | undefined, finalMileDelivery?: string | null | undefined, trackingNumbers?: string | null | undefined, departureShippingPort?: { __typename?: 'ShippingPort', id: string, port: string } | null | undefined, arrivalShippingPort?: { __typename?: 'ShippingPort', id: string, port: string } | null | undefined, shipmentDocuments: Array<{ __typename?: 'ShipmentDocument', id: string, documentType: string, fileName?: string | null | undefined }>, parcelCarrier?: { __typename?: 'ParcelCarrier', id: string, name: string } | null | undefined } | null | undefined }> } }> } };

export type ClientSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  sorts?: InputMaybe<Array<ClientSort> | ClientSort>;
}>;


export type ClientSearchQuery = { __typename?: 'Query', clients: { __typename?: 'ClientConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined }, nodes: Array<{ __typename?: 'Client', id: string, name?: string | null | undefined, humanId: string, showUrl: string }> } };

export type ClientSearchClientFragment = { __typename?: 'Client', id: string, name?: string | null | undefined, humanId: string, showUrl: string };

export type CreateMakerOrderMutationVariables = Exact<{
  input: CreateMakerOrderInput;
}>;


export type CreateMakerOrderMutation = { __typename?: 'Mutation', createMakerOrder: { __typename?: 'CreateMakerOrderPayload', makerOrder: { __typename?: 'MakerOrder', clientOrderId: string, makerId: string, makerLegalAgreementId?: string | null | undefined, humanId: string, contacts: Array<{ __typename?: 'Contact', fullName?: string | null | undefined }> }, errors: Array<{ __typename?: 'ValidationError', path?: Array<string> | null | undefined, message: string }> } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, role: string } | null | undefined };

export type ImpactReportMutationVariables = Exact<{
  input: ImpactReportInput;
}>;


export type ImpactReportMutation = { __typename?: 'Mutation', impactReport: { __typename?: 'ImpactReportPayload', impactReport: { __typename?: 'ImpactReport', id?: string | null | undefined, showUrl: string }, errors: Array<{ __typename?: 'ValidationError', path?: Array<string> | null | undefined, message: string }> } };

export type ImpactReportSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  makers?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  clients?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  deliveryWindowAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  deliveryWindowBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  types?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ImpactReportSearchQuery = { __typename?: 'Query', impactReports: { __typename?: 'ImpactReportConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined }, nodes: Array<{ __typename?: 'ImpactReport', id?: string | null | undefined, humanId: string, type?: string | null | undefined, showUrl: string, createdAt: string, description?: string | null | undefined, client?: { __typename?: 'Client', id: string, name?: string | null | undefined, showUrl: string } | null | undefined, clientOrders: Array<{ __typename?: 'ClientOrder', id: string, humanId: string, showUrl: string, deliveryWindow?: any | null | undefined, createdAt: string }>, makers: { __typename?: 'MakerConnection', nodes: Array<{ __typename?: 'Maker', id: string, name: string, showUrl: string }> } }> } };

export type ImpactReportListItemFragment = { __typename?: 'ImpactReport', id?: string | null | undefined, humanId: string, type?: string | null | undefined, showUrl: string, createdAt: string, description?: string | null | undefined, client?: { __typename?: 'Client', id: string, name?: string | null | undefined, showUrl: string } | null | undefined, clientOrders: Array<{ __typename?: 'ClientOrder', id: string, humanId: string, showUrl: string, deliveryWindow?: any | null | undefined, createdAt: string }>, makers: { __typename?: 'MakerConnection', nodes: Array<{ __typename?: 'Maker', id: string, name: string, showUrl: string }> } };

export type ImpactReportShowQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ImpactReportShowQuery = { __typename?: 'Query', impactReport: { __typename?: 'ImpactReport', id?: string | null | undefined, showUrl: string, indexUrl: string, impactReportCopiesUrl: string, clientId?: string | null | undefined, type?: string | null | undefined, description?: string | null | undefined, year?: string | null | undefined, overviewCopyId?: string | null | undefined, impactDescriptionCopyId?: string | null | undefined, carbonOffsettingDescriptionCopyId?: string | null | undefined, disclaimerNotesCopyId?: string | null | undefined, conclusionCopyId?: string | null | undefined, typeOptions: Array<string>, productAttributes: { __typename?: 'ProductAttributeConnection', nodes: Array<{ __typename?: 'ProductAttribute', id: string, name: string, icon: { __typename?: 'Attachment', imgixUrl: string } }> }, clientOrders: Array<{ __typename?: 'ClientOrder', id: string }>, client?: { __typename?: 'Client', name?: string | null | undefined } | null | undefined, clientOptions: Array<{ __typename?: 'Client', id: string, name?: string | null | undefined }>, impactReportCopyOptions: Array<{ __typename?: 'ImpactReportCopy', id: string, type: string, name: string, content: string }>, certificationOptions: Array<{ __typename?: 'Certification', id: string, name: string }>, certifications: { __typename?: 'CertificationConnection', nodes: Array<{ __typename?: 'Certification', id: string, name: string }> }, makerCertifications: { __typename?: 'MakerCertificationConnection', nodes: Array<{ __typename?: 'MakerCertification', id: string, maker: { __typename?: 'Maker', id: string }, certification: { __typename?: 'Certification', id: string, name: string, icon: { __typename?: 'Attachment', imgixUrl: string } } }> }, makerMarketingImage?: { __typename?: 'MakerMarketingImage', id: string, imgixUrl: string } | null | undefined, makerMarketingImages: { __typename?: 'MakerMarketingImageConnection', nodes: Array<{ __typename?: 'MakerMarketingImage', id: string, imgixUrl: string }> }, makers: { __typename?: 'MakerConnection', nodes: Array<{ __typename?: 'Maker', id: string, profile?: string | null | undefined, socialImpactDescription?: string | null | undefined, environmentalImpactDescription?: string | null | undefined, impactReportImage?: { __typename?: 'ImpactReportImage', id: string, imgixUrl: string, className: string } | null | undefined, makerCertifications: { __typename?: 'MakerCertificationConnection', nodes: Array<{ __typename?: 'MakerCertification', id: string, certification: { __typename?: 'Certification', id: string, name: string, icon: { __typename?: 'Attachment', imgixUrl: string } } }> }, impactReportClientOrderProducts: Array<{ __typename?: 'ClientOrderProduct', id: string, totalEnergyConservedKwh?: number | null | undefined, totalWaterSavedLiters?: number | null | undefined, totalEmissionsAvoidedKg?: number | null | undefined, totalFairWageHoursWorked?: number | null | undefined, totalRecycledWaterBottles?: number | null | undefined, totalPesticidesAvoidedG?: number | null | undefined, product: { __typename?: 'Product', id: string, name?: string | null | undefined, productAttributes: Array<{ __typename?: 'ProductAttribute', id: string, name: string, icon: { __typename?: 'Attachment', imgixUrl: string } }>, impactReportImage?: { __typename?: 'ImpactReportImage', id: string, imgixUrl: string, className: string } | null | undefined, countryOfOrigin?: { __typename?: 'Country', name: string } | null | undefined, materials: { __typename?: 'MaterialConnection', nodes: Array<{ __typename?: 'Material', name: string }> } } }> }> } } };

export type ImpactReportShowMakerFragment = { __typename?: 'ImpactReport', id?: string | null | undefined, showUrl: string, indexUrl: string, impactReportCopiesUrl: string, clientId?: string | null | undefined, type?: string | null | undefined, description?: string | null | undefined, year?: string | null | undefined, overviewCopyId?: string | null | undefined, impactDescriptionCopyId?: string | null | undefined, carbonOffsettingDescriptionCopyId?: string | null | undefined, disclaimerNotesCopyId?: string | null | undefined, conclusionCopyId?: string | null | undefined, typeOptions: Array<string>, productAttributes: { __typename?: 'ProductAttributeConnection', nodes: Array<{ __typename?: 'ProductAttribute', id: string, name: string, icon: { __typename?: 'Attachment', imgixUrl: string } }> }, clientOrders: Array<{ __typename?: 'ClientOrder', id: string }>, client?: { __typename?: 'Client', name?: string | null | undefined } | null | undefined, clientOptions: Array<{ __typename?: 'Client', id: string, name?: string | null | undefined }>, impactReportCopyOptions: Array<{ __typename?: 'ImpactReportCopy', id: string, type: string, name: string, content: string }>, certificationOptions: Array<{ __typename?: 'Certification', id: string, name: string }>, certifications: { __typename?: 'CertificationConnection', nodes: Array<{ __typename?: 'Certification', id: string, name: string }> }, makerCertifications: { __typename?: 'MakerCertificationConnection', nodes: Array<{ __typename?: 'MakerCertification', id: string, maker: { __typename?: 'Maker', id: string }, certification: { __typename?: 'Certification', id: string, name: string, icon: { __typename?: 'Attachment', imgixUrl: string } } }> }, makerMarketingImage?: { __typename?: 'MakerMarketingImage', id: string, imgixUrl: string } | null | undefined, makerMarketingImages: { __typename?: 'MakerMarketingImageConnection', nodes: Array<{ __typename?: 'MakerMarketingImage', id: string, imgixUrl: string }> }, makers: { __typename?: 'MakerConnection', nodes: Array<{ __typename?: 'Maker', id: string, profile?: string | null | undefined, socialImpactDescription?: string | null | undefined, environmentalImpactDescription?: string | null | undefined, impactReportImage?: { __typename?: 'ImpactReportImage', id: string, imgixUrl: string, className: string } | null | undefined, makerCertifications: { __typename?: 'MakerCertificationConnection', nodes: Array<{ __typename?: 'MakerCertification', id: string, certification: { __typename?: 'Certification', id: string, name: string, icon: { __typename?: 'Attachment', imgixUrl: string } } }> }, impactReportClientOrderProducts: Array<{ __typename?: 'ClientOrderProduct', id: string, totalEnergyConservedKwh?: number | null | undefined, totalWaterSavedLiters?: number | null | undefined, totalEmissionsAvoidedKg?: number | null | undefined, totalFairWageHoursWorked?: number | null | undefined, totalRecycledWaterBottles?: number | null | undefined, totalPesticidesAvoidedG?: number | null | undefined, product: { __typename?: 'Product', id: string, name?: string | null | undefined, productAttributes: Array<{ __typename?: 'ProductAttribute', id: string, name: string, icon: { __typename?: 'Attachment', imgixUrl: string } }>, impactReportImage?: { __typename?: 'ImpactReportImage', id: string, imgixUrl: string, className: string } | null | undefined, countryOfOrigin?: { __typename?: 'Country', name: string } | null | undefined, materials: { __typename?: 'MaterialConnection', nodes: Array<{ __typename?: 'Material', name: string }> } } }> }> } };

export type CertificationWithIconFragment = { __typename?: 'Certification', id: string, name: string, icon: { __typename?: 'Attachment', imgixUrl: string } };

export type ProductAttributeWithIconFragment = { __typename?: 'ProductAttribute', id: string, name: string, icon: { __typename?: 'Attachment', imgixUrl: string } };

export type MakerDocumentsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type MakerDocumentsQuery = { __typename?: 'Query', maker: { __typename?: 'Maker', id: string, editUrl: string, newMakerCertificationUrl: string, newMakerNdaUrl: string, newMakerVettingSurveyUrl: string, newMakerAuditUrl: string, newMakerDocumentUrl: string, makerCertifications: { __typename?: 'MakerCertificationConnection', nodes: Array<{ __typename?: 'MakerCertification', id: string, certifier?: string | null | undefined, activeFrom?: string | null | undefined, expiredAt?: string | null | undefined, editUrl: string, documentUrlInline?: string | null | undefined, documentUrlAttachment?: string | null | undefined, certification: { __typename?: 'Certification', id: string, name: string, icon: { __typename?: 'Attachment', imgixUrl: string } } }> }, makerNdas: { __typename?: 'MakerNdaConnection', nodes: Array<{ __typename?: 'MakerNda', id: string, documentType: string, signedByName: string, signedByPosition: string, dateOfSignature: string, expirationDate?: string | null | undefined, editUrl: string, documentUrlInline?: string | null | undefined, documentUrlAttachment?: string | null | undefined }> }, makerVettingSurveys: { __typename?: 'MakerVettingSurveyConnection', nodes: Array<{ __typename?: 'MakerVettingSurvey', id: string, completedAt?: string | null | undefined, approvedAt?: string | null | undefined, editUrl: string, completedBy?: { __typename?: 'Contact', id: string, fullName?: string | null | undefined, email?: string | null | undefined, jobTitle?: string | null | undefined } | null | undefined, approvedBy?: { __typename?: 'User', id: string, fullName: string } | null | undefined, surveys: Array<{ __typename?: 'Attachment', filename: string, downloadUrl: string }> }> }, makerAudits: { __typename?: 'MakerAuditConnection', nodes: Array<{ __typename?: 'MakerAudit', id: string, name?: string | null | undefined, dateOfCompletion?: string | null | undefined, expirationDate?: string | null | undefined, performedBy?: string | null | undefined, results?: string | null | undefined, editUrl: string, documents: Array<{ __typename?: 'Attachment', filename: string, downloadUrl: string }> }> }, makerDocuments: { __typename?: 'MakerDocumentConnection', nodes: Array<{ __typename?: 'MakerDocument', id: string, createdAt: string, documentType: string, fileName?: string | null | undefined, editUrl: string, documentUrlInline?: string | null | undefined, documentUrlAttachment?: string | null | undefined }> } } };

export type MakerDocumentsFragment = { __typename?: 'Maker', id: string, editUrl: string, newMakerCertificationUrl: string, newMakerNdaUrl: string, newMakerVettingSurveyUrl: string, newMakerAuditUrl: string, newMakerDocumentUrl: string, makerCertifications: { __typename?: 'MakerCertificationConnection', nodes: Array<{ __typename?: 'MakerCertification', id: string, certifier?: string | null | undefined, activeFrom?: string | null | undefined, expiredAt?: string | null | undefined, editUrl: string, documentUrlInline?: string | null | undefined, documentUrlAttachment?: string | null | undefined, certification: { __typename?: 'Certification', id: string, name: string, icon: { __typename?: 'Attachment', imgixUrl: string } } }> }, makerNdas: { __typename?: 'MakerNdaConnection', nodes: Array<{ __typename?: 'MakerNda', id: string, documentType: string, signedByName: string, signedByPosition: string, dateOfSignature: string, expirationDate?: string | null | undefined, editUrl: string, documentUrlInline?: string | null | undefined, documentUrlAttachment?: string | null | undefined }> }, makerVettingSurveys: { __typename?: 'MakerVettingSurveyConnection', nodes: Array<{ __typename?: 'MakerVettingSurvey', id: string, completedAt?: string | null | undefined, approvedAt?: string | null | undefined, editUrl: string, completedBy?: { __typename?: 'Contact', id: string, fullName?: string | null | undefined, email?: string | null | undefined, jobTitle?: string | null | undefined } | null | undefined, approvedBy?: { __typename?: 'User', id: string, fullName: string } | null | undefined, surveys: Array<{ __typename?: 'Attachment', filename: string, downloadUrl: string }> }> }, makerAudits: { __typename?: 'MakerAuditConnection', nodes: Array<{ __typename?: 'MakerAudit', id: string, name?: string | null | undefined, dateOfCompletion?: string | null | undefined, expirationDate?: string | null | undefined, performedBy?: string | null | undefined, results?: string | null | undefined, editUrl: string, documents: Array<{ __typename?: 'Attachment', filename: string, downloadUrl: string }> }> }, makerDocuments: { __typename?: 'MakerDocumentConnection', nodes: Array<{ __typename?: 'MakerDocument', id: string, createdAt: string, documentType: string, fileName?: string | null | undefined, editUrl: string, documentUrlInline?: string | null | undefined, documentUrlAttachment?: string | null | undefined }> } };

export type DownloadAttachmentFragment = { __typename?: 'Attachment', filename: string, downloadUrl: string };

export type MakerEditQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type MakerEditQuery = { __typename?: 'Query', maker: { __typename?: 'Maker', id: string, slug: string, name: string, brandName?: string | null | undefined, logoUrlWithFallback: string, fallbackLogoUrl: string, updatedAt: string, vettingStatus?: string | null | undefined, orderStatus?: string | null | undefined, status: MakerStatus, showUrl: string, editUrl: string, ttmMakerSince?: string | null | undefined, url?: string | null | undefined, makerTypes: Array<string>, environments: Array<string>, capabilities: Array<string>, moqPriceCents?: number | null | undefined, moqUnits?: number | null | undefined, moqNotes?: string | null | undefined, productionCapacity?: string | null | undefined, productionCapacityNotes?: string | null | undefined, internalNotes?: string | null | undefined, profile?: string | null | undefined, licenses: Array<string>, customers: Array<string>, socialImpactDescription?: string | null | undefined, environmentalImpactDescription?: string | null | undefined, funFact?: string | null | undefined, hangTagLanguage?: string | null | undefined, numberOfEmployees?: string | null | undefined, numberOfWomenEmployees?: number | null | undefined, score?: number | null | undefined, internalOperationNotes?: string | null | undefined, exportExperience?: string | null | undefined, address?: string | null | undefined, resourceUrl: string, newMakerMarketingImageUrl: string, newMakerProductCategoryUrl: string, newMakerMaterialUrl: string, orderStatusOptions: Array<string>, makerTypeOptions: Array<string>, makerEnvironmentsOptions: Array<string>, makerCapabilitiesOptions: Array<string>, customersOptions: Array<string>, licensesOptions: Array<string>, vettingStatusOptions: Array<string>, productionCapacityOptions: Array<string>, countries: { __typename?: 'CountryConnection', nodes: Array<{ __typename?: 'Country', id: string, name: string }> }, countriesOptions: Array<{ __typename?: 'Country', id: string, name: string }>, valueAlignments: Array<{ __typename?: 'ValueAlignment', id: string, name: string }>, valueAlignmentsOptions: Array<{ __typename?: 'ValueAlignment', id: string, name: string }>, incoterms: { __typename?: 'IncotermConnection', nodes: Array<{ __typename?: 'Incoterm', id: string, name: string }> }, incotermsOptions: Array<{ __typename?: 'Incoterm', id: string, name: string }>, parcelCarriers: { __typename?: 'ParcelCarrierConnection', nodes: Array<{ __typename?: 'ParcelCarrier', id: string, name: string }> }, parcelCarriersOptions: Array<{ __typename?: 'ParcelCarrier', id: string, name: string }>, makerCertifications: { __typename?: 'MakerCertificationConnection', nodes: Array<{ __typename?: 'MakerCertification', certificationType: string }> }, makerMarketingImages: { __typename?: 'MakerMarketingImageConnection', nodes: Array<{ __typename?: 'MakerMarketingImage', id: string, imgixUrl: string, filename: string, editUrl: string, resourceUrl: string, includeInImpactReport: boolean, discardedAt?: string | null | undefined }> }, makerMaterials: { __typename?: 'MakerMaterialConnection', nodes: Array<{ __typename?: 'MakerMaterial', id: string, editUrl: string, material: { __typename?: 'Material', id: string, name: string }, materialSubcategories: { __typename?: 'MaterialSubcategoryConnection', nodes: Array<{ __typename?: 'MaterialSubcategory', id: string, name: string }> } }> }, makerProductCategories: { __typename?: 'MakerProductCategoryConnection', nodes: Array<{ __typename?: 'MakerProductCategory', id: string, editUrl: string, productCategory: { __typename?: 'ProductCategory', id: string, name: string }, productSubcategories: { __typename?: 'ProductSubcategoryConnection', nodes: Array<{ __typename?: 'ProductSubcategory', id: string, name?: string | null | undefined }> } }> }, makerMakerQuestions: { __typename?: 'MakerMakerQuestionConnection', nodes: Array<{ __typename?: 'MakerMakerQuestion', id: string, response?: boolean | null | undefined, responseText?: string | null | undefined, makerQuestionId: string }> }, makerQuestions: { __typename?: 'MakerQuestionConnection', nodes: Array<{ __typename?: 'MakerQuestion', id: string, question: string }> }, makerMakerAttributes: { __typename?: 'MakerMakerAttributeConnection', nodes: Array<{ __typename?: 'MakerMakerAttribute', id: string, response?: boolean | null | undefined, responseText?: string | null | undefined, makerAttributeId: string }> }, makerAttributes: { __typename?: 'MakerAttributeConnection', nodes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }> } } };

export type MakerEditMakerFragment = { __typename?: 'Maker', id: string, slug: string, name: string, brandName?: string | null | undefined, logoUrlWithFallback: string, fallbackLogoUrl: string, updatedAt: string, vettingStatus?: string | null | undefined, orderStatus?: string | null | undefined, status: MakerStatus, showUrl: string, editUrl: string, ttmMakerSince?: string | null | undefined, url?: string | null | undefined, makerTypes: Array<string>, environments: Array<string>, capabilities: Array<string>, moqPriceCents?: number | null | undefined, moqUnits?: number | null | undefined, moqNotes?: string | null | undefined, productionCapacity?: string | null | undefined, productionCapacityNotes?: string | null | undefined, internalNotes?: string | null | undefined, profile?: string | null | undefined, licenses: Array<string>, customers: Array<string>, socialImpactDescription?: string | null | undefined, environmentalImpactDescription?: string | null | undefined, funFact?: string | null | undefined, hangTagLanguage?: string | null | undefined, numberOfEmployees?: string | null | undefined, numberOfWomenEmployees?: number | null | undefined, score?: number | null | undefined, internalOperationNotes?: string | null | undefined, exportExperience?: string | null | undefined, address?: string | null | undefined, resourceUrl: string, newMakerMarketingImageUrl: string, newMakerProductCategoryUrl: string, newMakerMaterialUrl: string, orderStatusOptions: Array<string>, makerTypeOptions: Array<string>, makerEnvironmentsOptions: Array<string>, makerCapabilitiesOptions: Array<string>, customersOptions: Array<string>, licensesOptions: Array<string>, vettingStatusOptions: Array<string>, productionCapacityOptions: Array<string>, countries: { __typename?: 'CountryConnection', nodes: Array<{ __typename?: 'Country', id: string, name: string }> }, countriesOptions: Array<{ __typename?: 'Country', id: string, name: string }>, valueAlignments: Array<{ __typename?: 'ValueAlignment', id: string, name: string }>, valueAlignmentsOptions: Array<{ __typename?: 'ValueAlignment', id: string, name: string }>, incoterms: { __typename?: 'IncotermConnection', nodes: Array<{ __typename?: 'Incoterm', id: string, name: string }> }, incotermsOptions: Array<{ __typename?: 'Incoterm', id: string, name: string }>, parcelCarriers: { __typename?: 'ParcelCarrierConnection', nodes: Array<{ __typename?: 'ParcelCarrier', id: string, name: string }> }, parcelCarriersOptions: Array<{ __typename?: 'ParcelCarrier', id: string, name: string }>, makerCertifications: { __typename?: 'MakerCertificationConnection', nodes: Array<{ __typename?: 'MakerCertification', certificationType: string }> }, makerMarketingImages: { __typename?: 'MakerMarketingImageConnection', nodes: Array<{ __typename?: 'MakerMarketingImage', id: string, imgixUrl: string, filename: string, editUrl: string, resourceUrl: string, includeInImpactReport: boolean, discardedAt?: string | null | undefined }> }, makerMaterials: { __typename?: 'MakerMaterialConnection', nodes: Array<{ __typename?: 'MakerMaterial', id: string, editUrl: string, material: { __typename?: 'Material', id: string, name: string }, materialSubcategories: { __typename?: 'MaterialSubcategoryConnection', nodes: Array<{ __typename?: 'MaterialSubcategory', id: string, name: string }> } }> }, makerProductCategories: { __typename?: 'MakerProductCategoryConnection', nodes: Array<{ __typename?: 'MakerProductCategory', id: string, editUrl: string, productCategory: { __typename?: 'ProductCategory', id: string, name: string }, productSubcategories: { __typename?: 'ProductSubcategoryConnection', nodes: Array<{ __typename?: 'ProductSubcategory', id: string, name?: string | null | undefined }> } }> }, makerMakerQuestions: { __typename?: 'MakerMakerQuestionConnection', nodes: Array<{ __typename?: 'MakerMakerQuestion', id: string, response?: boolean | null | undefined, responseText?: string | null | undefined, makerQuestionId: string }> }, makerQuestions: { __typename?: 'MakerQuestionConnection', nodes: Array<{ __typename?: 'MakerQuestion', id: string, question: string }> }, makerMakerAttributes: { __typename?: 'MakerMakerAttributeConnection', nodes: Array<{ __typename?: 'MakerMakerAttribute', id: string, response?: boolean | null | undefined, responseText?: string | null | undefined, makerAttributeId: string }> }, makerAttributes: { __typename?: 'MakerAttributeConnection', nodes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }> } };

export type MakerOrderEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MakerOrderEditQuery = { __typename?: 'Query', makerOrder: { __typename?: 'MakerOrder', id: string, label: string, showUrl: string, status?: string | null | undefined, makerShowUrl: string, makerLegalAgreementsUrl: string, incotermsUrl: string, makerLegalAgreementId?: string | null | undefined, incotermId?: string | null | undefined, mailCarrierId?: string | null | undefined, inHandsOn?: string | null | undefined, exFactoryDate?: string | null | undefined, moCutDate?: string | null | undefined, productionNotes?: string | null | undefined, trackingInfo?: string | null | undefined, packingAndShippingNotes?: string | null | undefined, clientInfoVisibleToMaker: boolean, paymentTerms?: string | null | undefined, addressesUrl: string, issuedTo?: string | null | undefined, billingConsigneeAddress?: { __typename?: 'Address', id: string, label: string, plain: string } | null | undefined, billingConsigneeAddressOptions: Array<{ __typename?: 'Address', id: string, label: string, plain: string }>, client: { __typename?: 'Client', id: string, name?: string | null | undefined }, contacts: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, jobTitle?: string | null | undefined }>, clientOrder: { __typename?: 'ClientOrder', shippingAddress?: { __typename?: 'Address', plain: string, label: string, contactName?: string | null | undefined, contactPhone?: string | null | undefined } | null | undefined }, makerLegalAgreementOptions: Array<{ __typename?: 'MakerLegalAgreement', id: string, name: string }>, incotermOptions: Array<{ __typename?: 'Incoterm', id: string, name: string }>, mailCarrierOptions: Array<{ __typename?: 'MailCarrier', id: string, name: string }>, shipment?: { __typename?: 'Shipment', id: string, shippingMode?: string | null | undefined, vesselStatus?: string | null | undefined, customsStatus?: string | null | undefined, finalMileDelivery?: string | null | undefined, departingPortAt?: string | null | undefined, arrivingPortAt?: string | null | undefined, deliveredOn?: string | null | undefined, trackingNumbers?: string | null | undefined, newShipmentDocumentUrl: string, parcelCarrier?: { __typename?: 'ParcelCarrier', id: string, name: string } | null | undefined, arrivalShippingPort?: { __typename?: 'ShippingPort', id: string } | null | undefined, departureShippingPort?: { __typename?: 'ShippingPort', id: string } | null | undefined, shipmentDocuments: Array<{ __typename?: 'ShipmentDocument', id: string, createdAt: string, documentType: string, fileName?: string | null | undefined, editUrl: string }> } | null | undefined, shippingModeOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, vesselStatusOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, customsStatusOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, finalMileDeliveryOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, exportShippingPortOptions: Array<{ __typename?: 'ShippingPort', id: string, port: string }>, importShippingPortOptions: Array<{ __typename?: 'ShippingPort', id: string, port: string }>, parcelCarrierOptions: Array<{ __typename?: 'ParcelCarrier', id: string, name: string }>, contactOptions: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, jobTitle?: string | null | undefined }> } };

export type MakerOrderEditMakerFragment = { __typename?: 'MakerOrder', id: string, label: string, showUrl: string, status?: string | null | undefined, makerShowUrl: string, makerLegalAgreementsUrl: string, incotermsUrl: string, makerLegalAgreementId?: string | null | undefined, incotermId?: string | null | undefined, mailCarrierId?: string | null | undefined, inHandsOn?: string | null | undefined, exFactoryDate?: string | null | undefined, moCutDate?: string | null | undefined, productionNotes?: string | null | undefined, trackingInfo?: string | null | undefined, packingAndShippingNotes?: string | null | undefined, clientInfoVisibleToMaker: boolean, paymentTerms?: string | null | undefined, addressesUrl: string, issuedTo?: string | null | undefined, billingConsigneeAddress?: { __typename?: 'Address', id: string, label: string, plain: string } | null | undefined, billingConsigneeAddressOptions: Array<{ __typename?: 'Address', id: string, label: string, plain: string }>, client: { __typename?: 'Client', id: string, name?: string | null | undefined }, contacts: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, jobTitle?: string | null | undefined }>, clientOrder: { __typename?: 'ClientOrder', shippingAddress?: { __typename?: 'Address', plain: string, label: string, contactName?: string | null | undefined, contactPhone?: string | null | undefined } | null | undefined }, makerLegalAgreementOptions: Array<{ __typename?: 'MakerLegalAgreement', id: string, name: string }>, incotermOptions: Array<{ __typename?: 'Incoterm', id: string, name: string }>, mailCarrierOptions: Array<{ __typename?: 'MailCarrier', id: string, name: string }>, shipment?: { __typename?: 'Shipment', id: string, shippingMode?: string | null | undefined, vesselStatus?: string | null | undefined, customsStatus?: string | null | undefined, finalMileDelivery?: string | null | undefined, departingPortAt?: string | null | undefined, arrivingPortAt?: string | null | undefined, deliveredOn?: string | null | undefined, trackingNumbers?: string | null | undefined, newShipmentDocumentUrl: string, parcelCarrier?: { __typename?: 'ParcelCarrier', id: string, name: string } | null | undefined, arrivalShippingPort?: { __typename?: 'ShippingPort', id: string } | null | undefined, departureShippingPort?: { __typename?: 'ShippingPort', id: string } | null | undefined, shipmentDocuments: Array<{ __typename?: 'ShipmentDocument', id: string, createdAt: string, documentType: string, fileName?: string | null | undefined, editUrl: string }> } | null | undefined, shippingModeOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, vesselStatusOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, customsStatusOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, finalMileDeliveryOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, exportShippingPortOptions: Array<{ __typename?: 'ShippingPort', id: string, port: string }>, importShippingPortOptions: Array<{ __typename?: 'ShippingPort', id: string, port: string }>, parcelCarrierOptions: Array<{ __typename?: 'ParcelCarrier', id: string, name: string }>, contactOptions: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, jobTitle?: string | null | undefined }> };

export type MakerLogisticsQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type MakerLogisticsQuery = { __typename?: 'Query', maker: { __typename?: 'Maker', id: string, address?: string | null | undefined, editUrl: string, newMakerShippingPortUrl: string, exportExperience?: string | null | undefined, internalOperationNotes?: string | null | undefined, newMakerContactUrl: string, exportExperienceOptions: Array<string>, makerShippingPorts: { __typename?: 'MakerShippingPortConnection', nodes: Array<{ __typename?: 'MakerShippingPort', id: string, default: boolean, editUrl: string, shippingPort: { __typename?: 'ShippingPort', id: string, port: string, locationType: ShippingPortLocation, abbreviation?: string | null | undefined, modeOfTransit: ModeOfTransit, country: { __typename?: 'Country', name: string } } }> }, exportingCountries: { __typename?: 'CountryConnection', nodes: Array<{ __typename?: 'Country', id: string, name: string }> }, makerContacts: { __typename?: 'MakerContactConnection', nodes: Array<{ __typename?: 'MakerContact', id: string, editUrl: string, default: boolean, archived: boolean, contact: { __typename?: 'Contact', id: string, fullName?: string | null | undefined, jobTitle?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, timezoneLabel?: string | null | undefined } }> }, incoterms: { __typename?: 'IncotermConnection', nodes: Array<{ __typename?: 'Incoterm', id: string, name: string }> }, parcelCarriers: { __typename?: 'ParcelCarrierConnection', nodes: Array<{ __typename?: 'ParcelCarrier', id: string, name: string }> }, countriesOptions: Array<{ __typename?: 'Country', id: string, name: string }>, incotermsOptions: Array<{ __typename?: 'Incoterm', id: string, name: string }>, parcelCarriersOptions: Array<{ __typename?: 'ParcelCarrier', id: string, name: string }> } };

export type MakerLogisticsFragment = { __typename?: 'Maker', id: string, address?: string | null | undefined, editUrl: string, newMakerShippingPortUrl: string, exportExperience?: string | null | undefined, internalOperationNotes?: string | null | undefined, newMakerContactUrl: string, exportExperienceOptions: Array<string>, makerShippingPorts: { __typename?: 'MakerShippingPortConnection', nodes: Array<{ __typename?: 'MakerShippingPort', id: string, default: boolean, editUrl: string, shippingPort: { __typename?: 'ShippingPort', id: string, port: string, locationType: ShippingPortLocation, abbreviation?: string | null | undefined, modeOfTransit: ModeOfTransit, country: { __typename?: 'Country', name: string } } }> }, exportingCountries: { __typename?: 'CountryConnection', nodes: Array<{ __typename?: 'Country', id: string, name: string }> }, makerContacts: { __typename?: 'MakerContactConnection', nodes: Array<{ __typename?: 'MakerContact', id: string, editUrl: string, default: boolean, archived: boolean, contact: { __typename?: 'Contact', id: string, fullName?: string | null | undefined, jobTitle?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, timezoneLabel?: string | null | undefined } }> }, incoterms: { __typename?: 'IncotermConnection', nodes: Array<{ __typename?: 'Incoterm', id: string, name: string }> }, parcelCarriers: { __typename?: 'ParcelCarrierConnection', nodes: Array<{ __typename?: 'ParcelCarrier', id: string, name: string }> }, countriesOptions: Array<{ __typename?: 'Country', id: string, name: string }>, incotermsOptions: Array<{ __typename?: 'Incoterm', id: string, name: string }>, parcelCarriersOptions: Array<{ __typename?: 'ParcelCarrier', id: string, name: string }> };

export type ContactFragment = { __typename?: 'Contact', id: string, fullName?: string | null | undefined, jobTitle?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, timezoneLabel?: string | null | undefined };

export type ImpactReportSearchFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ImpactReportSearchFilterOptionsQuery = { __typename?: 'Query', impactReportSearchFilterOptions: { __typename?: 'ImpactReportSearchFilterOptions', types: Array<string>, makers: Array<{ __typename?: 'Maker', id: string, name: string }>, clients: Array<{ __typename?: 'Client', id: string, name?: string | null | undefined }> } };

export type MakerOrderHistoryQueryVariables = Exact<{
  makerOrderId: Scalars['ID'];
}>;


export type MakerOrderHistoryQuery = { __typename?: 'Query', makerOrderHistory: { __typename?: 'OrderChangeConnection', nodes: Array<{ __typename?: 'OrderChange', id: string, note?: string | null | undefined, createdAt: string, description: string, responsible?: string | null | undefined, user?: { __typename?: 'User', displayName: string } | null | undefined }> } };

export type MakerOrderSearchFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type MakerOrderSearchFilterOptionsQuery = { __typename?: 'Query', makerOrderSearchFilterOptions: { __typename?: 'MakerOrderSearchFilterOptions', statuses: Array<string>, makers: Array<{ __typename?: 'Maker', id: string, name: string }>, clients: Array<{ __typename?: 'Client', id: string, name?: string | null | undefined }> } };

export type MakerOrderSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  makers?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  clients?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  createdAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  exFactoryDateAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  exFactoryDateBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  inHandsAfter?: InputMaybe<Scalars['ISO8601DateTime']>;
  inHandsBefore?: InputMaybe<Scalars['ISO8601DateTime']>;
  statuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type MakerOrderSearchQuery = { __typename?: 'Query', makerOrders: { __typename?: 'MakerOrderConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined }, nodes: Array<{ __typename?: 'MakerOrder', id: string, humanId: string, showUrl: string, status?: string | null | undefined, humanStatus: string, createdAt: string, exFactoryDate?: string | null | undefined, inHandsOn?: string | null | undefined, clientOrder: { __typename?: 'ClientOrder', description: string }, maker: { __typename?: 'Maker', id: string, name: string, showUrl: string } }> } };

export type MakerOrderListItemFragment = { __typename?: 'MakerOrder', id: string, humanId: string, showUrl: string, status?: string | null | undefined, humanStatus: string, createdAt: string, exFactoryDate?: string | null | undefined, inHandsOn?: string | null | undefined, clientOrder: { __typename?: 'ClientOrder', description: string }, maker: { __typename?: 'Maker', id: string, name: string, showUrl: string } };

export type MakerProfileOrdersQueryVariables = Exact<{
  slug: Scalars['String'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type MakerProfileOrdersQuery = { __typename?: 'Query', maker: { __typename?: 'Maker', makerOrders: { __typename?: 'MakerOrderConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined }, nodes: Array<{ __typename?: 'MakerOrder', id: string, humanId: string, createdAt: string, humanStatus: string, mostRecentEmailSentAt?: string | null | undefined, showUrl: string, clientOrder: { __typename?: 'ClientOrder', id: string, humanId: string, description: string, client: { __typename?: 'Client', id: string, name?: string | null | undefined } } }> } } };

export type MakerOrderShowQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MakerOrderShowQuery = { __typename?: 'Query', makerOrder: { __typename?: 'MakerOrder', id: string, humanId: string, makerId: string, editUrl: string, showUrl: string, newTnaUrl: string, label: string, status?: string | null | undefined, shipmentStatus: string, createdAt: string, updatedAt: string, productionStatusReadable?: string | null | undefined, productCount?: number | null | undefined, totalUnits?: number | null | undefined, totalCost?: number | null | undefined, issuedTo?: string | null | undefined, exFactoryDate?: string | null | undefined, moCutDate?: string | null | undefined, paymentTerms?: string | null | undefined, clientInfoVisibleToMaker: boolean, productionNotes?: string | null | undefined, trackingInfo?: string | null | undefined, packingAndShippingNotes?: string | null | undefined, shared: boolean, countriesOfOrigin?: Array<{ __typename?: 'Country', id: string, name: string }> | null | undefined, incoterm?: { __typename?: 'Incoterm', id: string, name: string } | null | undefined, mailCarrier?: { __typename?: 'MailCarrier', id: string, name: string } | null | undefined, client: { __typename?: 'Client', id: string, name?: string | null | undefined }, contacts: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined, jobTitle?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined }>, billingConsigneeAddress?: { __typename?: 'Address', id: string, label: string, plain: string, contactName?: string | null | undefined, contactPhone?: string | null | undefined } | null | undefined, clientOrder: { __typename?: 'ClientOrder', id: string, showUrl: string, humanId: string, description: string, shippingAddress?: { __typename?: 'Address', id: string, label: string, plain: string, contactName?: string | null | undefined, contactPhone?: string | null | undefined } | null | undefined }, statusOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, shipmentStatusOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, timeAndAction?: { __typename?: 'TimeAndAction', id: string } | null | undefined, sampleOrders?: Array<{ __typename?: 'SampleOrder', id: string, humanId: string, status: string, shipsOn?: string | null | undefined, mailCarrier?: string | null | undefined, trackingNumber?: string | null | undefined, dispatchedOn?: string | null | undefined, notes: string, sampleOrderType?: { __typename?: 'SampleOrderType', name: string, displayName: string } | null | undefined, shippingAddress?: { __typename?: 'Address', id: string, label: string, plain: string, contactName?: string | null | undefined, contactPhone?: string | null | undefined } | null | undefined, sampleOrderSkus?: Array<{ __typename?: 'SampleOrderSku', id: string, quantity: number, sku: { __typename?: 'Sku', id: string, humanId: string } }> | null | undefined }> | null | undefined, shipment?: { __typename?: 'Shipment', id: string, trackingNumbers?: string | null | undefined, shippingMode?: string | null | undefined, vesselStatus?: string | null | undefined, customsStatus?: string | null | undefined, finalMileDelivery?: string | null | undefined, departingPortAt?: string | null | undefined, arrivingPortAt?: string | null | undefined, newShipmentDocumentUrl: string, deliveredOn?: string | null | undefined, departureShippingPort?: { __typename?: 'ShippingPort', id: string, port: string } | null | undefined, arrivalShippingPort?: { __typename?: 'ShippingPort', id: string, port: string } | null | undefined, parcelCarrier?: { __typename?: 'ParcelCarrier', id: string, name: string } | null | undefined, shipmentDocuments: Array<{ __typename?: 'ShipmentDocument', id: string, createdAt: string, documentType: string, fileName?: string | null | undefined, editUrl: string, documentUrlInline?: string | null | undefined, documentUrlAttachment?: string | null | undefined }> } | null | undefined, shippingModeOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, vesselStatusOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, customsStatusOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, finalMileDeliveryOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, maker: { __typename?: 'Maker', id: string, name: string } } };

export type MakerOrderShowMakerFragment = { __typename?: 'MakerOrder', id: string, humanId: string, makerId: string, editUrl: string, showUrl: string, newTnaUrl: string, label: string, status?: string | null | undefined, shipmentStatus: string, createdAt: string, updatedAt: string, productionStatusReadable?: string | null | undefined, productCount?: number | null | undefined, totalUnits?: number | null | undefined, totalCost?: number | null | undefined, issuedTo?: string | null | undefined, exFactoryDate?: string | null | undefined, moCutDate?: string | null | undefined, paymentTerms?: string | null | undefined, clientInfoVisibleToMaker: boolean, productionNotes?: string | null | undefined, trackingInfo?: string | null | undefined, packingAndShippingNotes?: string | null | undefined, shared: boolean, countriesOfOrigin?: Array<{ __typename?: 'Country', id: string, name: string }> | null | undefined, incoterm?: { __typename?: 'Incoterm', id: string, name: string } | null | undefined, mailCarrier?: { __typename?: 'MailCarrier', id: string, name: string } | null | undefined, client: { __typename?: 'Client', id: string, name?: string | null | undefined }, contacts: Array<{ __typename?: 'Contact', id: string, fullName?: string | null | undefined, jobTitle?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined }>, billingConsigneeAddress?: { __typename?: 'Address', id: string, label: string, plain: string, contactName?: string | null | undefined, contactPhone?: string | null | undefined } | null | undefined, clientOrder: { __typename?: 'ClientOrder', id: string, showUrl: string, humanId: string, description: string, shippingAddress?: { __typename?: 'Address', id: string, label: string, plain: string, contactName?: string | null | undefined, contactPhone?: string | null | undefined } | null | undefined }, statusOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, shipmentStatusOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, timeAndAction?: { __typename?: 'TimeAndAction', id: string } | null | undefined, sampleOrders?: Array<{ __typename?: 'SampleOrder', id: string, humanId: string, status: string, shipsOn?: string | null | undefined, mailCarrier?: string | null | undefined, trackingNumber?: string | null | undefined, dispatchedOn?: string | null | undefined, notes: string, sampleOrderType?: { __typename?: 'SampleOrderType', name: string, displayName: string } | null | undefined, shippingAddress?: { __typename?: 'Address', id: string, label: string, plain: string, contactName?: string | null | undefined, contactPhone?: string | null | undefined } | null | undefined, sampleOrderSkus?: Array<{ __typename?: 'SampleOrderSku', id: string, quantity: number, sku: { __typename?: 'Sku', id: string, humanId: string } }> | null | undefined }> | null | undefined, shipment?: { __typename?: 'Shipment', id: string, trackingNumbers?: string | null | undefined, shippingMode?: string | null | undefined, vesselStatus?: string | null | undefined, customsStatus?: string | null | undefined, finalMileDelivery?: string | null | undefined, departingPortAt?: string | null | undefined, arrivingPortAt?: string | null | undefined, newShipmentDocumentUrl: string, deliveredOn?: string | null | undefined, departureShippingPort?: { __typename?: 'ShippingPort', id: string, port: string } | null | undefined, arrivalShippingPort?: { __typename?: 'ShippingPort', id: string, port: string } | null | undefined, parcelCarrier?: { __typename?: 'ParcelCarrier', id: string, name: string } | null | undefined, shipmentDocuments: Array<{ __typename?: 'ShipmentDocument', id: string, createdAt: string, documentType: string, fileName?: string | null | undefined, editUrl: string, documentUrlInline?: string | null | undefined, documentUrlAttachment?: string | null | undefined }> } | null | undefined, shippingModeOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, vesselStatusOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, customsStatusOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, finalMileDeliveryOptions: Array<{ __typename?: 'SelectOption', value: string, label: string }>, maker: { __typename?: 'Maker', id: string, name: string } };

export type MakerSearchFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type MakerSearchFilterOptionsQuery = { __typename?: 'Query', makerSearchFilterOptions: { __typename?: 'MakerSearchFilterOptions', productionCapacities: Array<string>, costRangeEstimates: Array<string>, capabilities: Array<string>, environments: Array<string>, certifications: { __typename?: 'CertificationConnection', nodes: Array<{ __typename?: 'Certification', id: string, name: string }> }, makerAttributes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }>, productCategories: Array<{ __typename?: 'ProductCategory', id: string, name: string, productSubcategories: { __typename?: 'ProductSubcategoryConnection', nodes: Array<{ __typename?: 'ProductSubcategory', id: string, name?: string | null | undefined }> } }>, shippingCountries: Array<{ __typename?: 'Country', id: string, iso3166: string, name: string }>, materials: Array<{ __typename?: 'Material', id: string, name: string, materialSubcategories: { __typename?: 'MaterialSubcategoryConnection', nodes: Array<{ __typename?: 'MaterialSubcategory', id: string, name: string }> } }> } };

export type MakerShowQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type MakerShowQuery = { __typename?: 'Query', maker: { __typename?: 'Maker', id: string, humanId: string, slug: string, name: string, brandName?: string | null | undefined, logoUrlWithFallback: string, updatedAt: string, vettingStatus?: string | null | undefined, orderStatus?: string | null | undefined, status: MakerStatus, editUrl: string, ttmMakerSince?: string | null | undefined, url?: string | null | undefined, makerTypes: Array<string>, environments: Array<string>, capabilities: Array<string>, makerCertificationTypes: Array<string>, moqPriceCents?: number | null | undefined, moqUnits?: number | null | undefined, moqNotes?: string | null | undefined, productionCapacity?: string | null | undefined, productionCapacityNotes?: string | null | undefined, internalNotes?: string | null | undefined, profile?: string | null | undefined, licenses: Array<string>, customers: Array<string>, socialImpactDescription?: string | null | undefined, environmentalImpactDescription?: string | null | undefined, funFact?: string | null | undefined, hangTagLanguage?: string | null | undefined, numberOfEmployees?: string | null | undefined, numberOfWomenEmployees?: number | null | undefined, score?: number | null | undefined, newMakerMarketingImageUrl: string, newMakerProductCategoryUrl: string, newMakerMaterialUrl: string, makerCertifications: { __typename?: 'MakerCertificationConnection', nodes: Array<{ __typename?: 'MakerCertification', certificationType: string, expiredAt?: string | null | undefined }> }, makerContacts: { __typename?: 'MakerContactConnection', nodes: Array<{ __typename?: 'MakerContact', id: string, editUrl: string, default: boolean, archived: boolean, contact: { __typename?: 'Contact', id: string, fullName?: string | null | undefined, jobTitle?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, timezoneLabel?: string | null | undefined } }> }, makerMarketingImages: { __typename?: 'MakerMarketingImageConnection', nodes: Array<{ __typename?: 'MakerMarketingImage', id: string, imgixUrl: string, filename: string, editUrl: string, resourceUrl: string, includeInImpactReport: boolean, description?: string | null | undefined, discardedAt?: string | null | undefined }> }, valueAlignments: Array<{ __typename?: 'ValueAlignment', id: string, name: string }>, materials: { __typename?: 'MaterialConnection', nodes: Array<{ __typename?: 'Material', id: string, name: string }> }, makerMaterials: { __typename?: 'MakerMaterialConnection', nodes: Array<{ __typename?: 'MakerMaterial', id: string, editUrl: string, material: { __typename?: 'Material', id: string, name: string }, materialSubcategories: { __typename?: 'MaterialSubcategoryConnection', nodes: Array<{ __typename?: 'MaterialSubcategory', id: string, name: string }> } }> }, products: { __typename?: 'ProductConnection', nodes: Array<{ __typename?: 'Product', id: string, name?: string | null | undefined, description?: string | null | undefined, showUrl: string, imageWithFallback: { __typename?: 'Image', id: string, imgixUrl: string }, image?: { __typename?: 'Image', id: string, imgixUrl: string } | null | undefined }> }, makerProductCategories: { __typename?: 'MakerProductCategoryConnection', nodes: Array<{ __typename?: 'MakerProductCategory', id: string, editUrl: string, productCategory: { __typename?: 'ProductCategory', id: string, name: string }, productSubcategories: { __typename?: 'ProductSubcategoryConnection', nodes: Array<{ __typename?: 'ProductSubcategory', id: string, name?: string | null | undefined }> } }> }, countries: { __typename?: 'CountryConnection', nodes: Array<{ __typename?: 'Country', id: string, name: string, region: { __typename?: 'Region', id: string, name: string } }> }, makerMakerQuestions: { __typename?: 'MakerMakerQuestionConnection', nodes: Array<{ __typename?: 'MakerMakerQuestion', id: string, response?: boolean | null | undefined, responseText?: string | null | undefined, makerQuestionId: string }> }, makerQuestions: { __typename?: 'MakerQuestionConnection', nodes: Array<{ __typename?: 'MakerQuestion', id: string, question: string }> }, makerMakerAttributes: { __typename?: 'MakerMakerAttributeConnection', nodes: Array<{ __typename?: 'MakerMakerAttribute', id: string, response?: boolean | null | undefined, responseText?: string | null | undefined, makerAttributeId: string }> }, makerAttributes: { __typename?: 'MakerAttributeConnection', nodes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }> }, makerScore?: { __typename?: 'MakerScore', overallScore: number, overallScorePercentile?: number | null | undefined, coreScore: number, coreScorePercentile?: number | null | undefined, performanceScore?: number | null | undefined, performanceScorePercentile?: number | null | undefined, showBreakdown: boolean, overallValueAlignment: number, certificationsAndAudits: number, amenitiesAndSocialServices: number, environmentalPoliciesAndInitiatives: number, employeePolicies: number, operationalPolicies: number, onboardingParticipation: number, samplingExperience?: number | null | undefined, productionExperience?: number | null | undefined, makerCommunication?: number | null | undefined, sustainableMaterials: number, environmentalFacilities: number, environmentallyFriendly: number, fairtrade: number, fairLaborPractices: number, specialSocialPrograms: number, womenOwned: number, inclusiveOwnership: number, unionGroup: number, bCorp: number, certifications: number, audits: number, generalServices: number, healthcare: number, ppe: number, training: number, socialServices: number, localCommunityServices: number, environmentalPolicy: number, sustainabilityFramework: number, designatedStaff: number, reductionTargets: number, recycling: number, trackingAndReporting: number, riskAssessment: number, hazardousChemicalRecords: number, handbook: number, compensationPolicy: number, leavePolicy: number, harassmentPolicy: number, maternityLeave: number, fireAndSafetyPolicy: number, qualityControlPolicy: number, vettingSurveyCurrency: number, ttmAgreements: number, trainingParticipation: number, samplingTiming?: number | null | undefined, samplingQuality?: number | null | undefined, samplingCost?: number | null | undefined, productionTiming?: number | null | undefined, productionQuality?: number | null | undefined, productionCost?: number | null | undefined, correspondence?: number | null | undefined, communications?: number | null | undefined, platformUse?: number | null | undefined, createdAt: string, updatedAt: string } | null | undefined } };

export type MakerShowMakerFragment = { __typename?: 'Maker', id: string, humanId: string, slug: string, name: string, brandName?: string | null | undefined, logoUrlWithFallback: string, updatedAt: string, vettingStatus?: string | null | undefined, orderStatus?: string | null | undefined, status: MakerStatus, editUrl: string, ttmMakerSince?: string | null | undefined, url?: string | null | undefined, makerTypes: Array<string>, environments: Array<string>, capabilities: Array<string>, makerCertificationTypes: Array<string>, moqPriceCents?: number | null | undefined, moqUnits?: number | null | undefined, moqNotes?: string | null | undefined, productionCapacity?: string | null | undefined, productionCapacityNotes?: string | null | undefined, internalNotes?: string | null | undefined, profile?: string | null | undefined, licenses: Array<string>, customers: Array<string>, socialImpactDescription?: string | null | undefined, environmentalImpactDescription?: string | null | undefined, funFact?: string | null | undefined, hangTagLanguage?: string | null | undefined, numberOfEmployees?: string | null | undefined, numberOfWomenEmployees?: number | null | undefined, score?: number | null | undefined, newMakerMarketingImageUrl: string, newMakerProductCategoryUrl: string, newMakerMaterialUrl: string, makerCertifications: { __typename?: 'MakerCertificationConnection', nodes: Array<{ __typename?: 'MakerCertification', certificationType: string, expiredAt?: string | null | undefined }> }, makerContacts: { __typename?: 'MakerContactConnection', nodes: Array<{ __typename?: 'MakerContact', id: string, editUrl: string, default: boolean, archived: boolean, contact: { __typename?: 'Contact', id: string, fullName?: string | null | undefined, jobTitle?: string | null | undefined, phone?: string | null | undefined, email?: string | null | undefined, timezoneLabel?: string | null | undefined } }> }, makerMarketingImages: { __typename?: 'MakerMarketingImageConnection', nodes: Array<{ __typename?: 'MakerMarketingImage', id: string, imgixUrl: string, filename: string, editUrl: string, resourceUrl: string, includeInImpactReport: boolean, description?: string | null | undefined, discardedAt?: string | null | undefined }> }, valueAlignments: Array<{ __typename?: 'ValueAlignment', id: string, name: string }>, materials: { __typename?: 'MaterialConnection', nodes: Array<{ __typename?: 'Material', id: string, name: string }> }, makerMaterials: { __typename?: 'MakerMaterialConnection', nodes: Array<{ __typename?: 'MakerMaterial', id: string, editUrl: string, material: { __typename?: 'Material', id: string, name: string }, materialSubcategories: { __typename?: 'MaterialSubcategoryConnection', nodes: Array<{ __typename?: 'MaterialSubcategory', id: string, name: string }> } }> }, products: { __typename?: 'ProductConnection', nodes: Array<{ __typename?: 'Product', id: string, name?: string | null | undefined, description?: string | null | undefined, showUrl: string, imageWithFallback: { __typename?: 'Image', id: string, imgixUrl: string }, image?: { __typename?: 'Image', id: string, imgixUrl: string } | null | undefined }> }, makerProductCategories: { __typename?: 'MakerProductCategoryConnection', nodes: Array<{ __typename?: 'MakerProductCategory', id: string, editUrl: string, productCategory: { __typename?: 'ProductCategory', id: string, name: string }, productSubcategories: { __typename?: 'ProductSubcategoryConnection', nodes: Array<{ __typename?: 'ProductSubcategory', id: string, name?: string | null | undefined }> } }> }, countries: { __typename?: 'CountryConnection', nodes: Array<{ __typename?: 'Country', id: string, name: string, region: { __typename?: 'Region', id: string, name: string } }> }, makerMakerQuestions: { __typename?: 'MakerMakerQuestionConnection', nodes: Array<{ __typename?: 'MakerMakerQuestion', id: string, response?: boolean | null | undefined, responseText?: string | null | undefined, makerQuestionId: string }> }, makerQuestions: { __typename?: 'MakerQuestionConnection', nodes: Array<{ __typename?: 'MakerQuestion', id: string, question: string }> }, makerMakerAttributes: { __typename?: 'MakerMakerAttributeConnection', nodes: Array<{ __typename?: 'MakerMakerAttribute', id: string, response?: boolean | null | undefined, responseText?: string | null | undefined, makerAttributeId: string }> }, makerAttributes: { __typename?: 'MakerAttributeConnection', nodes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }> }, makerScore?: { __typename?: 'MakerScore', overallScore: number, overallScorePercentile?: number | null | undefined, coreScore: number, coreScorePercentile?: number | null | undefined, performanceScore?: number | null | undefined, performanceScorePercentile?: number | null | undefined, showBreakdown: boolean, overallValueAlignment: number, certificationsAndAudits: number, amenitiesAndSocialServices: number, environmentalPoliciesAndInitiatives: number, employeePolicies: number, operationalPolicies: number, onboardingParticipation: number, samplingExperience?: number | null | undefined, productionExperience?: number | null | undefined, makerCommunication?: number | null | undefined, sustainableMaterials: number, environmentalFacilities: number, environmentallyFriendly: number, fairtrade: number, fairLaborPractices: number, specialSocialPrograms: number, womenOwned: number, inclusiveOwnership: number, unionGroup: number, bCorp: number, certifications: number, audits: number, generalServices: number, healthcare: number, ppe: number, training: number, socialServices: number, localCommunityServices: number, environmentalPolicy: number, sustainabilityFramework: number, designatedStaff: number, reductionTargets: number, recycling: number, trackingAndReporting: number, riskAssessment: number, hazardousChemicalRecords: number, handbook: number, compensationPolicy: number, leavePolicy: number, harassmentPolicy: number, maternityLeave: number, fireAndSafetyPolicy: number, qualityControlPolicy: number, vettingSurveyCurrency: number, ttmAgreements: number, trainingParticipation: number, samplingTiming?: number | null | undefined, samplingQuality?: number | null | undefined, samplingCost?: number | null | undefined, productionTiming?: number | null | undefined, productionQuality?: number | null | undefined, productionCost?: number | null | undefined, correspondence?: number | null | undefined, communications?: number | null | undefined, platformUse?: number | null | undefined, createdAt: string, updatedAt: string } | null | undefined };

export type ProductAttributeListFragment = { __typename?: 'Product', productAttributes: Array<{ __typename?: 'ProductAttribute', name: string, icon: { __typename?: 'Attachment', imgixUrl: string } }> };

export type ProductEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductEditQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, updatedAt: string, status: ProductStatus, name?: string | null | undefined, description?: string | null | undefined, styleNumber?: string | null | undefined, productionMethod?: string | null | undefined, htsCode?: string | null | undefined, fabricType?: string | null | undefined, availableUntil?: string | null | undefined, internalNotes?: string | null | undefined, showUrl: string, resourceUrl: string, newProductCategoryUrl: string, newProductMaterialUrl: string, newProductNameAliasUrl: string, newProductSkuAliasUrl: string, makerName?: string | null | undefined, variantName?: string | null | undefined, newNpaVariantUrl: string, makerTypes: Array<string>, environments: Array<string>, makerCapabilities: Array<string>, makerTypeOptions: Array<string>, environmentsOptions: Array<string>, makerCapabilitiesOptions: Array<string>, htsCodeOptions: Array<string>, fabricTypeOptions: Array<string>, productionMethodOptions: Array<string>, socialImpactMetricsEnabled: boolean, fairWagePerHour?: number | null | undefined, equivalencesEnabled: boolean, landSavedFromPesticidesM2?: number | null | undefined, drivingEmissionsAvoidedKm?: number | null | undefined, bulbEnergySavedHours?: number | null | undefined, drinkingWaterSavedDays?: number | null | undefined, environmentalImpactMetricsEnabled: boolean, energyConservedKwh?: number | null | undefined, waterSavedLiters?: number | null | undefined, emissionsAvoidedKg?: number | null | undefined, pesticidesAvoidedG?: number | null | undefined, wasteDivertedG?: number | null | undefined, recycledWaterBottles?: number | null | undefined, carbonOffsetMetricsEnabled: boolean, carbonOffsetKg?: number | null | undefined, carbonOffsetAsKmOfDriving?: number | null | undefined, carbonOffsetAsTransatlanticFlights?: number | null | undefined, carbonOffsetAsPhonesCharged?: number | null | undefined, dimension?: { __typename?: 'Dimension', weightKg?: number | null | undefined, heightCm?: number | null | undefined, widthCm?: number | null | undefined, lengthCm?: number | null | undefined } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, name: string, dimension?: { __typename?: 'Dimension', id: string, weightKg?: number | null | undefined, heightCm?: number | null | undefined, widthCm?: number | null | undefined, lengthCm?: number | null | undefined } | null | undefined }>, npaVariants: Array<{ __typename?: 'NpaVariant', id: string, name: string, editUrl: string, npaVariantOptions: Array<{ __typename?: 'NpaVariantOption', id: string, name: string, makerName?: string | null | undefined, position?: number | null | undefined }> }>, countryOptions: Array<{ __typename?: 'Country', id: string, nameWithFlag: string }>, npaVariantTemplateOptions: Array<{ __typename?: 'NpaVariantTemplate', id: string, name: string, npaVariantTemplateOptions: Array<{ __typename?: 'NpaVariantTemplateOption', id: string, name?: string | null | undefined }> }>, maker: { __typename?: 'Maker', name: string, showUrl: string }, makerCountry?: { __typename?: 'Country', id: string, name: string } | null | undefined, shipsFromCountry?: { __typename?: 'Country', id: string, name: string } | null | undefined, countryOfOrigin?: { __typename?: 'Country', id: string, name: string } | null | undefined, imageWithFallback: { __typename?: 'Image', id: string, imgixUrl: string }, image?: { __typename?: 'Image', id: string, imgixUrl: string } | null | undefined, images: Array<{ __typename?: 'Image', id: string, imgixUrl: string, filename: string }>, infoImages: Array<{ __typename?: 'Image', id: string, imgixUrl: string, filename: string }>, techPack?: { __typename?: 'Attachment', filename: string } | null | undefined, makerAttributes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }>, selectedMakerAttributes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }>, valueAlignments: Array<{ __typename?: 'ValueAlignment', id: string, name: string }>, valueAlignmentsOptions: Array<{ __typename?: 'ValueAlignment', id: string, name: string }>, productAttributes: Array<{ __typename?: 'ProductAttribute', id: string, name: string }>, productAttributeOptions: Array<{ __typename?: 'ProductAttribute', id: string, name: string }>, productProductCategories: { __typename?: 'ProductProductCategoryConnection', nodes: Array<{ __typename?: 'ProductProductCategory', id: string, editUrl: string, productCategory: { __typename?: 'ProductCategory', id: string, name: string }, productSubcategories: { __typename?: 'ProductSubcategoryConnection', nodes: Array<{ __typename?: 'ProductSubcategory', id: string, name?: string | null | undefined }> } }> }, productCategories: Array<{ __typename?: 'ProductCategory', id: string, name: string, productSubcategories: { __typename?: 'ProductSubcategoryConnection', nodes: Array<{ __typename?: 'ProductSubcategory', id: string, name?: string | null | undefined }> } }>, productMaterials: { __typename?: 'ProductMaterialConnection', nodes: Array<{ __typename?: 'ProductMaterial', id: string, editUrl: string, material: { __typename?: 'Material', name: string }, materialSubcategories: { __typename?: 'MaterialSubcategoryConnection', nodes: Array<{ __typename?: 'MaterialSubcategory', id: string, name: string }> } }> }, nameAliases: Array<{ __typename?: 'ProductNameAlias', id: string, name: string, createdAt: string, editUrl: string, resourceUrl: string }>, skuAliases: Array<{ __typename?: 'ProductSkuAlias', id: string, sku: string, createdAt: string, editUrl: string, resourceUrl: string }> } };

export type ProductEditMakerFragment = { __typename?: 'Product', id: string, updatedAt: string, status: ProductStatus, name?: string | null | undefined, description?: string | null | undefined, styleNumber?: string | null | undefined, productionMethod?: string | null | undefined, htsCode?: string | null | undefined, fabricType?: string | null | undefined, availableUntil?: string | null | undefined, internalNotes?: string | null | undefined, showUrl: string, resourceUrl: string, newProductCategoryUrl: string, newProductMaterialUrl: string, newProductNameAliasUrl: string, newProductSkuAliasUrl: string, makerName?: string | null | undefined, variantName?: string | null | undefined, newNpaVariantUrl: string, makerTypes: Array<string>, environments: Array<string>, makerCapabilities: Array<string>, makerTypeOptions: Array<string>, environmentsOptions: Array<string>, makerCapabilitiesOptions: Array<string>, htsCodeOptions: Array<string>, fabricTypeOptions: Array<string>, productionMethodOptions: Array<string>, socialImpactMetricsEnabled: boolean, fairWagePerHour?: number | null | undefined, equivalencesEnabled: boolean, landSavedFromPesticidesM2?: number | null | undefined, drivingEmissionsAvoidedKm?: number | null | undefined, bulbEnergySavedHours?: number | null | undefined, drinkingWaterSavedDays?: number | null | undefined, environmentalImpactMetricsEnabled: boolean, energyConservedKwh?: number | null | undefined, waterSavedLiters?: number | null | undefined, emissionsAvoidedKg?: number | null | undefined, pesticidesAvoidedG?: number | null | undefined, wasteDivertedG?: number | null | undefined, recycledWaterBottles?: number | null | undefined, carbonOffsetMetricsEnabled: boolean, carbonOffsetKg?: number | null | undefined, carbonOffsetAsKmOfDriving?: number | null | undefined, carbonOffsetAsTransatlanticFlights?: number | null | undefined, carbonOffsetAsPhonesCharged?: number | null | undefined, dimension?: { __typename?: 'Dimension', weightKg?: number | null | undefined, heightCm?: number | null | undefined, widthCm?: number | null | undefined, lengthCm?: number | null | undefined } | null | undefined, variants: Array<{ __typename?: 'Variant', id: string, name: string, dimension?: { __typename?: 'Dimension', id: string, weightKg?: number | null | undefined, heightCm?: number | null | undefined, widthCm?: number | null | undefined, lengthCm?: number | null | undefined } | null | undefined }>, npaVariants: Array<{ __typename?: 'NpaVariant', id: string, name: string, editUrl: string, npaVariantOptions: Array<{ __typename?: 'NpaVariantOption', id: string, name: string, makerName?: string | null | undefined, position?: number | null | undefined }> }>, countryOptions: Array<{ __typename?: 'Country', id: string, nameWithFlag: string }>, npaVariantTemplateOptions: Array<{ __typename?: 'NpaVariantTemplate', id: string, name: string, npaVariantTemplateOptions: Array<{ __typename?: 'NpaVariantTemplateOption', id: string, name?: string | null | undefined }> }>, maker: { __typename?: 'Maker', name: string, showUrl: string }, makerCountry?: { __typename?: 'Country', id: string, name: string } | null | undefined, shipsFromCountry?: { __typename?: 'Country', id: string, name: string } | null | undefined, countryOfOrigin?: { __typename?: 'Country', id: string, name: string } | null | undefined, imageWithFallback: { __typename?: 'Image', id: string, imgixUrl: string }, image?: { __typename?: 'Image', id: string, imgixUrl: string } | null | undefined, images: Array<{ __typename?: 'Image', id: string, imgixUrl: string, filename: string }>, infoImages: Array<{ __typename?: 'Image', id: string, imgixUrl: string, filename: string }>, techPack?: { __typename?: 'Attachment', filename: string } | null | undefined, makerAttributes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }>, selectedMakerAttributes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }>, valueAlignments: Array<{ __typename?: 'ValueAlignment', id: string, name: string }>, valueAlignmentsOptions: Array<{ __typename?: 'ValueAlignment', id: string, name: string }>, productAttributes: Array<{ __typename?: 'ProductAttribute', id: string, name: string }>, productAttributeOptions: Array<{ __typename?: 'ProductAttribute', id: string, name: string }>, productProductCategories: { __typename?: 'ProductProductCategoryConnection', nodes: Array<{ __typename?: 'ProductProductCategory', id: string, editUrl: string, productCategory: { __typename?: 'ProductCategory', id: string, name: string }, productSubcategories: { __typename?: 'ProductSubcategoryConnection', nodes: Array<{ __typename?: 'ProductSubcategory', id: string, name?: string | null | undefined }> } }> }, productCategories: Array<{ __typename?: 'ProductCategory', id: string, name: string, productSubcategories: { __typename?: 'ProductSubcategoryConnection', nodes: Array<{ __typename?: 'ProductSubcategory', id: string, name?: string | null | undefined }> } }>, productMaterials: { __typename?: 'ProductMaterialConnection', nodes: Array<{ __typename?: 'ProductMaterial', id: string, editUrl: string, material: { __typename?: 'Material', name: string }, materialSubcategories: { __typename?: 'MaterialSubcategoryConnection', nodes: Array<{ __typename?: 'MaterialSubcategory', id: string, name: string }> } }> }, nameAliases: Array<{ __typename?: 'ProductNameAlias', id: string, name: string, createdAt: string, editUrl: string, resourceUrl: string }>, skuAliases: Array<{ __typename?: 'ProductSkuAlias', id: string, sku: string, createdAt: string, editUrl: string, resourceUrl: string }> };

export type ProductGroupEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductGroupEditQuery = { __typename?: 'Query', productGroup: { __typename?: 'ProductGroup', id: string, name: string, humanId: string, updatedAt: string, status: ProductGroupStatus, showUrl: string, description?: string | null | undefined, htsCode?: string | null | undefined, newProductGroupNameAliasUrl: string, newProductGroupStyleNumberAliasUrl: string, htsCodeOptions: Array<string>, fabricTypeOptions: Array<string>, countries: { __typename?: 'CountryConnection', nodes: Array<{ __typename?: 'Country', id: string, name: string, region: { __typename?: 'Region', id: string, name: string } }> }, images: Array<{ __typename?: 'Image', id: string, imgixUrl: string, filename: string }>, techPack?: { __typename?: 'Attachment', filename: string, url: string } | null | undefined, nameAliases: Array<{ __typename?: 'ProductGroupNameAlias', id: string, name: string, createdAt: string, editUrl: string, resourceUrl: string }>, styleNumberAliases: Array<{ __typename?: 'ProductGroupStyleNumberAlias', id: string, styleNumber: string, createdAt: string, editUrl: string, resourceUrl: string }>, productCategories: Array<{ __typename?: 'ProductCategory', name: string }> } };

export type ProductGroupEditMakerFragment = { __typename?: 'ProductGroup', id: string, name: string, humanId: string, updatedAt: string, status: ProductGroupStatus, showUrl: string, description?: string | null | undefined, htsCode?: string | null | undefined, newProductGroupNameAliasUrl: string, newProductGroupStyleNumberAliasUrl: string, htsCodeOptions: Array<string>, fabricTypeOptions: Array<string>, countries: { __typename?: 'CountryConnection', nodes: Array<{ __typename?: 'Country', id: string, name: string, region: { __typename?: 'Region', id: string, name: string } }> }, images: Array<{ __typename?: 'Image', id: string, imgixUrl: string, filename: string }>, techPack?: { __typename?: 'Attachment', filename: string, url: string } | null | undefined, nameAliases: Array<{ __typename?: 'ProductGroupNameAlias', id: string, name: string, createdAt: string, editUrl: string, resourceUrl: string }>, styleNumberAliases: Array<{ __typename?: 'ProductGroupStyleNumberAlias', id: string, styleNumber: string, createdAt: string, editUrl: string, resourceUrl: string }>, productCategories: Array<{ __typename?: 'ProductCategory', name: string }> };

export type ProductGroupShowQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductGroupShowQuery = { __typename?: 'Query', productGroup: { __typename?: 'ProductGroup', id: string, name: string, humanId: string, updatedAt: string, status: ProductGroupStatus, editUrl: string, newProductUrl: string, makerName?: string | null | undefined, description?: string | null | undefined, htsCode?: string | null | undefined, previousBuyers: Array<string>, environments: Array<string>, makerCertificationTypes: Array<string>, productionMethods: Array<string>, makerCountries: Array<{ __typename?: 'Country', name: string }>, countries: { __typename?: 'CountryConnection', nodes: Array<{ __typename?: 'Country', id: string, name: string, region: { __typename?: 'Region', id: string, name: string } }> }, images: Array<{ __typename?: 'Image', id: string, imgixUrl: string, filename: string }>, techPack?: { __typename?: 'Attachment', filename: string, url: string } | null | undefined, nameAliases: Array<{ __typename?: 'ProductGroupNameAlias', id: string, name: string, createdAt: string }>, styleNumberAliases: Array<{ __typename?: 'ProductGroupStyleNumberAlias', id: string, styleNumber: string, createdAt: string }>, productCategories: Array<{ __typename?: 'ProductCategory', name: string }>, valueAlignments: Array<{ __typename?: 'ValueAlignment', name: string }>, makerAttributes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }>, products: Array<{ __typename?: 'Product', id: string, name?: string | null | undefined, humanId: string, description?: string | null | undefined, variantName?: string | null | undefined, maxCapacity?: number | null | undefined, availableUntil?: string | null | undefined, showUrl: string, duplicateUrl: string, materials: { __typename?: 'MaterialConnection', nodes: Array<{ __typename?: 'Material', id: string, name: string }> }, countryOfOrigin?: { __typename?: 'Country', name: string } | null | undefined, images: Array<{ __typename?: 'Image', id: string, imgixUrl: string }>, variants: Array<{ __typename?: 'Variant', id: string, name: string }>, npaVariants: Array<{ __typename?: 'NpaVariant', id: string, name: string }> }>, maker: { __typename?: 'Maker', name: string, editUrl: string, makerTypes: Array<string>, capabilities: Array<string>, socialImpactDescription?: string | null | undefined, environmentalImpactDescription?: string | null | undefined, countries: { __typename?: 'CountryConnection', nodes: Array<{ __typename?: 'Country', name: string }> }, shippingPorts: { __typename?: 'ShippingPortConnection', nodes: Array<{ __typename?: 'ShippingPort', port: string }> } } } };

export type ProductGroupShowMakerFragment = { __typename?: 'ProductGroup', id: string, name: string, humanId: string, updatedAt: string, status: ProductGroupStatus, editUrl: string, newProductUrl: string, makerName?: string | null | undefined, description?: string | null | undefined, htsCode?: string | null | undefined, previousBuyers: Array<string>, environments: Array<string>, makerCertificationTypes: Array<string>, productionMethods: Array<string>, makerCountries: Array<{ __typename?: 'Country', name: string }>, countries: { __typename?: 'CountryConnection', nodes: Array<{ __typename?: 'Country', id: string, name: string, region: { __typename?: 'Region', id: string, name: string } }> }, images: Array<{ __typename?: 'Image', id: string, imgixUrl: string, filename: string }>, techPack?: { __typename?: 'Attachment', filename: string, url: string } | null | undefined, nameAliases: Array<{ __typename?: 'ProductGroupNameAlias', id: string, name: string, createdAt: string }>, styleNumberAliases: Array<{ __typename?: 'ProductGroupStyleNumberAlias', id: string, styleNumber: string, createdAt: string }>, productCategories: Array<{ __typename?: 'ProductCategory', name: string }>, valueAlignments: Array<{ __typename?: 'ValueAlignment', name: string }>, makerAttributes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }>, products: Array<{ __typename?: 'Product', id: string, name?: string | null | undefined, humanId: string, description?: string | null | undefined, variantName?: string | null | undefined, maxCapacity?: number | null | undefined, availableUntil?: string | null | undefined, showUrl: string, duplicateUrl: string, materials: { __typename?: 'MaterialConnection', nodes: Array<{ __typename?: 'Material', id: string, name: string }> }, countryOfOrigin?: { __typename?: 'Country', name: string } | null | undefined, images: Array<{ __typename?: 'Image', id: string, imgixUrl: string }>, variants: Array<{ __typename?: 'Variant', id: string, name: string }>, npaVariants: Array<{ __typename?: 'NpaVariant', id: string, name: string }> }>, maker: { __typename?: 'Maker', name: string, editUrl: string, makerTypes: Array<string>, capabilities: Array<string>, socialImpactDescription?: string | null | undefined, environmentalImpactDescription?: string | null | undefined, countries: { __typename?: 'CountryConnection', nodes: Array<{ __typename?: 'Country', name: string }> }, shippingPorts: { __typename?: 'ShippingPortConnection', nodes: Array<{ __typename?: 'ShippingPort', port: string }> } } };

export type ProductProfileOrdersQueryVariables = Exact<{
  id: Scalars['ID'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type ProductProfileOrdersQuery = { __typename?: 'Query', product: { __typename?: 'Product', clientOrders: { __typename?: 'ClientOrderConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined }, nodes: Array<{ __typename?: 'ClientOrder', id: string, humanId: string, totalQuantity: number, perItemPriceRange?: string | null | undefined, msrpRange?: string | null | undefined, showUrl: string, client: { __typename?: 'Client', id: string, name?: string | null | undefined } }> } } };

export type ProductGroupProfilePricingAndLogisticsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductGroupProfilePricingAndLogisticsQuery = { __typename?: 'Query', productGroup: { __typename?: 'ProductGroup', id: string, products: Array<{ __typename?: 'Product', id: string, name?: string | null | undefined, productGroup: { __typename?: 'ProductGroup', id: string, cogsColumns: Array<{ __typename?: 'CogsColumn', id: string, unitsMin: number }> }, variants: Array<{ __typename?: 'Variant', id: string, name: string, costCents?: number | null | undefined, cogsVariantCells: Array<{ __typename?: 'CogsVariantCell', id: string, cogsColumnId: string, turnaroundTimeString: string, perItemAmountCents: number }> }>, skus: Array<{ __typename?: 'Sku', id: string, humanId: string, variant: { __typename?: 'Variant', name: string, htsCode?: string | null | undefined, weightKg?: number | null | undefined, heightCm?: number | null | undefined, widthCm?: number | null | undefined, lengthCm?: number | null | undefined, shippingPriceBy?: string | null | undefined } }> }>, maker: { __typename?: 'Maker', id: string, defaultAirShippingPort?: { __typename?: 'ShippingPort', id: string } | null | undefined, defaultSeaShippingPort?: { __typename?: 'ShippingPort', id: string } | null | undefined, shippingPorts: { __typename?: 'ShippingPortConnection', nodes: Array<{ __typename?: 'ShippingPort', id: string, modeOfTransit: ModeOfTransit }> } } } };

export type ProductGroupProfilePricingAndLogisticsMakerFragment = { __typename?: 'ProductGroup', id: string, products: Array<{ __typename?: 'Product', id: string, name?: string | null | undefined, productGroup: { __typename?: 'ProductGroup', id: string, cogsColumns: Array<{ __typename?: 'CogsColumn', id: string, unitsMin: number }> }, variants: Array<{ __typename?: 'Variant', id: string, name: string, costCents?: number | null | undefined, cogsVariantCells: Array<{ __typename?: 'CogsVariantCell', id: string, cogsColumnId: string, turnaroundTimeString: string, perItemAmountCents: number }> }>, skus: Array<{ __typename?: 'Sku', id: string, humanId: string, variant: { __typename?: 'Variant', name: string, htsCode?: string | null | undefined, weightKg?: number | null | undefined, heightCm?: number | null | undefined, widthCm?: number | null | undefined, lengthCm?: number | null | undefined, shippingPriceBy?: string | null | undefined } }> }>, maker: { __typename?: 'Maker', id: string, defaultAirShippingPort?: { __typename?: 'ShippingPort', id: string } | null | undefined, defaultSeaShippingPort?: { __typename?: 'ShippingPort', id: string } | null | undefined, shippingPorts: { __typename?: 'ShippingPortConnection', nodes: Array<{ __typename?: 'ShippingPort', id: string, modeOfTransit: ModeOfTransit }> } } };

export type ProductProfilePricingAndLogisticsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductProfilePricingAndLogisticsQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, name?: string | null | undefined, variantName?: string | null | undefined, editCogsVariantCellsUrl: string, variants: Array<{ __typename?: 'Variant', id: string, name: string, costCents?: number | null | undefined, cogsVariantCells: Array<{ __typename?: 'CogsVariantCell', id: string, cogsColumnId: string, turnaroundTimeString: string, perItemAmountCents: number }> }>, npaVariants: Array<{ __typename?: 'NpaVariant', id: string, name: string }>, productGroup: { __typename?: 'ProductGroup', id: string, cogsColumns: Array<{ __typename?: 'CogsColumn', id: string, unitsMin: number }> }, skus: Array<{ __typename?: 'Sku', id: string, humanId: string, variant: { __typename?: 'Variant', name: string, htsCode?: string | null | undefined, weightKg?: number | null | undefined, heightCm?: number | null | undefined, widthCm?: number | null | undefined, lengthCm?: number | null | undefined, shippingPriceBy?: string | null | undefined }, npaVariantOptions: Array<{ __typename?: 'NpaVariantOption', id: string, npaVariantId: string, name: string }> }>, maker: { __typename?: 'Maker', id: string, defaultAirShippingPort?: { __typename?: 'ShippingPort', id: string } | null | undefined, defaultSeaShippingPort?: { __typename?: 'ShippingPort', id: string } | null | undefined, shippingPorts: { __typename?: 'ShippingPortConnection', nodes: Array<{ __typename?: 'ShippingPort', id: string, modeOfTransit: ModeOfTransit }> } } } };

export type ProductProfilePricingAndLogisticsMakerFragment = { __typename?: 'Product', id: string, name?: string | null | undefined, variantName?: string | null | undefined, editCogsVariantCellsUrl: string, variants: Array<{ __typename?: 'Variant', id: string, name: string, costCents?: number | null | undefined, cogsVariantCells: Array<{ __typename?: 'CogsVariantCell', id: string, cogsColumnId: string, turnaroundTimeString: string, perItemAmountCents: number }> }>, npaVariants: Array<{ __typename?: 'NpaVariant', id: string, name: string }>, productGroup: { __typename?: 'ProductGroup', id: string, cogsColumns: Array<{ __typename?: 'CogsColumn', id: string, unitsMin: number }> }, skus: Array<{ __typename?: 'Sku', id: string, humanId: string, variant: { __typename?: 'Variant', name: string, htsCode?: string | null | undefined, weightKg?: number | null | undefined, heightCm?: number | null | undefined, widthCm?: number | null | undefined, lengthCm?: number | null | undefined, shippingPriceBy?: string | null | undefined }, npaVariantOptions: Array<{ __typename?: 'NpaVariantOption', id: string, npaVariantId: string, name: string }> }>, maker: { __typename?: 'Maker', id: string, defaultAirShippingPort?: { __typename?: 'ShippingPort', id: string } | null | undefined, defaultSeaShippingPort?: { __typename?: 'ShippingPort', id: string } | null | undefined, shippingPorts: { __typename?: 'ShippingPortConnection', nodes: Array<{ __typename?: 'ShippingPort', id: string, modeOfTransit: ModeOfTransit }> } } };

export type ProductProfileTestingAndComplianceQueryVariables = Exact<{
  id: Scalars['ID'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type ProductProfileTestingAndComplianceQuery = { __typename?: 'Query', product: { __typename?: 'Product', newProductTestUrl: string, editUrl: string, productTests: { __typename?: 'ProductTestConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined }, nodes: Array<{ __typename?: 'ProductTest', id: string, name?: string | null | undefined, description?: string | null | undefined, result: string, dateOfCompletion?: string | null | undefined, editUrl: string, document?: { __typename?: 'Attachment', url: string, filename: string } | null | undefined }> } } };

export type ProductShowQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductShowQuery = { __typename?: 'Query', product: { __typename?: 'Product', id: string, name?: string | null | undefined, updatedAt: string, status: ProductStatus, editUrl: string, makerName?: string | null | undefined, description?: string | null | undefined, styleNumber?: string | null | undefined, productionMethod?: string | null | undefined, htsCode?: string | null | undefined, fabricType?: string | null | undefined, availableUntil?: string | null | undefined, maxCapacity?: number | null | undefined, internalNotes?: string | null | undefined, previousBuyers: Array<string>, environments: Array<string>, makerCapabilities: Array<string>, makerTypes: Array<string>, makerCertificationTypes: Array<string>, socialImpactMetricsEnabled: boolean, fairWagePerHour?: number | null | undefined, equivalencesEnabled: boolean, landSavedFromPesticidesM2?: number | null | undefined, drivingEmissionsAvoidedKm?: number | null | undefined, bulbEnergySavedHours?: number | null | undefined, drinkingWaterSavedDays?: number | null | undefined, environmentalImpactMetricsEnabled: boolean, energyConservedKwh?: number | null | undefined, waterSavedLiters?: number | null | undefined, emissionsAvoidedKg?: number | null | undefined, pesticidesAvoidedG?: number | null | undefined, wasteDivertedG?: number | null | undefined, recycledWaterBottles?: number | null | undefined, carbonOffsetMetricsEnabled: boolean, carbonOffsetKg?: number | null | undefined, carbonOffsetAsKmOfDriving?: number | null | undefined, carbonOffsetAsTransatlanticFlights?: number | null | undefined, carbonOffsetAsPhonesCharged?: number | null | undefined, newProductCategoryUrl: string, newProductMaterialUrl: string, variants: Array<{ __typename?: 'Variant', id: string, name: string, dimension?: { __typename?: 'Dimension', weightKg?: number | null | undefined, heightCm?: number | null | undefined, widthCm?: number | null | undefined, lengthCm?: number | null | undefined } | null | undefined }>, dimension?: { __typename?: 'Dimension', weightKg?: number | null | undefined, heightCm?: number | null | undefined, widthCm?: number | null | undefined, lengthCm?: number | null | undefined } | null | undefined, npaVariants: Array<{ __typename?: 'NpaVariant', id: string, name: string, npaVariantOptions: Array<{ __typename?: 'NpaVariantOption', id: string, name: string, makerName?: string | null | undefined, position?: number | null | undefined }> }>, productProductCategories: { __typename?: 'ProductProductCategoryConnection', nodes: Array<{ __typename?: 'ProductProductCategory', id: string, editUrl: string, productCategory: { __typename?: 'ProductCategory', id: string, name: string }, productSubcategories: { __typename?: 'ProductSubcategoryConnection', nodes: Array<{ __typename?: 'ProductSubcategory', id: string, name?: string | null | undefined }> } }> }, productCategories: Array<{ __typename?: 'ProductCategory', id: string, name: string, productSubcategories: { __typename?: 'ProductSubcategoryConnection', nodes: Array<{ __typename?: 'ProductSubcategory', id: string, name?: string | null | undefined }> } }>, productMaterials: { __typename?: 'ProductMaterialConnection', nodes: Array<{ __typename?: 'ProductMaterial', id: string, editUrl: string, material: { __typename?: 'Material', name: string }, materialSubcategories: { __typename?: 'MaterialSubcategoryConnection', nodes: Array<{ __typename?: 'MaterialSubcategory', id: string, name: string }> } }> }, images: Array<{ __typename?: 'Image', id: string, imgixUrl: string, filename: string }>, techPack?: { __typename?: 'Attachment', filename: string, url: string } | null | undefined, nameAliases: Array<{ __typename?: 'ProductNameAlias', id: string, name: string, createdAt: string, editUrl: string, resourceUrl: string }>, skuAliases: Array<{ __typename?: 'ProductSkuAlias', id: string, sku: string, createdAt: string, editUrl: string, resourceUrl: string }>, image?: { __typename?: 'Image', id: string, imgixUrl: string } | null | undefined, imageWithFallback: { __typename?: 'Image', id: string, imgixUrl: string }, productGroup: { __typename?: 'ProductGroup', name: string, showUrl: string }, makerCountry?: { __typename?: 'Country', name: string } | null | undefined, shipsFromCountry?: { __typename?: 'Country', name: string } | null | undefined, countryOfOrigin?: { __typename?: 'Country', name: string } | null | undefined, valueAlignments: Array<{ __typename?: 'ValueAlignment', name: string }>, makerAttributes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }>, selectedMakerAttributes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }>, maker: { __typename?: 'Maker', id: string, name: string, editUrl: string, countries: { __typename?: 'CountryConnection', nodes: Array<{ __typename?: 'Country', name: string }> }, shippingPorts: { __typename?: 'ShippingPortConnection', nodes: Array<{ __typename?: 'ShippingPort', port: string }> } }, productAttributes: Array<{ __typename?: 'ProductAttribute', name: string, icon: { __typename?: 'Attachment', imgixUrl: string } }> } };

export type ProductShowMakerFragment = { __typename?: 'Product', id: string, name?: string | null | undefined, updatedAt: string, status: ProductStatus, editUrl: string, makerName?: string | null | undefined, description?: string | null | undefined, styleNumber?: string | null | undefined, productionMethod?: string | null | undefined, htsCode?: string | null | undefined, fabricType?: string | null | undefined, availableUntil?: string | null | undefined, maxCapacity?: number | null | undefined, internalNotes?: string | null | undefined, previousBuyers: Array<string>, environments: Array<string>, makerCapabilities: Array<string>, makerTypes: Array<string>, makerCertificationTypes: Array<string>, socialImpactMetricsEnabled: boolean, fairWagePerHour?: number | null | undefined, equivalencesEnabled: boolean, landSavedFromPesticidesM2?: number | null | undefined, drivingEmissionsAvoidedKm?: number | null | undefined, bulbEnergySavedHours?: number | null | undefined, drinkingWaterSavedDays?: number | null | undefined, environmentalImpactMetricsEnabled: boolean, energyConservedKwh?: number | null | undefined, waterSavedLiters?: number | null | undefined, emissionsAvoidedKg?: number | null | undefined, pesticidesAvoidedG?: number | null | undefined, wasteDivertedG?: number | null | undefined, recycledWaterBottles?: number | null | undefined, carbonOffsetMetricsEnabled: boolean, carbonOffsetKg?: number | null | undefined, carbonOffsetAsKmOfDriving?: number | null | undefined, carbonOffsetAsTransatlanticFlights?: number | null | undefined, carbonOffsetAsPhonesCharged?: number | null | undefined, newProductCategoryUrl: string, newProductMaterialUrl: string, variants: Array<{ __typename?: 'Variant', id: string, name: string, dimension?: { __typename?: 'Dimension', weightKg?: number | null | undefined, heightCm?: number | null | undefined, widthCm?: number | null | undefined, lengthCm?: number | null | undefined } | null | undefined }>, dimension?: { __typename?: 'Dimension', weightKg?: number | null | undefined, heightCm?: number | null | undefined, widthCm?: number | null | undefined, lengthCm?: number | null | undefined } | null | undefined, npaVariants: Array<{ __typename?: 'NpaVariant', id: string, name: string, npaVariantOptions: Array<{ __typename?: 'NpaVariantOption', id: string, name: string, makerName?: string | null | undefined, position?: number | null | undefined }> }>, productProductCategories: { __typename?: 'ProductProductCategoryConnection', nodes: Array<{ __typename?: 'ProductProductCategory', id: string, editUrl: string, productCategory: { __typename?: 'ProductCategory', id: string, name: string }, productSubcategories: { __typename?: 'ProductSubcategoryConnection', nodes: Array<{ __typename?: 'ProductSubcategory', id: string, name?: string | null | undefined }> } }> }, productCategories: Array<{ __typename?: 'ProductCategory', id: string, name: string, productSubcategories: { __typename?: 'ProductSubcategoryConnection', nodes: Array<{ __typename?: 'ProductSubcategory', id: string, name?: string | null | undefined }> } }>, productMaterials: { __typename?: 'ProductMaterialConnection', nodes: Array<{ __typename?: 'ProductMaterial', id: string, editUrl: string, material: { __typename?: 'Material', name: string }, materialSubcategories: { __typename?: 'MaterialSubcategoryConnection', nodes: Array<{ __typename?: 'MaterialSubcategory', id: string, name: string }> } }> }, images: Array<{ __typename?: 'Image', id: string, imgixUrl: string, filename: string }>, techPack?: { __typename?: 'Attachment', filename: string, url: string } | null | undefined, nameAliases: Array<{ __typename?: 'ProductNameAlias', id: string, name: string, createdAt: string, editUrl: string, resourceUrl: string }>, skuAliases: Array<{ __typename?: 'ProductSkuAlias', id: string, sku: string, createdAt: string, editUrl: string, resourceUrl: string }>, image?: { __typename?: 'Image', id: string, imgixUrl: string } | null | undefined, imageWithFallback: { __typename?: 'Image', id: string, imgixUrl: string }, productGroup: { __typename?: 'ProductGroup', name: string, showUrl: string }, makerCountry?: { __typename?: 'Country', name: string } | null | undefined, shipsFromCountry?: { __typename?: 'Country', name: string } | null | undefined, countryOfOrigin?: { __typename?: 'Country', name: string } | null | undefined, valueAlignments: Array<{ __typename?: 'ValueAlignment', name: string }>, makerAttributes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }>, selectedMakerAttributes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }>, maker: { __typename?: 'Maker', id: string, name: string, editUrl: string, countries: { __typename?: 'CountryConnection', nodes: Array<{ __typename?: 'Country', name: string }> }, shippingPorts: { __typename?: 'ShippingPortConnection', nodes: Array<{ __typename?: 'ShippingPort', port: string }> } }, productAttributes: Array<{ __typename?: 'ProductAttribute', name: string, icon: { __typename?: 'Attachment', imgixUrl: string } }> };

export type ProductSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<ProductSort>;
  statuses?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  certifications?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  makerAttributeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  productAttributeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  makerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  makerCapabilities?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  environments?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  productCategoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  productSubcategoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  materialIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  materialSubcategoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  customizations?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  previousBuyers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  makerTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  skus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  styleNumbers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  minPrice?: InputMaybe<Scalars['Int']>;
  maxPrice?: InputMaybe<Scalars['Int']>;
  minUnits?: InputMaybe<Scalars['Int']>;
  maxUnits?: InputMaybe<Scalars['Int']>;
}>;


export type ProductSearchQuery = { __typename?: 'Query', products: { __typename?: 'ProductConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined }, nodes: Array<{ __typename?: 'Product', id: string, name?: string | null | undefined, isArchived: boolean, showUrl: string, minimumOrderQuantity?: number | null | undefined, customizations: Array<string>, subcategories: Array<string>, previousBuyers: Array<string>, makerCertificationTypes: Array<string>, styleNumber?: string | null | undefined, image?: { __typename?: 'Image', imgixUrl: string, id: string } | null | undefined, imageWithFallback: { __typename?: 'Image', imgixUrl: string }, productGroup: { __typename?: 'ProductGroup', id: string, showUrl: string, name: string }, variants: Array<{ __typename?: 'Variant', id: string, name: string }>, maker: { __typename?: 'Maker', id: string, name: string, showUrl: string, environments: Array<string>, makerTypes: Array<string>, capabilities: Array<string> }, productCategories: Array<{ __typename?: 'ProductCategory', id: string, name: string, productSubcategories: { __typename?: 'ProductSubcategoryConnection', nodes: Array<{ __typename?: 'ProductSubcategory', id: string, name?: string | null | undefined }> } }>, productAttributes: Array<{ __typename?: 'ProductAttribute', id: string, name: string }>, makerAttributes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }>, price?: { __typename?: 'ProductPrice', amount: number, quantity: number } | null | undefined, materials: { __typename?: 'MaterialConnection', nodes: Array<{ __typename?: 'Material', id: string, name: string }> }, materialSubcategories: { __typename?: 'MaterialSubcategoryConnection', nodes: Array<{ __typename?: 'MaterialSubcategory', id: string, name: string }> }, countryOfOrigin?: { __typename?: 'Country', id: string, name: string, iso3166: string } | null | undefined, skus: Array<{ __typename?: 'Sku', id: string, humanId: string }>, nameAliases: Array<{ __typename?: 'ProductNameAlias', id: string, name: string }> }> } };

export type ProductSearchListItemFragment = { __typename?: 'Product', id: string, name?: string | null | undefined, isArchived: boolean, showUrl: string, minimumOrderQuantity?: number | null | undefined, customizations: Array<string>, subcategories: Array<string>, previousBuyers: Array<string>, makerCertificationTypes: Array<string>, styleNumber?: string | null | undefined, image?: { __typename?: 'Image', imgixUrl: string, id: string } | null | undefined, imageWithFallback: { __typename?: 'Image', imgixUrl: string }, productGroup: { __typename?: 'ProductGroup', id: string, showUrl: string, name: string }, variants: Array<{ __typename?: 'Variant', id: string, name: string }>, maker: { __typename?: 'Maker', id: string, name: string, showUrl: string, environments: Array<string>, makerTypes: Array<string>, capabilities: Array<string> }, productCategories: Array<{ __typename?: 'ProductCategory', id: string, name: string, productSubcategories: { __typename?: 'ProductSubcategoryConnection', nodes: Array<{ __typename?: 'ProductSubcategory', id: string, name?: string | null | undefined }> } }>, productAttributes: Array<{ __typename?: 'ProductAttribute', id: string, name: string }>, makerAttributes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }>, price?: { __typename?: 'ProductPrice', amount: number, quantity: number } | null | undefined, materials: { __typename?: 'MaterialConnection', nodes: Array<{ __typename?: 'Material', id: string, name: string }> }, materialSubcategories: { __typename?: 'MaterialSubcategoryConnection', nodes: Array<{ __typename?: 'MaterialSubcategory', id: string, name: string }> }, countryOfOrigin?: { __typename?: 'Country', id: string, name: string, iso3166: string } | null | undefined, skus: Array<{ __typename?: 'Sku', id: string, humanId: string }>, nameAliases: Array<{ __typename?: 'ProductNameAlias', id: string, name: string }> };

export type ProductSearchFilterOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductSearchFilterOptionsQuery = { __typename?: 'Query', productSearchFilterOptions: { __typename?: 'ProductSearchFilterOptions', environments: Array<string>, customizations: Array<string>, previousBuyers: Array<string>, makerTypes: Array<string>, makerCapabilities: Array<string>, minPrice: number, maxPrice: number, minUnits: number, maxUnits: number, certifications: { __typename?: 'CertificationConnection', nodes: Array<{ __typename?: 'Certification', id: string, name: string }> }, valueAlignments: Array<{ __typename?: 'ValueAlignment', id: string, name: string }>, productCategories: Array<{ __typename?: 'ProductCategory', id: string, name: string, productSubcategories: { __typename?: 'ProductSubcategoryConnection', nodes: Array<{ __typename?: 'ProductSubcategory', id: string, name?: string | null | undefined }> } }>, makerAttributes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }>, productAttributes: Array<{ __typename?: 'ProductAttribute', id: string, name: string }>, makers: Array<{ __typename?: 'Maker', id: string, name: string }>, materials: Array<{ __typename?: 'Material', id: string, name: string, materialSubcategories: { __typename?: 'MaterialSubcategoryConnection', nodes: Array<{ __typename?: 'MaterialSubcategory', id: string, name: string }> } }>, countries: Array<{ __typename?: 'Country', id: string, name: string }> } };

export type ShippingPortsQueryVariables = Exact<{
  makerId?: InputMaybe<Scalars['ID']>;
  locationType: ShippingPortLocation;
}>;


export type ShippingPortsQuery = { __typename?: 'Query', shippingPorts: Array<{ __typename?: 'ShippingPort', id: string, port: string, locationType: ShippingPortLocation, modeOfTransit: ModeOfTransit, country: { __typename?: 'Country', id: string, name: string } }> };

export type ShippingPortListItemFragment = { __typename?: 'ShippingPort', id: string, port: string, locationType: ShippingPortLocation, modeOfTransit: ModeOfTransit, country: { __typename?: 'Country', id: string, name: string } };

export type TimeAndActionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TimeAndActionQuery = { __typename?: 'Query', timeAndAction: { __typename?: 'TimeAndAction', id: string, humanId: string, description?: string | null | undefined, active: boolean, createdAt: string, updatedAt: string, editUrl: string, showUrl: string, taskStatusOptions: Array<{ __typename?: 'TimeAndActionCalendarTaskStatusOption', value: string, label: string }>, maker: { __typename?: 'Maker', id: string, humanId: string, name: string }, clientOrder: { __typename?: 'ClientOrder', id: string, humanId: string }, calendar: { __typename?: 'TimeAndActionCalendar', id: string, name: string, tasks: { __typename?: 'TimeAndActionCalendarTaskConnection', nodes: Array<{ __typename?: 'TimeAndActionCalendarTask', id: string, name: string, stage: string, stageHumanized: string, status: string, position: number, dueDate?: string | null | undefined, startDate?: string | null | undefined, actualStartDate?: string | null | undefined, dateCompleted?: string | null | undefined, durationDays?: number | null | undefined, remindersOn: boolean, displayToMaker: boolean, remindersUrl: string, pastDue?: boolean | null | undefined, owners: { __typename?: 'TimeAndActionCalendarTaskOwnerConnection', nodes: Array<{ __typename?: 'TimeAndActionCalendarTaskOwner', id: string, maker: boolean, user?: { __typename?: 'User', id: string, fullName: string } | null | undefined }> }, taskChanges: Array<{ __typename?: 'TimeAndActionCalendarChange', id: string, description: string, responsible?: string | null | undefined, createdAt: string, notes?: string | null | undefined, relatedDescription?: string | null | undefined, user?: { __typename?: 'User', displayName: string } | null | undefined }>, activeChangeRequest?: { __typename?: 'TimeAndActionTaskChangeRequest', id: string, status: string, dueDate?: string | null | undefined, startDate?: string | null | undefined, existingDueDate?: string | null | undefined, existingStartDate?: string | null | undefined, jobPosition?: string | null | undefined, notes?: string | null | undefined, responsible?: string | null | undefined } | null | undefined, changeRequests: Array<{ __typename?: 'TimeAndActionTaskChangeRequest', id: string, status: string, dueDate?: string | null | undefined, startDate?: string | null | undefined, existingDueDate?: string | null | undefined, existingStartDate?: string | null | undefined, jobPosition?: string | null | undefined, notes?: string | null | undefined, responsible?: string | null | undefined }> }> }, calendarChanges: Array<{ __typename?: 'TimeAndActionCalendarChange', id: string, description: string, responsible?: string | null | undefined, createdAt: string, notes?: string | null | undefined, relatedDescription?: string | null | undefined, user?: { __typename?: 'User', displayName: string } | null | undefined }> }, ownerOptions: Array<{ __typename?: 'User', id: string, fullName: string }> } };

export type TimeAndActionCalendarFragment = { __typename?: 'TimeAndAction', id: string, humanId: string, description?: string | null | undefined, active: boolean, createdAt: string, updatedAt: string, editUrl: string, showUrl: string, taskStatusOptions: Array<{ __typename?: 'TimeAndActionCalendarTaskStatusOption', value: string, label: string }>, maker: { __typename?: 'Maker', id: string, humanId: string, name: string }, clientOrder: { __typename?: 'ClientOrder', id: string, humanId: string }, calendar: { __typename?: 'TimeAndActionCalendar', id: string, name: string, tasks: { __typename?: 'TimeAndActionCalendarTaskConnection', nodes: Array<{ __typename?: 'TimeAndActionCalendarTask', id: string, name: string, stage: string, stageHumanized: string, status: string, position: number, dueDate?: string | null | undefined, startDate?: string | null | undefined, actualStartDate?: string | null | undefined, dateCompleted?: string | null | undefined, durationDays?: number | null | undefined, remindersOn: boolean, displayToMaker: boolean, remindersUrl: string, pastDue?: boolean | null | undefined, owners: { __typename?: 'TimeAndActionCalendarTaskOwnerConnection', nodes: Array<{ __typename?: 'TimeAndActionCalendarTaskOwner', id: string, maker: boolean, user?: { __typename?: 'User', id: string, fullName: string } | null | undefined }> }, taskChanges: Array<{ __typename?: 'TimeAndActionCalendarChange', id: string, description: string, responsible?: string | null | undefined, createdAt: string, notes?: string | null | undefined, relatedDescription?: string | null | undefined, user?: { __typename?: 'User', displayName: string } | null | undefined }>, activeChangeRequest?: { __typename?: 'TimeAndActionTaskChangeRequest', id: string, status: string, dueDate?: string | null | undefined, startDate?: string | null | undefined, existingDueDate?: string | null | undefined, existingStartDate?: string | null | undefined, jobPosition?: string | null | undefined, notes?: string | null | undefined, responsible?: string | null | undefined } | null | undefined, changeRequests: Array<{ __typename?: 'TimeAndActionTaskChangeRequest', id: string, status: string, dueDate?: string | null | undefined, startDate?: string | null | undefined, existingDueDate?: string | null | undefined, existingStartDate?: string | null | undefined, jobPosition?: string | null | undefined, notes?: string | null | undefined, responsible?: string | null | undefined }> }> }, calendarChanges: Array<{ __typename?: 'TimeAndActionCalendarChange', id: string, description: string, responsible?: string | null | undefined, createdAt: string, notes?: string | null | undefined, relatedDescription?: string | null | undefined, user?: { __typename?: 'User', displayName: string } | null | undefined }> }, ownerOptions: Array<{ __typename?: 'User', id: string, fullName: string }> };

export type TimeAndActionCalendarTemplateEditQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TimeAndActionCalendarTemplateEditQuery = { __typename?: 'Query', timeAndActionCalendarTemplate: { __typename?: 'TimeAndActionCalendarTemplate', id: string, name: string, tasks: { __typename?: 'TimeAndActionCalendarTaskConnection', nodes: Array<{ __typename?: 'TimeAndActionCalendarTask', id: string, name: string, stage: string, status: string, position: number, dueDate?: string | null | undefined, startDate?: string | null | undefined, actualStartDate?: string | null | undefined, dateCompleted?: string | null | undefined, durationDays?: number | null | undefined, remindersOn: boolean, displayToMaker: boolean, owners: { __typename?: 'TimeAndActionCalendarTaskOwnerConnection', nodes: Array<{ __typename?: 'TimeAndActionCalendarTaskOwner', id: string, maker: boolean, user?: { __typename?: 'User', id: string, fullName: string } | null | undefined }> } }> } } };

export type TimeAndActionCalendarTemplateEditCalendarFragment = { __typename?: 'TimeAndActionCalendarTemplate', id: string, name: string, tasks: { __typename?: 'TimeAndActionCalendarTaskConnection', nodes: Array<{ __typename?: 'TimeAndActionCalendarTask', id: string, name: string, stage: string, status: string, position: number, dueDate?: string | null | undefined, startDate?: string | null | undefined, actualStartDate?: string | null | undefined, dateCompleted?: string | null | undefined, durationDays?: number | null | undefined, remindersOn: boolean, displayToMaker: boolean, owners: { __typename?: 'TimeAndActionCalendarTaskOwnerConnection', nodes: Array<{ __typename?: 'TimeAndActionCalendarTaskOwner', id: string, maker: boolean, user?: { __typename?: 'User', id: string, fullName: string } | null | undefined }> } }> } };

export type UpdateActiveClientOrderMutationVariables = Exact<{
  input: UpdateActiveClientOrderInput;
}>;


export type UpdateActiveClientOrderMutation = { __typename?: 'Mutation', updateActiveClientOrder: { __typename?: 'UpdateActiveClientOrderPayload', clientOrder: { __typename?: 'ClientOrder', id: string }, errors: Array<{ __typename?: 'ValidationError', path?: Array<string> | null | undefined, message: string }> } };

export type UpdateClientOrderMutationVariables = Exact<{
  input: UpdateClientOrderInput;
}>;


export type UpdateClientOrderMutation = { __typename?: 'Mutation', updateClientOrder: { __typename?: 'UpdateClientOrderPayload', clientOrder: { __typename?: 'ClientOrder', id: string, clientOrderProducts: { __typename?: 'ClientOrderProductConnection', nodes: Array<{ __typename?: 'ClientOrderProduct', editUrl: string, product: { __typename?: 'Product', id: string } }> } }, errors: Array<{ __typename?: 'ValidationError', path?: Array<string> | null | undefined, message: string }> } };

export type UpdateClientOrderStatusMutationVariables = Exact<{
  input: UpdateClientOrderStatusInput;
}>;


export type UpdateClientOrderStatusMutation = { __typename?: 'Mutation', updateClientOrderStatus: { __typename?: 'UpdateClientOrderStatusPayload', clientOrder: { __typename?: 'ClientOrder', id: string, status?: ClientOrderStatus | null | undefined }, errors: Array<{ __typename?: 'ValidationError', path?: Array<string> | null | undefined, message: string }> } };

export type UpdateMakerStatusMutationVariables = Exact<{
  input: UpdateMakerStatusInput;
}>;


export type UpdateMakerStatusMutation = { __typename?: 'Mutation', updateMakerStatus: { __typename?: 'UpdateMakerStatusPayload', maker: { __typename?: 'Maker', id: string, status: MakerStatus }, errors: Array<{ __typename?: 'ValidationError', path?: Array<string> | null | undefined, message: string }> } };

export type UpdateMakerMutationVariables = Exact<{
  input: UpdateMakerInput;
}>;


export type UpdateMakerMutation = { __typename?: 'Mutation', updateMaker: { __typename?: 'UpdateMakerPayload', maker: { __typename?: 'Maker', id: string }, errors: Array<{ __typename?: 'ValidationError', path?: Array<string> | null | undefined, message: string }> } };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'UpdateProductPayload', product: { __typename?: 'Product', id: string }, errors: Array<{ __typename?: 'ValidationError', path?: Array<string> | null | undefined, message: string }> } };

export type UpdateMakerOrderMutationVariables = Exact<{
  input: UpdateMakerOrderInput;
}>;


export type UpdateMakerOrderMutation = { __typename?: 'Mutation', updateMakerOrder: { __typename?: 'UpdateMakerOrderPayload', makerOrder: { __typename?: 'MakerOrder', id: string, shipment?: { __typename?: 'Shipment', id: string } | null | undefined }, errors: Array<{ __typename?: 'ValidationError', path?: Array<string> | null | undefined, message: string }> } };

export type CogsValidUntilQueryVariables = Exact<{
  productId: Scalars['ID'];
}>;


export type CogsValidUntilQuery = { __typename?: 'Query', product: { __typename?: 'Product', cogsExpiresOn?: string | null | undefined, pricingOwners: { __typename?: 'UserConnection', nodes: Array<{ __typename?: 'User', value: string, label: string }> }, pricingOwnerOptions: { __typename?: 'UserConnection', nodes: Array<{ __typename?: 'User', value: string, label: string }> } } };

export type UpdateCogsExpiresOnMutationVariables = Exact<{
  input: UpdateProductInput;
}>;


export type UpdateCogsExpiresOnMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'UpdateProductPayload', product: { __typename?: 'Product', availableUntil?: string | null | undefined } } };

export type UpdateProductGroupMutationVariables = Exact<{
  input: UpdateProductGroupInput;
}>;


export type UpdateProductGroupMutation = { __typename?: 'Mutation', updateProductGroup: { __typename?: 'UpdateProductGroupPayload', productGroup: { __typename?: 'ProductGroup', id: string }, errors: Array<{ __typename?: 'ValidationError', path?: Array<string> | null | undefined, message: string }> } };

export type UpdateProductStatusMutationVariables = Exact<{
  input: UpdateProductStatusInput;
}>;


export type UpdateProductStatusMutation = { __typename?: 'Mutation', updateProductStatus: { __typename?: 'UpdateProductStatusPayload', product: { __typename?: 'Product', id: string, status: ProductStatus }, errors: Array<{ __typename?: 'ValidationError', message: string }> } };

export type UpdateMakerOrderCogsMutationVariables = Exact<{
  input: UpdateMakerOrderCogsInput;
}>;


export type UpdateMakerOrderCogsMutation = { __typename?: 'Mutation', updateMakerOrderCogs: { __typename?: 'UpdateMakerOrderCogsPayload', makerOrder: { __typename?: 'MakerOrder', id: string, showUrl: string }, errors: Array<{ __typename?: 'ValidationError', path?: Array<string> | null | undefined, message: string }> } };

export type UpdateTimeAndActionMutationVariables = Exact<{
  input: UpdateTimeAndActionInput;
}>;


export type UpdateTimeAndActionMutation = { __typename?: 'Mutation', updateTimeAndAction: { __typename?: 'UpdateTimeAndActionPayload', timeAndAction: { __typename?: 'TimeAndAction', id: string, calendar: { __typename?: 'TimeAndActionCalendar', id: string, tasks: { __typename?: 'TimeAndActionCalendarTaskConnection', nodes: Array<{ __typename?: 'TimeAndActionCalendarTask', id: string, owners: { __typename?: 'TimeAndActionCalendarTaskOwnerConnection', nodes: Array<{ __typename?: 'TimeAndActionCalendarTaskOwner', id: string }> } }> } } }, errors: Array<{ __typename?: 'ValidationError', path?: Array<string> | null | undefined, message: string }> } };

export type UpdateTimeAndActionCalendarTemplateMutationVariables = Exact<{
  input: UpdateTimeAndActionCalendarTemplateInput;
}>;


export type UpdateTimeAndActionCalendarTemplateMutation = { __typename?: 'Mutation', updateTimeAndActionCalendarTemplate: { __typename?: 'UpdateTimeAndActionCalendarTemplatePayload', timeAndActionCalendarTemplate: { __typename?: 'TimeAndActionCalendarTemplate', id: string, name: string, tasks: { __typename?: 'TimeAndActionCalendarTaskConnection', nodes: Array<{ __typename?: 'TimeAndActionCalendarTask', id: string }> } }, errors: Array<{ __typename?: 'ValidationError', path?: Array<string> | null | undefined, message: string }> } };

export type MakerSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  statuses: Array<Scalars['String']> | Scalars['String'];
  costRangeEstimates: Array<Scalars['String']> | Scalars['String'];
  productionCapacities?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  certifications?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  makerAttributeIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  shippingCountryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  environments?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  capabilities?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  productCategoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  productSubcategoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  materialIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  materialSubcategoryIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  sorts?: InputMaybe<Array<MakerSort> | MakerSort>;
}>;


export type MakerSearchQuery = { __typename?: 'Query', makers: { __typename?: 'MakerConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined }, nodes: Array<{ __typename?: 'Maker', id: string, name: string, status: MakerStatus, address?: string | null | undefined, editUrl: string, showUrl: string, logoUrlWithFallback: string, productionCapacity?: string | null | undefined, makerCertificationTypes: Array<string>, environments: Array<string>, capabilities: Array<string>, costRangeEstimate?: string | null | undefined, mostRecentOrderDate?: string | null | undefined, subcategories: Array<string>, valueAlignments: Array<{ __typename?: 'ValueAlignment', id: string, name: string }>, makerAttributes: { __typename?: 'MakerAttributeConnection', nodes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }> }, makerMakerAttributes: { __typename?: 'MakerMakerAttributeConnection', nodes: Array<{ __typename?: 'MakerMakerAttribute', id: string, response?: boolean | null | undefined, responseText?: string | null | undefined, makerAttributeId: string }> }, materials: { __typename?: 'MaterialConnection', nodes: Array<{ __typename?: 'Material', id: string, name: string }> }, makerProductCategories: { __typename?: 'MakerProductCategoryConnection', nodes: Array<{ __typename?: 'MakerProductCategory', id: string, subcategories: Array<string>, productCategory: { __typename?: 'ProductCategory', id: string, name: string } }> }, countries: { __typename?: 'CountryConnection', nodes: Array<{ __typename?: 'Country', id: string, iso3166: string, name: string }> } }> } };

export type MakerSearchMakerFragment = { __typename?: 'Maker', id: string, name: string, status: MakerStatus, address?: string | null | undefined, editUrl: string, showUrl: string, logoUrlWithFallback: string, productionCapacity?: string | null | undefined, makerCertificationTypes: Array<string>, environments: Array<string>, capabilities: Array<string>, costRangeEstimate?: string | null | undefined, mostRecentOrderDate?: string | null | undefined, subcategories: Array<string>, valueAlignments: Array<{ __typename?: 'ValueAlignment', id: string, name: string }>, makerAttributes: { __typename?: 'MakerAttributeConnection', nodes: Array<{ __typename?: 'MakerAttribute', id: string, text: string }> }, makerMakerAttributes: { __typename?: 'MakerMakerAttributeConnection', nodes: Array<{ __typename?: 'MakerMakerAttribute', id: string, response?: boolean | null | undefined, responseText?: string | null | undefined, makerAttributeId: string }> }, materials: { __typename?: 'MaterialConnection', nodes: Array<{ __typename?: 'Material', id: string, name: string }> }, makerProductCategories: { __typename?: 'MakerProductCategoryConnection', nodes: Array<{ __typename?: 'MakerProductCategory', id: string, subcategories: Array<string>, productCategory: { __typename?: 'ProductCategory', id: string, name: string } }> }, countries: { __typename?: 'CountryConnection', nodes: Array<{ __typename?: 'Country', id: string, iso3166: string, name: string }> } };

export type UpdateTimeAndActionCalendarTaskMutationVariables = Exact<{
  input: UpdateTimeAndActionCalendarTaskInput;
}>;


export type UpdateTimeAndActionCalendarTaskMutation = { __typename?: 'Mutation', updateTimeAndActionCalendarTask: { __typename?: 'UpdateTimeAndActionCalendarTaskPayload', timeAndActionCalendarTask: { __typename?: 'TimeAndActionCalendarTask', id: string, status: string }, errors: Array<{ __typename?: 'ValidationError', path?: Array<string> | null | undefined, message: string }> } };

export const ActiveClientOrderMakerFragmentDoc = `
    fragment ActiveClientOrderMaker on ClientOrder {
  id
  showUrl
  newClientOrderProductUrl
  makerOrders {
    nodes {
      id
      humanId
      accepted
      maker {
        id
        name
      }
    }
  }
}
    `;
export const ClientOrderEditMakerFragmentDoc = `
    fragment ClientOrderEditMaker on ClientOrder {
  id
  humanId
  description
  createdAt
  editUrl
  duplicateUrl
  totalPriceLooseCents
  totalUnits
  totalSkuUnits
  totalUniqueProducts
  paymentTerms
  acceptedByClient
  hasAcceptedMakerOrders
  internalNotes
  externalPoReference
  deliveryWindow
  totalCostCents
  totalMargin
  status
  statusOptions
  salesPresentationsUrl
  newSalesPresentationUrl
  clientApprovalOrdersUrl
  newClientApprovalOrderUrl
  makerOrdersUrl
  newMakerOrderUrl
  timeAndActionsUrl
  newTimeAndActionUrl
  newImpactReportUrl
  billingAddressId
  shippingAddressId
  newReferenceImageUrl
  showUrl
  clientLegalAgreementId
  clientSoPo {
    imgixUrl
    filename
    attachmentUrl
    url
  }
  creatorUser {
    id
    fullName
  }
  referenceImages {
    imgixUrl
    filename
    attachmentUrl
    url
  }
  salesPresentations(first: 3) {
    nodes {
      id
      humanId
      pdfStatus
      humanPdfStatus
      showUrl
      createdAt
    }
  }
  clientApprovalOrders(first: 3) {
    nodes {
      id
      humanId
      status
      humanStatus
      showUrl
      createdAt
    }
  }
  salesLeads {
    id
    fullName
  }
  designLeads {
    id
    fullName
  }
  productionLeads {
    id
    fullName
  }
  impactLeads {
    id
    fullName
  }
  operationsLeads {
    id
    fullName
  }
  financialLeads {
    id
    fullName
  }
  leadOptions {
    id
    fullName
  }
  client {
    id
    showUrl
    name
  }
  makerOrders {
    nodes {
      id
      humanId
      status
      humanStatus
      accepted
      showUrl
      createdAt
      maker {
        id
        name
      }
    }
  }
  timeAndActions {
    nodes {
      id
      humanId
      showUrl
      active
      createdAt
      maker {
        id
        name
      }
    }
  }
  contacts {
    id
    fullName
    email
    phone
    jobTitle
  }
  makers {
    nodes {
      id
      name
      logoUrlWithFallback
      showUrl
      orderMinimumCents
    }
  }
  clientLegalAgreementOptions {
    id
    name
  }
  addressOptions {
    id
    selectLabel
  }
  clientOrderProducts {
    nodes {
      id
      makerId
      totalCostCents
      totalPriceCents
      includeShippingCosts
      includeDutyCosts
      importShippingPort {
        id
        abbreviation
        modeOfTransit
      }
      exportShippingPort {
        id
        abbreviation
        modeOfTransit
      }
      image {
        id
        imgixUrl
      }
      product {
        name
        description
        variantName
        showUrl
        countryOfOrigin {
          name
        }
        dimension {
          widthCm
          heightCm
          lengthCm
        }
        materials {
          nodes {
            name
          }
        }
        materialSubcategories {
          nodes {
            name
            material {
              name
            }
          }
        }
        imageWithFallback {
          imgixUrl
        }
        image {
          id
          imgixUrl
        }
        skus {
          id
          variantDisplayName
        }
        npaVariants {
          id
          name
          npaVariantTemplateId
          npaVariantOptions {
            id
            name
            position
          }
        }
        variants {
          id
          name
        }
        productGroup {
          name
          showUrl
          customizationCategories
          minimumCogsColumnQuantity
          addons {
            id
            name
          }
          customizations {
            id
            name
            customizationCategoryName
          }
        }
      }
      clientOrderProductSkus {
        id
        quantity
        perItemAmountCents
        cogsPerItemAmountCents
        margin
        calculatedMargin
        perItemPrice
        calculatedPerItemPrice
        totalPriceCents
        msrp
        shippingCostsCents
        dutyCostsCents
        totalEnergyConservedKwh
        totalWaterSavedLiters
        totalEmissionsAvoidedKg
        totalFairWageHoursWorked
        totalPesticidesAvoidedG
        totalCarbonOffsetKg
        totalWasteDivertedG
        totalRecycledWaterBottles
        editCostUrl
        countryOfOrigin {
          id
          shortName: iso3166
        }
        sku {
          humanId
          variant {
            id
            name
          }
          npaVariantOptions {
            id
            name
            npaVariantId
            position
          }
        }
      }
      clientOrderProductCustomizations {
        id
        quantity
        perItemAmountCents
        margin
        calculatedMargin
        perItemPrice
        calculatedPerItemPrice
        totalPriceCents
        editUrl
        editCostUrl
        customization {
          name
          customizationCategoryName
          acceptsArtwork
        }
        customizationArtworks {
          id
          designName
          imprintType
          designLocation
          designSize
          designColor
          artwork {
            url
          }
        }
      }
      clientOrderProductAddons {
        id
        quantity
        perItemAmountCents
        margin
        calculatedMargin
        perItemPrice
        calculatedPerItemPrice
        totalPriceCents
        editCostUrl
        addon {
          name
        }
      }
      clientOrderProductLineItems {
        id
        name
        quantity
        perItemCost
        margin
        calculatedMargin
        perItemPrice
        calculatedPerItemPrice
        totalPriceCents
      }
    }
  }
}
    `;
export const ClientProjectListItemFragmentDoc = `
    fragment ClientProjectListItem on ClientOrder {
  id
  humanId
  showUrl
  description
  productCount
  status
  createdAt
  externalPoReference
  deliveryWindow
  salesLeads {
    id
    fullName
  }
  productionLeads {
    id
    fullName
  }
  operationsLeads {
    id
    fullName
  }
  designLeads {
    id
    fullName
  }
  financialLeads {
    id
    fullName
  }
  impactLeads {
    id
    fullName
  }
  impactReport {
    id
  }
  client {
    name
    showUrl
  }
  makers {
    nodes {
      id
      name
      showUrl
    }
  }
  makerOrders {
    nodes {
      id
      humanId
      makerId
      status
      showUrl
      timeAndAction {
        id
        humanId
        showUrl
      }
      productionStatus
      shipmentStatus
      moCutDate
      exFactoryDate
      activeTaskCount
      countriesOfOrigin {
        id
        name
      }
      shipment {
        id
        shippingMode
        departureShippingPort {
          id
          port
        }
        arrivalShippingPort {
          id
          port
        }
        departingPortAt
        arrivingPortAt
        vesselStatus
        customsStatus
        deliveredOn
        finalMileDelivery
        shipmentDocuments {
          id
          documentType
          fileName
        }
        parcelCarrier {
          id
          name
        }
        trackingNumbers
      }
    }
  }
}
    `;
export const ClientOrderHistoryMakerFragmentDoc = `
    fragment ClientOrderHistoryMaker on ClientOrder {
  id
  orderChanges {
    description
    createdAt
    ownerName
  }
}
    `;
export const ClientOrderShowMakerFragmentDoc = `
    fragment ClientOrderShowMaker on ClientOrder {
  id
  humanId
  description
  createdAt
  editUrl
  duplicateUrl
  totalPriceLooseCents
  totalUnits
  totalSkuUnits
  totalUniqueProducts
  paymentTerms
  acceptedByClient
  hasAcceptedMakerOrders
  internalNotes
  totalCostCents
  totalMargin
  status
  showUrl
  statusOptions
  salesPresentationsUrl
  newSalesPresentationUrl
  clientApprovalOrdersUrl
  newClientApprovalOrderUrl
  makerOrdersUrl
  timeAndActionsUrl
  newTimeAndActionUrl
  newMakerOrderUrl
  newImpactReportUrl
  externalPoReference
  deliveryWindow
  clientSoPo {
    imgixUrl
    filename
    attachmentUrl
    url
  }
  creatorUser {
    id
    fullName
  }
  salesLeads {
    id
    fullName
  }
  productionLeads {
    id
    fullName
  }
  operationsLeads {
    id
    fullName
  }
  impactLeads {
    id
    fullName
  }
  designLeads {
    id
    fullName
  }
  financialLeads {
    id
    fullName
  }
  leadOptions {
    id
    fullName
  }
  impactReport {
    id
    showUrl
  }
  referenceImages {
    filename
    url
    imgixUrl
    attachmentUrl
  }
  salesPresentations(first: 3) {
    nodes {
      id
      humanId
      pdfStatus
      humanPdfStatus
      showUrl
      createdAt
    }
  }
  clientApprovalOrders(first: 3) {
    nodes {
      id
      humanId
      status
      humanStatus
      showUrl
      createdAt
    }
  }
  makerOrders {
    nodes {
      id
      humanId
      status
      humanStatus
      accepted
      showUrl
      createdAt
      maker {
        id
        name
      }
    }
  }
  timeAndActions {
    nodes {
      id
      humanId
      showUrl
      active
      createdAt
      maker {
        id
        name
      }
    }
  }
  client {
    id
    showUrl
    name
  }
  shippingAddress {
    plain
    label
    contactName
    contactPhone
    contactEmail
    addressType
    deliveryAppointmentRequired
    dock
    warehouseAddressNotes
  }
  billingAddress {
    plain
    label
    contactName
    contactPhone
    contactEmail
    addressType
    deliveryAppointmentRequired
    dock
    warehouseAddressNotes
  }
  contacts {
    id
    fullName
    jobTitle
    phone
    email
  }
  makers {
    nodes {
      id
      name
      logoUrlWithFallback
      showUrl
      orderMinimumCents
    }
  }
  clientOrderProducts {
    nodes {
      id
      makerId
      totalCostCents
      totalPriceCents
      includeShippingCosts
      includeDutyCosts
      importShippingPort {
        id
        abbreviation
        modeOfTransit
      }
      exportShippingPort {
        id
        abbreviation
        modeOfTransit
      }
      image {
        id
        imgixUrl
      }
      product {
        name
        description
        variantName
        showUrl
        countryOfOrigin {
          name
        }
        dimension {
          widthCm
          heightCm
          lengthCm
        }
        materials {
          nodes {
            name
          }
        }
        materialSubcategories {
          nodes {
            name
            material {
              name
            }
          }
        }
        imageWithFallback {
          imgixUrl
        }
        image {
          id
          imgixUrl
        }
        skus {
          id
          variantDisplayName
        }
        npaVariants {
          id
          name
          npaVariantTemplateId
          npaVariantOptions {
            id
            name
            position
          }
        }
        variants {
          id
          name
        }
        productGroup {
          name
          showUrl
          customizationCategories
          minimumCogsColumnQuantity
          addons {
            id
            name
          }
          customizations {
            id
            name
            customizationCategoryName
          }
        }
      }
      clientOrderProductSkus {
        id
        quantity
        perItemAmountCents
        cogsPerItemAmountCents
        margin
        calculatedMargin
        perItemPrice
        calculatedPerItemPrice
        totalPriceCents
        msrp
        shippingCostsCents
        dutyCostsCents
        totalEnergyConservedKwh
        totalWaterSavedLiters
        totalEmissionsAvoidedKg
        totalFairWageHoursWorked
        totalPesticidesAvoidedG
        totalCarbonOffsetKg
        totalWasteDivertedG
        totalRecycledWaterBottles
        totalBulbEnergySavedHours
        totalDrivingEmissionsAvoidedKm
        totalDrinkingWaterSavedDays
        totalLandSavedFromPesticidesM2
        editCostUrl
        countryOfOrigin {
          id
          shortName: iso3166
        }
        sku {
          humanId
          variant {
            id
            name
          }
          npaVariantOptions {
            id
            name
            npaVariantId
            position
          }
        }
      }
      clientOrderProductCustomizations {
        id
        quantity
        perItemAmountCents
        margin
        calculatedMargin
        perItemPrice
        calculatedPerItemPrice
        totalPriceCents
        editUrl
        editCostUrl
        customization {
          name
          customizationCategoryName
          acceptsArtwork
        }
        customizationArtworks {
          id
          designName
          imprintType
          designLocation
          designSize
          designColor
          artwork {
            url
          }
        }
      }
      clientOrderProductAddons {
        id
        quantity
        perItemAmountCents
        margin
        calculatedMargin
        perItemPrice
        calculatedPerItemPrice
        totalPriceCents
        editCostUrl
        addon {
          name
        }
      }
      clientOrderProductLineItems {
        id
        name
        quantity
        perItemCost
        margin
        calculatedMargin
        perItemPrice
        calculatedPerItemPrice
        totalPriceCents
      }
    }
  }
}
    `;
export const ClientSearchClientFragmentDoc = `
    fragment ClientSearchClient on Client {
  id
  name
  humanId
  showUrl
}
    `;
export const ImpactReportListItemFragmentDoc = `
    fragment ImpactReportListItem on ImpactReport {
  id
  humanId
  type
  showUrl
  createdAt
  description
  client {
    id
    name
    showUrl
  }
  clientOrders {
    id
    humanId
    showUrl
    deliveryWindow
    createdAt
  }
  makers {
    nodes {
      id
      name
      showUrl
    }
  }
}
    `;
export const ProductAttributeWithIconFragmentDoc = `
    fragment ProductAttributeWithIcon on ProductAttribute {
  id
  icon {
    imgixUrl
  }
  name
}
    `;
export const CertificationWithIconFragmentDoc = `
    fragment CertificationWithIcon on Certification {
  id
  icon {
    imgixUrl
  }
  name
}
    `;
export const ImpactReportShowMakerFragmentDoc = `
    fragment ImpactReportShowMaker on ImpactReport {
  id
  showUrl
  indexUrl
  impactReportCopiesUrl
  clientId
  type
  description
  year
  overviewCopyId
  impactDescriptionCopyId
  carbonOffsettingDescriptionCopyId
  disclaimerNotesCopyId
  conclusionCopyId
  productAttributes(first: 100) {
    nodes {
      ...ProductAttributeWithIcon
    }
  }
  clientOrders {
    id
  }
  client {
    name
  }
  clientOptions {
    id
    name
  }
  typeOptions
  impactReportCopyOptions {
    id
    type
    name
    content
  }
  certificationOptions {
    id
    name
  }
  certifications {
    nodes {
      id
      name
    }
  }
  makerCertifications(first: 100) {
    nodes {
      id
      maker {
        id
      }
      certification {
        ...CertificationWithIcon
      }
    }
  }
  makerMarketingImage {
    id
    imgixUrl
  }
  makerMarketingImages(first: 50) {
    nodes {
      id
      imgixUrl
    }
  }
  makers {
    nodes {
      id
      profile
      socialImpactDescription
      environmentalImpactDescription
      impactReportImage(impactReportId: $id) {
        id
        imgixUrl
        className
      }
      makerCertifications(first: 100) {
        nodes {
          id
          certification {
            ...CertificationWithIcon
          }
        }
      }
      impactReportClientOrderProducts(impactReportId: $id) {
        id
        totalEnergyConservedKwh
        totalWaterSavedLiters
        totalEmissionsAvoidedKg
        totalFairWageHoursWorked
        totalRecycledWaterBottles
        totalPesticidesAvoidedG
        product {
          id
          name
          productAttributes {
            ...ProductAttributeWithIcon
          }
          impactReportImage(impactReportId: $id) {
            id
            imgixUrl
            className
          }
          countryOfOrigin {
            name
          }
          materials {
            nodes {
              name
            }
          }
        }
      }
    }
  }
}
    ${ProductAttributeWithIconFragmentDoc}
${CertificationWithIconFragmentDoc}`;
export const DownloadAttachmentFragmentDoc = `
    fragment DownloadAttachment on Attachment {
  downloadUrl: url(download: true)
  filename
}
    `;
export const MakerDocumentsFragmentDoc = `
    fragment MakerDocuments on Maker {
  id
  editUrl
  newMakerCertificationUrl
  makerCertifications(first: 50) {
    nodes {
      id
      certification {
        id
        name
        icon {
          imgixUrl
        }
      }
      certifier
      activeFrom
      expiredAt
      documentUrlInline: documentUrl(download: false)
      documentUrlAttachment: documentUrl(download: true)
      editUrl
    }
  }
  newMakerNdaUrl
  makerNdas(first: 50) {
    nodes {
      id
      documentType
      signedByName
      signedByPosition
      dateOfSignature
      expirationDate
      editUrl
      documentUrlInline: documentUrl(download: false)
      documentUrlAttachment: documentUrl(download: true)
    }
  }
  newMakerVettingSurveyUrl
  makerVettingSurveys(first: 50) {
    nodes {
      id
      completedBy {
        id
        fullName
        email
        jobTitle
      }
      completedAt
      approvedBy {
        id
        fullName
      }
      approvedAt
      editUrl
      surveys {
        ...DownloadAttachment
      }
    }
  }
  newMakerAuditUrl
  makerAudits(first: 50) {
    nodes {
      id
      name
      dateOfCompletion
      expirationDate
      performedBy
      results
      editUrl
      documents {
        ...DownloadAttachment
      }
    }
  }
  newMakerDocumentUrl
  makerDocuments {
    nodes {
      id
      createdAt
      documentType
      fileName
      documentUrlInline: documentUrl(download: false)
      documentUrlAttachment: documentUrl(download: true)
      editUrl
    }
  }
}
    ${DownloadAttachmentFragmentDoc}`;
export const MakerEditMakerFragmentDoc = `
    fragment MakerEditMaker on Maker {
  id
  slug
  name
  brandName
  logoUrlWithFallback
  fallbackLogoUrl
  updatedAt
  vettingStatus
  orderStatus
  status
  showUrl
  editUrl
  ttmMakerSince
  url
  makerTypes
  environments
  capabilities
  moqPriceCents
  moqUnits
  moqNotes
  productionCapacity
  productionCapacityNotes
  internalNotes
  profile
  licenses
  customers
  socialImpactDescription
  environmentalImpactDescription
  funFact
  hangTagLanguage
  numberOfEmployees
  numberOfWomenEmployees
  score
  internalOperationNotes
  exportExperience
  address
  resourceUrl
  newMakerMarketingImageUrl
  newMakerProductCategoryUrl
  newMakerMaterialUrl
  orderStatusOptions
  makerTypeOptions
  makerEnvironmentsOptions
  makerCapabilitiesOptions
  customersOptions
  licensesOptions
  vettingStatusOptions
  productionCapacityOptions
  countries {
    nodes {
      id
      name
    }
  }
  countriesOptions {
    id
    name
  }
  valueAlignments {
    id
    name
  }
  valueAlignmentsOptions {
    id
    name
  }
  incoterms {
    nodes {
      id
      name
    }
  }
  incotermsOptions {
    id
    name
  }
  parcelCarriers {
    nodes {
      id
      name
    }
  }
  parcelCarriersOptions {
    id
    name
  }
  makerCertifications {
    nodes {
      certificationType
    }
  }
  makerMarketingImages {
    nodes {
      id
      imgixUrl
      filename
      editUrl
      resourceUrl
      includeInImpactReport
      discardedAt
    }
  }
  makerMaterials {
    nodes {
      id
      editUrl
      material {
        id
        name
      }
      materialSubcategories {
        nodes {
          id
          name
        }
      }
    }
  }
  makerProductCategories(first: 50) {
    nodes {
      id
      productCategory {
        id
        name
      }
      productSubcategories {
        nodes {
          id
          name
        }
      }
      editUrl
    }
  }
  makerMakerQuestions {
    nodes {
      id
      response
      responseText
      makerQuestionId
    }
  }
  makerQuestions {
    nodes {
      id
      question
    }
  }
  makerMakerAttributes {
    nodes {
      id
      response
      responseText
      makerAttributeId
    }
  }
  makerAttributes {
    nodes {
      id
      text
    }
  }
}
    `;
export const MakerOrderEditMakerFragmentDoc = `
    fragment MakerOrderEditMaker on MakerOrder {
  id
  label
  showUrl
  status
  makerShowUrl
  makerLegalAgreementsUrl
  incotermsUrl
  makerLegalAgreementId
  incotermId
  mailCarrierId
  inHandsOn
  exFactoryDate
  moCutDate
  productionNotes
  trackingInfo
  packingAndShippingNotes
  clientInfoVisibleToMaker
  paymentTerms
  addressesUrl
  issuedTo
  billingConsigneeAddress {
    id
    label
    plain
  }
  billingConsigneeAddressOptions {
    id
    label
    plain
  }
  client {
    id
    name
  }
  contacts {
    id
    fullName
    email
    phone
    jobTitle
  }
  clientOrder {
    shippingAddress {
      plain
      label
      contactName
      contactPhone
    }
  }
  makerLegalAgreementOptions {
    id
    name
  }
  incotermOptions {
    id
    name
  }
  mailCarrierOptions {
    id
    name
  }
  shipment {
    id
    shippingMode
    vesselStatus
    customsStatus
    finalMileDelivery
    departingPortAt
    arrivingPortAt
    deliveredOn
    trackingNumbers
    parcelCarrier {
      id
      name
    }
    arrivalShippingPort {
      id
    }
    departureShippingPort {
      id
    }
    newShipmentDocumentUrl
    shipmentDocuments {
      id
      createdAt
      documentType
      fileName
      editUrl
    }
  }
  shippingModeOptions {
    value
    label
  }
  vesselStatusOptions {
    value
    label
  }
  customsStatusOptions {
    value
    label
  }
  finalMileDeliveryOptions {
    value
    label
  }
  exportShippingPortOptions {
    id
    port
  }
  importShippingPortOptions {
    id
    port
  }
  parcelCarrierOptions {
    id
    name
  }
  contactOptions {
    id
    fullName
    email
    phone
    jobTitle
  }
}
    `;
export const ContactFragmentDoc = `
    fragment Contact on Contact {
  id
  fullName
  jobTitle
  phone
  email
  timezoneLabel
}
    `;
export const MakerLogisticsFragmentDoc = `
    fragment MakerLogistics on Maker {
  id
  address
  editUrl
  newMakerShippingPortUrl
  makerShippingPorts(first: 50) {
    nodes {
      id
      default
      editUrl
      shippingPort {
        id
        port
        locationType
        abbreviation
        country {
          name
        }
        modeOfTransit
      }
    }
  }
  exportExperience
  exportingCountries {
    nodes {
      id
      name
    }
  }
  internalOperationNotes
  makerContacts {
    nodes {
      id
      editUrl
      default
      archived
      contact {
        ...Contact
      }
    }
  }
  newMakerContactUrl
  incoterms {
    nodes {
      id
      name
    }
  }
  parcelCarriers {
    nodes {
      id
      name
    }
  }
  exportExperienceOptions
  countriesOptions {
    id
    name
  }
  incotermsOptions {
    id
    name
  }
  parcelCarriersOptions {
    id
    name
  }
}
    ${ContactFragmentDoc}`;
export const MakerOrderListItemFragmentDoc = `
    fragment MakerOrderListItem on MakerOrder {
  id
  humanId
  showUrl
  status
  humanStatus
  createdAt
  exFactoryDate
  inHandsOn
  clientOrder {
    description
  }
  maker {
    id
    name
    showUrl
  }
}
    `;
export const MakerOrderShowMakerFragmentDoc = `
    fragment MakerOrderShowMaker on MakerOrder {
  id
  humanId
  makerId
  editUrl
  showUrl
  newTnaUrl
  label
  status
  shipmentStatus
  createdAt
  updatedAt
  productionStatusReadable
  productCount
  totalUnits
  totalCost
  issuedTo
  countriesOfOrigin {
    id
    name
  }
  exFactoryDate
  moCutDate
  incoterm {
    id
    name
  }
  paymentTerms
  mailCarrier {
    id
    name
  }
  client {
    id
    name
  }
  contacts {
    id
    fullName
    jobTitle
    phone
    email
  }
  billingConsigneeAddress {
    id
    label
    plain
    contactName
    contactPhone
  }
  clientOrder {
    id
    showUrl
    humanId
    description
    shippingAddress {
      id
      label
      plain
      contactName
      contactPhone
    }
  }
  statusOptions {
    value
    label
  }
  shipmentStatusOptions {
    value
    label
  }
  timeAndAction {
    id
  }
  clientInfoVisibleToMaker
  sampleOrders {
    id
    humanId
    sampleOrderType {
      name
      displayName
    }
    status
    shipsOn
    shippingAddress {
      id
      label
      plain
      contactName
      contactPhone
    }
    mailCarrier
    trackingNumber
    dispatchedOn
    notes
    sampleOrderSkus {
      id
      sku {
        id
        humanId
      }
      quantity
    }
  }
  shipment {
    id
    departureShippingPort {
      id
      port
    }
    arrivalShippingPort {
      id
      port
    }
    parcelCarrier {
      id
      name
    }
    trackingNumbers
    shippingMode
    vesselStatus
    customsStatus
    finalMileDelivery
    departingPortAt
    arrivingPortAt
    newShipmentDocumentUrl
    deliveredOn
    shipmentDocuments {
      id
      createdAt
      documentType
      fileName
      editUrl
      documentUrlInline: documentUrl(download: false)
      documentUrlAttachment: documentUrl(download: true)
    }
  }
  shippingModeOptions {
    value
    label
  }
  vesselStatusOptions {
    value
    label
  }
  customsStatusOptions {
    value
    label
  }
  finalMileDeliveryOptions {
    value
    label
  }
  productionNotes
  trackingInfo
  packingAndShippingNotes
  shared
  maker {
    id
    name
  }
}
    `;
export const MakerShowMakerFragmentDoc = `
    fragment MakerShowMaker on Maker {
  id
  humanId
  slug
  name
  brandName
  logoUrlWithFallback
  updatedAt
  vettingStatus
  orderStatus
  status
  editUrl
  ttmMakerSince
  url
  makerTypes
  environments
  capabilities
  makerCertificationTypes
  moqPriceCents
  moqUnits
  moqNotes
  productionCapacity
  productionCapacityNotes
  internalNotes
  profile
  licenses
  customers
  socialImpactDescription
  environmentalImpactDescription
  funFact
  hangTagLanguage
  numberOfEmployees
  numberOfWomenEmployees
  score
  newMakerMarketingImageUrl
  newMakerProductCategoryUrl
  newMakerMaterialUrl
  makerCertifications {
    nodes {
      certificationType
      expiredAt
    }
  }
  makerContacts {
    nodes {
      id
      editUrl
      default
      archived
      contact {
        ...Contact
      }
    }
  }
  makerMarketingImages {
    nodes {
      id
      imgixUrl
      filename
      editUrl
      resourceUrl
      includeInImpactReport
      description
      discardedAt
    }
  }
  valueAlignments {
    id
    name
  }
  materials {
    nodes {
      id
      name
    }
  }
  makerMaterials {
    nodes {
      id
      editUrl
      material {
        id
        name
      }
      materialSubcategories {
        nodes {
          id
          name
        }
      }
    }
  }
  products(first: 6) {
    nodes {
      id
      name
      description
      showUrl
      imageWithFallback {
        id
        imgixUrl
      }
      image {
        id
        imgixUrl
      }
    }
  }
  makerProductCategories(first: 50) {
    nodes {
      id
      productCategory {
        id
        name
      }
      productSubcategories {
        nodes {
          id
          name
        }
      }
      editUrl
    }
  }
  countries {
    nodes {
      id
      name
      region {
        id
        name
      }
    }
  }
  makerMakerQuestions {
    nodes {
      id
      response
      responseText
      makerQuestionId
    }
  }
  makerQuestions {
    nodes {
      id
      question
    }
  }
  makerMakerAttributes {
    nodes {
      id
      response
      responseText
      makerAttributeId
    }
  }
  makerAttributes {
    nodes {
      id
      text
    }
  }
  makerScore {
    overallScore
    overallScorePercentile
    coreScore
    coreScorePercentile
    performanceScore
    performanceScorePercentile
    showBreakdown
    overallValueAlignment
    certificationsAndAudits
    amenitiesAndSocialServices
    environmentalPoliciesAndInitiatives
    employeePolicies
    operationalPolicies
    onboardingParticipation
    samplingExperience
    productionExperience
    makerCommunication
    sustainableMaterials
    environmentalFacilities
    environmentallyFriendly
    fairtrade
    fairLaborPractices
    specialSocialPrograms
    womenOwned
    inclusiveOwnership
    unionGroup
    bCorp
    certifications
    audits
    generalServices
    healthcare
    ppe
    training
    socialServices
    localCommunityServices
    environmentalPolicy
    sustainabilityFramework
    designatedStaff
    reductionTargets
    recycling
    trackingAndReporting
    riskAssessment
    hazardousChemicalRecords
    handbook
    compensationPolicy
    leavePolicy
    harassmentPolicy
    maternityLeave
    fireAndSafetyPolicy
    qualityControlPolicy
    vettingSurveyCurrency
    ttmAgreements
    trainingParticipation
    samplingTiming
    samplingQuality
    samplingCost
    productionTiming
    productionQuality
    productionCost
    correspondence
    communications
    platformUse
    createdAt
    updatedAt
  }
}
    ${ContactFragmentDoc}`;
export const ProductEditMakerFragmentDoc = `
    fragment ProductEditMaker on Product {
  id
  updatedAt
  status
  name
  description
  styleNumber
  productionMethod
  htsCode
  fabricType
  availableUntil
  internalNotes
  showUrl
  resourceUrl
  newProductCategoryUrl
  newProductMaterialUrl
  newProductNameAliasUrl
  newProductSkuAliasUrl
  makerName
  variantName
  dimension {
    weightKg
    heightCm
    widthCm
    lengthCm
  }
  variants {
    id
    name
    dimension {
      id
      weightKg
      heightCm
      widthCm
      lengthCm
    }
  }
  npaVariants {
    id
    name
    editUrl
    npaVariantOptions {
      id
      name
      makerName
      position
    }
  }
  newNpaVariantUrl
  makerTypes
  environments
  makerCapabilities
  makerTypeOptions
  environmentsOptions
  makerCapabilitiesOptions
  htsCodeOptions
  fabricTypeOptions
  productionMethodOptions
  socialImpactMetricsEnabled
  fairWagePerHour
  equivalencesEnabled
  landSavedFromPesticidesM2
  drivingEmissionsAvoidedKm
  bulbEnergySavedHours
  drinkingWaterSavedDays
  environmentalImpactMetricsEnabled
  energyConservedKwh
  waterSavedLiters
  emissionsAvoidedKg
  pesticidesAvoidedG
  wasteDivertedG
  recycledWaterBottles
  carbonOffsetMetricsEnabled
  carbonOffsetKg
  carbonOffsetAsKmOfDriving
  carbonOffsetAsTransatlanticFlights
  carbonOffsetAsPhonesCharged
  countryOptions {
    id
    nameWithFlag
  }
  npaVariantTemplateOptions {
    id
    name
    npaVariantTemplateOptions {
      id
      name
    }
  }
  maker {
    name
    showUrl
  }
  makerCountry {
    id
    name
  }
  shipsFromCountry {
    id
    name
  }
  countryOfOrigin {
    id
    name
  }
  imageWithFallback {
    id
    imgixUrl
  }
  image {
    id
    imgixUrl
  }
  images {
    id
    imgixUrl
    filename
  }
  infoImages {
    id
    imgixUrl
    filename
  }
  techPack {
    filename
  }
  makerAttributes {
    id
    text
  }
  selectedMakerAttributes {
    id
    text
  }
  valueAlignments {
    id
    name
  }
  valueAlignmentsOptions {
    id
    name
  }
  productAttributes {
    id
    name
  }
  productAttributeOptions {
    id
    name
  }
  productProductCategories {
    nodes {
      id
      editUrl
      productCategory {
        id
        name
      }
      productSubcategories {
        nodes {
          id
          name
        }
      }
    }
  }
  productCategories {
    id
    name
    productSubcategories {
      nodes {
        id
        name
      }
    }
  }
  productMaterials {
    nodes {
      id
      editUrl
      material {
        name
      }
      materialSubcategories {
        nodes {
          id
          name
        }
      }
    }
  }
  nameAliases {
    id
    name
    createdAt
    editUrl
    resourceUrl
  }
  skuAliases {
    id
    sku
    createdAt
    editUrl
    resourceUrl
  }
}
    `;
export const ProductGroupEditMakerFragmentDoc = `
    fragment ProductGroupEditMaker on ProductGroup {
  id
  name
  humanId
  updatedAt
  status
  showUrl
  description
  htsCode
  newProductGroupNameAliasUrl
  newProductGroupStyleNumberAliasUrl
  htsCodeOptions
  fabricTypeOptions
  countries {
    nodes {
      id
      name
      region {
        id
        name
      }
    }
  }
  images {
    id
    imgixUrl
    filename
  }
  techPack {
    filename
    url
  }
  nameAliases {
    id
    name
    createdAt
    editUrl
    resourceUrl
  }
  styleNumberAliases {
    id
    styleNumber
    createdAt
    editUrl
    resourceUrl
  }
  productCategories {
    name
  }
}
    `;
export const ProductGroupShowMakerFragmentDoc = `
    fragment ProductGroupShowMaker on ProductGroup {
  id
  name
  humanId
  updatedAt
  status
  editUrl
  newProductUrl
  makerName
  description
  htsCode
  previousBuyers
  environments
  makerCertificationTypes
  productionMethods
  makerCountries {
    name
  }
  countries {
    nodes {
      id
      name
      region {
        id
        name
      }
    }
  }
  images {
    id
    imgixUrl
    filename
  }
  techPack {
    filename
    url
  }
  nameAliases {
    id
    name
    createdAt
  }
  styleNumberAliases {
    id
    styleNumber
    createdAt
  }
  productCategories {
    name
  }
  valueAlignments {
    name
  }
  makerAttributes {
    id
    text
  }
  products {
    id
    name
    humanId
    description
    variantName
    maxCapacity
    availableUntil
    showUrl
    duplicateUrl
    materials {
      nodes {
        id
        name
      }
    }
    countryOfOrigin {
      name
    }
    images {
      id
      imgixUrl
    }
    variants {
      id
      name
    }
    npaVariants {
      id
      name
    }
  }
  maker {
    name
    editUrl
    makerTypes
    capabilities
    socialImpactDescription
    environmentalImpactDescription
    countries {
      nodes {
        name
      }
    }
    shippingPorts {
      nodes {
        port
      }
    }
  }
}
    `;
export const ProductGroupProfilePricingAndLogisticsMakerFragmentDoc = `
    fragment ProductGroupProfilePricingAndLogisticsMaker on ProductGroup {
  id
  products {
    id
    name
    productGroup {
      id
      cogsColumns {
        id
        unitsMin
      }
    }
    variants {
      id
      name
      costCents
      cogsVariantCells {
        id
        cogsColumnId
        turnaroundTimeString
        perItemAmountCents
      }
    }
    skus {
      id
      humanId
      variant {
        name
        htsCode
        weightKg
        heightCm
        widthCm
        lengthCm
        shippingPriceBy
      }
    }
  }
  maker {
    id
    defaultAirShippingPort {
      id
    }
    defaultSeaShippingPort {
      id
    }
    shippingPorts {
      nodes {
        id
        modeOfTransit
      }
    }
  }
}
    `;
export const ProductProfilePricingAndLogisticsMakerFragmentDoc = `
    fragment ProductProfilePricingAndLogisticsMaker on Product {
  id
  name
  variantName
  editCogsVariantCellsUrl
  variants {
    id
    name
  }
  npaVariants {
    id
    name
  }
  productGroup {
    id
    cogsColumns {
      id
      unitsMin
    }
  }
  variants {
    id
    name
    costCents
    cogsVariantCells {
      id
      cogsColumnId
      turnaroundTimeString
      perItemAmountCents
    }
  }
  skus {
    id
    humanId
    variant {
      name
      htsCode
      weightKg
      heightCm
      widthCm
      lengthCm
      shippingPriceBy
    }
    npaVariantOptions {
      id
      npaVariantId
      name
    }
  }
  maker {
    id
    defaultAirShippingPort {
      id
    }
    defaultSeaShippingPort {
      id
    }
    shippingPorts {
      nodes {
        id
        modeOfTransit
      }
    }
  }
}
    `;
export const ProductAttributeListFragmentDoc = `
    fragment ProductAttributeList on Product {
  productAttributes {
    name
    icon {
      imgixUrl
    }
  }
}
    `;
export const ProductShowMakerFragmentDoc = `
    fragment ProductShowMaker on Product {
  id
  name
  updatedAt
  status
  editUrl
  makerName
  description
  styleNumber
  productionMethod
  htsCode
  fabricType
  availableUntil
  maxCapacity
  internalNotes
  previousBuyers
  environments
  makerCapabilities
  makerTypes
  makerCertificationTypes
  socialImpactMetricsEnabled
  fairWagePerHour
  equivalencesEnabled
  landSavedFromPesticidesM2
  drivingEmissionsAvoidedKm
  bulbEnergySavedHours
  drinkingWaterSavedDays
  environmentalImpactMetricsEnabled
  energyConservedKwh
  waterSavedLiters
  emissionsAvoidedKg
  pesticidesAvoidedG
  wasteDivertedG
  recycledWaterBottles
  carbonOffsetMetricsEnabled
  carbonOffsetKg
  carbonOffsetAsKmOfDriving
  carbonOffsetAsTransatlanticFlights
  carbonOffsetAsPhonesCharged
  newProductCategoryUrl
  newProductMaterialUrl
  ...ProductAttributeList
  variants {
    id
    name
    dimension {
      weightKg
      heightCm
      widthCm
      lengthCm
    }
  }
  dimension {
    weightKg
    heightCm
    widthCm
    lengthCm
  }
  npaVariants {
    id
    name
    npaVariantOptions {
      id
      name
      makerName
      position
    }
  }
  productProductCategories {
    nodes {
      id
      editUrl
      productCategory {
        id
        name
      }
      productSubcategories {
        nodes {
          id
          name
        }
      }
    }
  }
  productCategories {
    id
    name
    productSubcategories {
      nodes {
        id
        name
      }
    }
  }
  productMaterials {
    nodes {
      id
      editUrl
      material {
        name
      }
      materialSubcategories {
        nodes {
          id
          name
        }
      }
    }
  }
  images {
    id
    imgixUrl
    filename
  }
  techPack {
    filename
    url
  }
  nameAliases {
    id
    name
    createdAt
    editUrl
    resourceUrl
  }
  skuAliases {
    id
    sku
    createdAt
    editUrl
    resourceUrl
  }
  image {
    id
    imgixUrl
  }
  imageWithFallback {
    id
    imgixUrl
  }
  productGroup {
    name
    showUrl
  }
  makerCountry {
    name
  }
  shipsFromCountry {
    name
  }
  countryOfOrigin {
    name
  }
  valueAlignments {
    name
  }
  makerAttributes {
    id
    text
  }
  selectedMakerAttributes {
    id
    text
  }
  maker {
    id
    name
    editUrl
    countries {
      nodes {
        name
      }
    }
    shippingPorts {
      nodes {
        port
      }
    }
  }
}
    ${ProductAttributeListFragmentDoc}`;
export const ProductSearchListItemFragmentDoc = `
    fragment ProductSearchListItem on Product {
  id
  name
  isArchived
  showUrl
  image {
    imgixUrl
  }
  imageWithFallback {
    imgixUrl
  }
  image {
    id
    imgixUrl
  }
  productGroup {
    id
    showUrl
    name
  }
  variants {
    id
    name
  }
  maker {
    id
    name
    showUrl
    environments
    makerTypes
    capabilities
  }
  productCategories {
    id
    name
    productSubcategories {
      nodes {
        id
        name
      }
    }
  }
  productAttributes {
    id
    name
  }
  makerAttributes {
    id
    text
  }
  price {
    amount
    quantity
  }
  minimumOrderQuantity
  materials {
    nodes {
      id
      name
    }
  }
  materialSubcategories {
    nodes {
      id
      name
    }
  }
  customizations
  subcategories
  previousBuyers
  makerCertificationTypes
  styleNumber
  countryOfOrigin {
    id
    name
    iso3166
  }
  skus {
    id
    humanId
  }
  nameAliases {
    id
    name
  }
}
    `;
export const ShippingPortListItemFragmentDoc = `
    fragment ShippingPortListItem on ShippingPort {
  id
  port
  locationType
  modeOfTransit
  country {
    id
    name
  }
}
    `;
export const TimeAndActionCalendarFragmentDoc = `
    fragment TimeAndActionCalendar on TimeAndAction {
  id
  humanId
  description
  active
  createdAt
  updatedAt
  editUrl
  showUrl
  taskStatusOptions {
    value
    label
  }
  maker {
    id
    humanId
    name
  }
  clientOrder {
    id
    humanId
  }
  calendar {
    id
    name
    tasks {
      nodes {
        id
        name
        stage
        stageHumanized
        status
        position
        dueDate
        startDate
        actualStartDate
        dateCompleted
        durationDays
        remindersOn
        displayToMaker
        remindersUrl
        pastDue
        owners {
          nodes {
            id
            maker
            user {
              id
              fullName
            }
          }
        }
        taskChanges {
          id
          user {
            displayName
          }
          description
          responsible
          createdAt
          notes
          relatedDescription
        }
        activeChangeRequest {
          id
          status
          dueDate
          startDate
          existingDueDate
          existingStartDate
          jobPosition
          notes
          responsible
        }
        changeRequests {
          id
          status
          dueDate
          startDate
          existingDueDate
          existingStartDate
          jobPosition
          notes
          responsible
        }
      }
    }
    calendarChanges {
      id
      user {
        displayName
      }
      description
      responsible
      createdAt
      notes
      relatedDescription
    }
  }
  ownerOptions {
    id
    fullName
  }
}
    `;
export const TimeAndActionCalendarTemplateEditCalendarFragmentDoc = `
    fragment TimeAndActionCalendarTemplateEditCalendar on TimeAndActionCalendarTemplate {
  id
  name
  tasks {
    nodes {
      id
      name
      stage
      status
      position
      dueDate
      startDate
      actualStartDate
      dateCompleted
      durationDays
      remindersOn
      displayToMaker
      owners {
        nodes {
          id
          maker
          user {
            id
            fullName
          }
        }
      }
    }
  }
}
    `;
export const MakerSearchMakerFragmentDoc = `
    fragment MakerSearchMaker on Maker {
  id
  name
  status
  address
  editUrl
  showUrl
  logoUrlWithFallback
  productionCapacity
  makerCertificationTypes
  valueAlignments {
    id
    name
  }
  makerAttributes {
    nodes {
      id
      text
    }
  }
  makerMakerAttributes {
    nodes {
      id
      response
      responseText
      makerAttributeId
    }
  }
  environments
  capabilities
  costRangeEstimate
  mostRecentOrderDate
  subcategories
  materials {
    nodes {
      id
      name
    }
  }
  makerProductCategories {
    nodes {
      id
      productCategory {
        id
        name
      }
      subcategories
    }
  }
  countries {
    nodes {
      id
      iso3166
      name
    }
  }
}
    `;
export const ActiveClientOrderDocument = `
    query ActiveClientOrder {
  activeClientOrder {
    id
    clientOrder {
      ...ActiveClientOrderMaker
    }
  }
}
    ${ActiveClientOrderMakerFragmentDoc}`;
export const useActiveClientOrderQuery = <
      TData = ActiveClientOrderQuery,
      TError = unknown
    >(
      variables?: ActiveClientOrderQueryVariables,
      options?: UseQueryOptions<ActiveClientOrderQuery, TError, TData>
    ) =>
    useQuery<ActiveClientOrderQuery, TError, TData>(
      variables === undefined ? ['ActiveClientOrder'] : ['ActiveClientOrder', variables],
      graphqlFetcher<ActiveClientOrderQuery, ActiveClientOrderQueryVariables>(ActiveClientOrderDocument, variables),
      options
    );
useActiveClientOrderQuery.document = ActiveClientOrderDocument;


useActiveClientOrderQuery.getKey = (variables?: ActiveClientOrderQueryVariables) => variables === undefined ? ['ActiveClientOrder'] : ['ActiveClientOrder', variables];
;

export const ActiveMakerLegalAgreementsDocument = `
    query ActiveMakerLegalAgreements {
  activeMakerLegalAgreements {
    id
    name
  }
}
    `;
export const useActiveMakerLegalAgreementsQuery = <
      TData = ActiveMakerLegalAgreementsQuery,
      TError = unknown
    >(
      variables?: ActiveMakerLegalAgreementsQueryVariables,
      options?: UseQueryOptions<ActiveMakerLegalAgreementsQuery, TError, TData>
    ) =>
    useQuery<ActiveMakerLegalAgreementsQuery, TError, TData>(
      variables === undefined ? ['ActiveMakerLegalAgreements'] : ['ActiveMakerLegalAgreements', variables],
      graphqlFetcher<ActiveMakerLegalAgreementsQuery, ActiveMakerLegalAgreementsQueryVariables>(ActiveMakerLegalAgreementsDocument, variables),
      options
    );
useActiveMakerLegalAgreementsQuery.document = ActiveMakerLegalAgreementsDocument;


useActiveMakerLegalAgreementsQuery.getKey = (variables?: ActiveMakerLegalAgreementsQueryVariables) => variables === undefined ? ['ActiveMakerLegalAgreements'] : ['ActiveMakerLegalAgreements', variables];
;

export const AddProductsToClientOrderFormDocument = `
    query AddProductsToClientOrderForm($id: ID!, $clientOrderId: ID!, $unitCount: Int, $exportShippingPortId: ID, $importShippingPortId: ID) {
  product(id: $id) {
    variantName
    maker {
      id
    }
    npaVariants {
      id
      name
      npaVariantTemplateId
      npaVariantOptions {
        id
        name
        position
      }
    }
    variants {
      id
      name
    }
    skus {
      id
      humanId
      variantDisplayName
      variant {
        id
        name
        costCents(units: $unitCount)
        shippingCostCents(
          units: $unitCount
          exportShippingPortId: $exportShippingPortId
          importShippingPortId: $importShippingPortId
        )
        dutyCostCents(
          units: $unitCount
          exportShippingPortId: $exportShippingPortId
          importShippingPortId: $importShippingPortId
        )
      }
      npaVariantOptions {
        id
        npaVariant {
          id
        }
      }
    }
  }
  clientOrder(id: $clientOrderId) {
    showUrl
  }
}
    `;
export const useAddProductsToClientOrderFormQuery = <
      TData = AddProductsToClientOrderFormQuery,
      TError = unknown
    >(
      variables: AddProductsToClientOrderFormQueryVariables,
      options?: UseQueryOptions<AddProductsToClientOrderFormQuery, TError, TData>
    ) =>
    useQuery<AddProductsToClientOrderFormQuery, TError, TData>(
      ['AddProductsToClientOrderForm', variables],
      graphqlFetcher<AddProductsToClientOrderFormQuery, AddProductsToClientOrderFormQueryVariables>(AddProductsToClientOrderFormDocument, variables),
      options
    );
useAddProductsToClientOrderFormQuery.document = AddProductsToClientOrderFormDocument;


useAddProductsToClientOrderFormQuery.getKey = (variables: AddProductsToClientOrderFormQueryVariables) => ['AddProductsToClientOrderForm', variables];
;

export const ClientOrderEditDocument = `
    query ClientOrderEdit($id: ID!) {
  clientOrder(id: $id) {
    ...ClientOrderEditMaker
  }
}
    ${ClientOrderEditMakerFragmentDoc}`;
export const useClientOrderEditQuery = <
      TData = ClientOrderEditQuery,
      TError = unknown
    >(
      variables: ClientOrderEditQueryVariables,
      options?: UseQueryOptions<ClientOrderEditQuery, TError, TData>
    ) =>
    useQuery<ClientOrderEditQuery, TError, TData>(
      ['ClientOrderEdit', variables],
      graphqlFetcher<ClientOrderEditQuery, ClientOrderEditQueryVariables>(ClientOrderEditDocument, variables),
      options
    );
useClientOrderEditQuery.document = ClientOrderEditDocument;


useClientOrderEditQuery.getKey = (variables: ClientOrderEditQueryVariables) => ['ClientOrderEdit', variables];
;

export const AddSkusToClientOrderDocument = `
    mutation AddSkusToClientOrder($input: AddSkusToClientOrderInput!) {
  addSkusToClientOrder(input: $input) {
    clientOrder {
      showUrl
    }
  }
}
    `;
export const useAddSkusToClientOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddSkusToClientOrderMutation, TError, AddSkusToClientOrderMutationVariables, TContext>) =>
    useMutation<AddSkusToClientOrderMutation, TError, AddSkusToClientOrderMutationVariables, TContext>(
      'AddSkusToClientOrder',
      (variables?: AddSkusToClientOrderMutationVariables) => graphqlFetcher<AddSkusToClientOrderMutation, AddSkusToClientOrderMutationVariables>(AddSkusToClientOrderDocument, variables)(),
      options
    );
export const ClientOrderSearchDocument = `
    query ClientOrderSearch($tracker: String, $query: String, $after: String, $sorts: [ClientOrderSort!], $makers: [ID!], $clients: [ID!], $createdAfter: ISO8601DateTime, $createdBefore: ISO8601DateTime, $exFactoryDateAfter: ISO8601DateTime, $exFactoryDateBefore: ISO8601DateTime, $moCutDateAfter: ISO8601DateTime, $moCutDateBefore: ISO8601DateTime, $salesLead: [String!], $productionLead: [String!], $operationsLead: [String!], $financialLead: [String!], $impactLead: [String!], $designLead: [String!], $clientOrderStatus: [String!], $productionStatus: [String!], $shipmentStatus: [String!], $shippingMode: [String!], $vesselStatus: [String!], $customsStatus: [String!], $finalMileDelivery: [String!], $importPort: [String!], $exportPort: [String!], $shippingDocsPresent: Boolean, $bolPodDocsPresent: Boolean, $parcelCarrier: [String!]) {
  clientOrders(
    tracker: $tracker
    query: $query
    after: $after
    sorts: $sorts
    makers: $makers
    clients: $clients
    clientOrderStatus: $clientOrderStatus
    productionStatus: $productionStatus
    shipmentStatus: $shipmentStatus
    createdAfter: $createdAfter
    createdBefore: $createdBefore
    exFactoryDateAfter: $exFactoryDateAfter
    exFactoryDateBefore: $exFactoryDateBefore
    moCutDateAfter: $moCutDateAfter
    moCutDateBefore: $moCutDateBefore
    salesLead: $salesLead
    productionLead: $productionLead
    operationsLead: $operationsLead
    financialLead: $financialLead
    impactLead: $impactLead
    designLead: $designLead
    shippingMode: $shippingMode
    vesselStatus: $vesselStatus
    customsStatus: $customsStatus
    finalMileDelivery: $finalMileDelivery
    importPort: $importPort
    exportPort: $exportPort
    shippingDocsPresent: $shippingDocsPresent
    bolPodDocsPresent: $bolPodDocsPresent
    parcelCarrier: $parcelCarrier
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      ...ClientProjectListItem
    }
  }
}
    ${ClientProjectListItemFragmentDoc}`;
export const useClientOrderSearchQuery = <
      TData = ClientOrderSearchQuery,
      TError = unknown
    >(
      variables?: ClientOrderSearchQueryVariables,
      options?: UseQueryOptions<ClientOrderSearchQuery, TError, TData>
    ) =>
    useQuery<ClientOrderSearchQuery, TError, TData>(
      variables === undefined ? ['ClientOrderSearch'] : ['ClientOrderSearch', variables],
      graphqlFetcher<ClientOrderSearchQuery, ClientOrderSearchQueryVariables>(ClientOrderSearchDocument, variables),
      options
    );
useClientOrderSearchQuery.document = ClientOrderSearchDocument;


useClientOrderSearchQuery.getKey = (variables?: ClientOrderSearchQueryVariables) => variables === undefined ? ['ClientOrderSearch'] : ['ClientOrderSearch', variables];
;

export const ClientOrderHistoryDocument = `
    query ClientOrderHistory($id: ID!) {
  clientOrder(id: $id) {
    ...ClientOrderHistoryMaker
  }
}
    ${ClientOrderHistoryMakerFragmentDoc}`;
export const useClientOrderHistoryQuery = <
      TData = ClientOrderHistoryQuery,
      TError = unknown
    >(
      variables: ClientOrderHistoryQueryVariables,
      options?: UseQueryOptions<ClientOrderHistoryQuery, TError, TData>
    ) =>
    useQuery<ClientOrderHistoryQuery, TError, TData>(
      ['ClientOrderHistory', variables],
      graphqlFetcher<ClientOrderHistoryQuery, ClientOrderHistoryQueryVariables>(ClientOrderHistoryDocument, variables),
      options
    );
useClientOrderHistoryQuery.document = ClientOrderHistoryDocument;


useClientOrderHistoryQuery.getKey = (variables: ClientOrderHistoryQueryVariables) => ['ClientOrderHistory', variables];
;

export const ClientOrderSearchFilterOptionsDocument = `
    query ClientOrderSearchFilterOptions {
  clientOrderSearchFilterOptions {
    makers {
      id
      name
    }
    clients {
      id
      name
    }
    owners {
      id
      fullName
    }
    clientOrderStatuses {
      value
      label
    }
    productionStatuses {
      value
      label
    }
    shipmentStatuses {
      value
      label
    }
    vesselStatuses {
      value
      label
    }
    customsStatuses {
      value
      label
    }
    finalMileDeliveries {
      value
      label
    }
    shippingModes {
      value
      label
    }
    importPorts {
      id
      port
    }
    exportPorts {
      id
      port
    }
    parcelCarriers {
      id
      name
    }
  }
}
    `;
export const useClientOrderSearchFilterOptionsQuery = <
      TData = ClientOrderSearchFilterOptionsQuery,
      TError = unknown
    >(
      variables?: ClientOrderSearchFilterOptionsQueryVariables,
      options?: UseQueryOptions<ClientOrderSearchFilterOptionsQuery, TError, TData>
    ) =>
    useQuery<ClientOrderSearchFilterOptionsQuery, TError, TData>(
      variables === undefined ? ['ClientOrderSearchFilterOptions'] : ['ClientOrderSearchFilterOptions', variables],
      graphqlFetcher<ClientOrderSearchFilterOptionsQuery, ClientOrderSearchFilterOptionsQueryVariables>(ClientOrderSearchFilterOptionsDocument, variables),
      options
    );
useClientOrderSearchFilterOptionsQuery.document = ClientOrderSearchFilterOptionsDocument;


useClientOrderSearchFilterOptionsQuery.getKey = (variables?: ClientOrderSearchFilterOptionsQueryVariables) => variables === undefined ? ['ClientOrderSearchFilterOptions'] : ['ClientOrderSearchFilterOptions', variables];
;

export const ClientOrderShowDocument = `
    query ClientOrderShow($id: ID!) {
  clientOrder(id: $id) {
    ...ClientOrderShowMaker
  }
}
    ${ClientOrderShowMakerFragmentDoc}`;
export const useClientOrderShowQuery = <
      TData = ClientOrderShowQuery,
      TError = unknown
    >(
      variables: ClientOrderShowQueryVariables,
      options?: UseQueryOptions<ClientOrderShowQuery, TError, TData>
    ) =>
    useQuery<ClientOrderShowQuery, TError, TData>(
      ['ClientOrderShow', variables],
      graphqlFetcher<ClientOrderShowQuery, ClientOrderShowQueryVariables>(ClientOrderShowDocument, variables),
      options
    );
useClientOrderShowQuery.document = ClientOrderShowDocument;


useClientOrderShowQuery.getKey = (variables: ClientOrderShowQueryVariables) => ['ClientOrderShow', variables];
;

export const ClientOrdersDocument = `
    query ClientOrders($after: String, $clientId: ID, $year: String) {
  clientOrders(after: $after, clientId: $clientId, year: $year) {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      ...ClientProjectListItem
    }
  }
}
    ${ClientProjectListItemFragmentDoc}`;
export const useClientOrdersQuery = <
      TData = ClientOrdersQuery,
      TError = unknown
    >(
      variables?: ClientOrdersQueryVariables,
      options?: UseQueryOptions<ClientOrdersQuery, TError, TData>
    ) =>
    useQuery<ClientOrdersQuery, TError, TData>(
      variables === undefined ? ['ClientOrders'] : ['ClientOrders', variables],
      graphqlFetcher<ClientOrdersQuery, ClientOrdersQueryVariables>(ClientOrdersDocument, variables),
      options
    );
useClientOrdersQuery.document = ClientOrdersDocument;


useClientOrdersQuery.getKey = (variables?: ClientOrdersQueryVariables) => variables === undefined ? ['ClientOrders'] : ['ClientOrders', variables];
;

export const ClientSearchDocument = `
    query ClientSearch($query: String, $after: String, $sorts: [ClientSort!]) {
  clients(query: $query, after: $after, sorts: $sorts) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      ...ClientSearchClient
    }
  }
}
    ${ClientSearchClientFragmentDoc}`;
export const useClientSearchQuery = <
      TData = ClientSearchQuery,
      TError = unknown
    >(
      variables?: ClientSearchQueryVariables,
      options?: UseQueryOptions<ClientSearchQuery, TError, TData>
    ) =>
    useQuery<ClientSearchQuery, TError, TData>(
      variables === undefined ? ['ClientSearch'] : ['ClientSearch', variables],
      graphqlFetcher<ClientSearchQuery, ClientSearchQueryVariables>(ClientSearchDocument, variables),
      options
    );
useClientSearchQuery.document = ClientSearchDocument;


useClientSearchQuery.getKey = (variables?: ClientSearchQueryVariables) => variables === undefined ? ['ClientSearch'] : ['ClientSearch', variables];
;

export const CreateMakerOrderDocument = `
    mutation CreateMakerOrder($input: CreateMakerOrderInput!) {
  createMakerOrder(input: $input) {
    makerOrder {
      clientOrderId
      makerId
      makerLegalAgreementId
      humanId
      contacts {
        fullName
      }
    }
    errors {
      path
      message
    }
  }
}
    `;
export const useCreateMakerOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateMakerOrderMutation, TError, CreateMakerOrderMutationVariables, TContext>) =>
    useMutation<CreateMakerOrderMutation, TError, CreateMakerOrderMutationVariables, TContext>(
      'CreateMakerOrder',
      (variables?: CreateMakerOrderMutationVariables) => graphqlFetcher<CreateMakerOrderMutation, CreateMakerOrderMutationVariables>(CreateMakerOrderDocument, variables)(),
      options
    );
export const CurrentUserDocument = `
    query CurrentUser {
  currentUser {
    id
    role
  }
}
    `;
export const useCurrentUserQuery = <
      TData = CurrentUserQuery,
      TError = unknown
    >(
      variables?: CurrentUserQueryVariables,
      options?: UseQueryOptions<CurrentUserQuery, TError, TData>
    ) =>
    useQuery<CurrentUserQuery, TError, TData>(
      variables === undefined ? ['CurrentUser'] : ['CurrentUser', variables],
      graphqlFetcher<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, variables),
      options
    );
useCurrentUserQuery.document = CurrentUserDocument;


useCurrentUserQuery.getKey = (variables?: CurrentUserQueryVariables) => variables === undefined ? ['CurrentUser'] : ['CurrentUser', variables];
;

export const ImpactReportDocument = `
    mutation ImpactReport($input: ImpactReportInput!) {
  impactReport(input: $input) {
    impactReport {
      id
      showUrl
    }
    errors {
      path
      message
    }
  }
}
    `;
export const useImpactReportMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ImpactReportMutation, TError, ImpactReportMutationVariables, TContext>) =>
    useMutation<ImpactReportMutation, TError, ImpactReportMutationVariables, TContext>(
      'ImpactReport',
      (variables?: ImpactReportMutationVariables) => graphqlFetcher<ImpactReportMutation, ImpactReportMutationVariables>(ImpactReportDocument, variables)(),
      options
    );
export const ImpactReportSearchDocument = `
    query ImpactReportSearch($query: String, $after: String, $makers: [ID!], $clients: [ID!], $createdAfter: ISO8601DateTime, $createdBefore: ISO8601DateTime, $deliveryWindowAfter: ISO8601DateTime, $deliveryWindowBefore: ISO8601DateTime, $types: [String!]) {
  impactReports(
    query: $query
    after: $after
    makers: $makers
    clients: $clients
    createdAfter: $createdAfter
    createdBefore: $createdBefore
    deliveryWindowAfter: $deliveryWindowAfter
    deliveryWindowBefore: $deliveryWindowBefore
    types: $types
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      ...ImpactReportListItem
    }
  }
}
    ${ImpactReportListItemFragmentDoc}`;
export const useImpactReportSearchQuery = <
      TData = ImpactReportSearchQuery,
      TError = unknown
    >(
      variables?: ImpactReportSearchQueryVariables,
      options?: UseQueryOptions<ImpactReportSearchQuery, TError, TData>
    ) =>
    useQuery<ImpactReportSearchQuery, TError, TData>(
      variables === undefined ? ['ImpactReportSearch'] : ['ImpactReportSearch', variables],
      graphqlFetcher<ImpactReportSearchQuery, ImpactReportSearchQueryVariables>(ImpactReportSearchDocument, variables),
      options
    );
useImpactReportSearchQuery.document = ImpactReportSearchDocument;


useImpactReportSearchQuery.getKey = (variables?: ImpactReportSearchQueryVariables) => variables === undefined ? ['ImpactReportSearch'] : ['ImpactReportSearch', variables];
;

export const ImpactReportShowDocument = `
    query ImpactReportShow($id: ID!) {
  impactReport(id: $id) {
    ...ImpactReportShowMaker
  }
}
    ${ImpactReportShowMakerFragmentDoc}`;
export const useImpactReportShowQuery = <
      TData = ImpactReportShowQuery,
      TError = unknown
    >(
      variables: ImpactReportShowQueryVariables,
      options?: UseQueryOptions<ImpactReportShowQuery, TError, TData>
    ) =>
    useQuery<ImpactReportShowQuery, TError, TData>(
      ['ImpactReportShow', variables],
      graphqlFetcher<ImpactReportShowQuery, ImpactReportShowQueryVariables>(ImpactReportShowDocument, variables),
      options
    );
useImpactReportShowQuery.document = ImpactReportShowDocument;


useImpactReportShowQuery.getKey = (variables: ImpactReportShowQueryVariables) => ['ImpactReportShow', variables];
;

export const MakerDocumentsDocument = `
    query MakerDocuments($slug: String!) {
  maker(slug: $slug) {
    ...MakerDocuments
  }
}
    ${MakerDocumentsFragmentDoc}`;
export const useMakerDocumentsQuery = <
      TData = MakerDocumentsQuery,
      TError = unknown
    >(
      variables: MakerDocumentsQueryVariables,
      options?: UseQueryOptions<MakerDocumentsQuery, TError, TData>
    ) =>
    useQuery<MakerDocumentsQuery, TError, TData>(
      ['MakerDocuments', variables],
      graphqlFetcher<MakerDocumentsQuery, MakerDocumentsQueryVariables>(MakerDocumentsDocument, variables),
      options
    );
useMakerDocumentsQuery.document = MakerDocumentsDocument;


useMakerDocumentsQuery.getKey = (variables: MakerDocumentsQueryVariables) => ['MakerDocuments', variables];
;

export const MakerEditDocument = `
    query MakerEdit($slug: String!) {
  maker(slug: $slug) {
    ...MakerEditMaker
  }
}
    ${MakerEditMakerFragmentDoc}`;
export const useMakerEditQuery = <
      TData = MakerEditQuery,
      TError = unknown
    >(
      variables: MakerEditQueryVariables,
      options?: UseQueryOptions<MakerEditQuery, TError, TData>
    ) =>
    useQuery<MakerEditQuery, TError, TData>(
      ['MakerEdit', variables],
      graphqlFetcher<MakerEditQuery, MakerEditQueryVariables>(MakerEditDocument, variables),
      options
    );
useMakerEditQuery.document = MakerEditDocument;


useMakerEditQuery.getKey = (variables: MakerEditQueryVariables) => ['MakerEdit', variables];
;

export const MakerOrderEditDocument = `
    query MakerOrderEdit($id: ID!) {
  makerOrder(id: $id) {
    ...MakerOrderEditMaker
  }
}
    ${MakerOrderEditMakerFragmentDoc}`;
export const useMakerOrderEditQuery = <
      TData = MakerOrderEditQuery,
      TError = unknown
    >(
      variables: MakerOrderEditQueryVariables,
      options?: UseQueryOptions<MakerOrderEditQuery, TError, TData>
    ) =>
    useQuery<MakerOrderEditQuery, TError, TData>(
      ['MakerOrderEdit', variables],
      graphqlFetcher<MakerOrderEditQuery, MakerOrderEditQueryVariables>(MakerOrderEditDocument, variables),
      options
    );
useMakerOrderEditQuery.document = MakerOrderEditDocument;


useMakerOrderEditQuery.getKey = (variables: MakerOrderEditQueryVariables) => ['MakerOrderEdit', variables];
;

export const MakerLogisticsDocument = `
    query MakerLogistics($slug: String!) {
  maker(slug: $slug) {
    ...MakerLogistics
  }
}
    ${MakerLogisticsFragmentDoc}`;
export const useMakerLogisticsQuery = <
      TData = MakerLogisticsQuery,
      TError = unknown
    >(
      variables: MakerLogisticsQueryVariables,
      options?: UseQueryOptions<MakerLogisticsQuery, TError, TData>
    ) =>
    useQuery<MakerLogisticsQuery, TError, TData>(
      ['MakerLogistics', variables],
      graphqlFetcher<MakerLogisticsQuery, MakerLogisticsQueryVariables>(MakerLogisticsDocument, variables),
      options
    );
useMakerLogisticsQuery.document = MakerLogisticsDocument;


useMakerLogisticsQuery.getKey = (variables: MakerLogisticsQueryVariables) => ['MakerLogistics', variables];
;

export const ImpactReportSearchFilterOptionsDocument = `
    query ImpactReportSearchFilterOptions {
  impactReportSearchFilterOptions {
    makers {
      id
      name
    }
    clients {
      id
      name
    }
    types
  }
}
    `;
export const useImpactReportSearchFilterOptionsQuery = <
      TData = ImpactReportSearchFilterOptionsQuery,
      TError = unknown
    >(
      variables?: ImpactReportSearchFilterOptionsQueryVariables,
      options?: UseQueryOptions<ImpactReportSearchFilterOptionsQuery, TError, TData>
    ) =>
    useQuery<ImpactReportSearchFilterOptionsQuery, TError, TData>(
      variables === undefined ? ['ImpactReportSearchFilterOptions'] : ['ImpactReportSearchFilterOptions', variables],
      graphqlFetcher<ImpactReportSearchFilterOptionsQuery, ImpactReportSearchFilterOptionsQueryVariables>(ImpactReportSearchFilterOptionsDocument, variables),
      options
    );
useImpactReportSearchFilterOptionsQuery.document = ImpactReportSearchFilterOptionsDocument;


useImpactReportSearchFilterOptionsQuery.getKey = (variables?: ImpactReportSearchFilterOptionsQueryVariables) => variables === undefined ? ['ImpactReportSearchFilterOptions'] : ['ImpactReportSearchFilterOptions', variables];
;

export const MakerOrderHistoryDocument = `
    query MakerOrderHistory($makerOrderId: ID!) {
  makerOrderHistory(makerOrderId: $makerOrderId) {
    nodes {
      id
      note
      createdAt
      description
      responsible
      user {
        displayName
      }
    }
  }
}
    `;
export const useMakerOrderHistoryQuery = <
      TData = MakerOrderHistoryQuery,
      TError = unknown
    >(
      variables: MakerOrderHistoryQueryVariables,
      options?: UseQueryOptions<MakerOrderHistoryQuery, TError, TData>
    ) =>
    useQuery<MakerOrderHistoryQuery, TError, TData>(
      ['MakerOrderHistory', variables],
      graphqlFetcher<MakerOrderHistoryQuery, MakerOrderHistoryQueryVariables>(MakerOrderHistoryDocument, variables),
      options
    );
useMakerOrderHistoryQuery.document = MakerOrderHistoryDocument;


useMakerOrderHistoryQuery.getKey = (variables: MakerOrderHistoryQueryVariables) => ['MakerOrderHistory', variables];
;

export const MakerOrderSearchFilterOptionsDocument = `
    query MakerOrderSearchFilterOptions {
  makerOrderSearchFilterOptions {
    makers {
      id
      name
    }
    clients {
      id
      name
    }
    statuses
  }
}
    `;
export const useMakerOrderSearchFilterOptionsQuery = <
      TData = MakerOrderSearchFilterOptionsQuery,
      TError = unknown
    >(
      variables?: MakerOrderSearchFilterOptionsQueryVariables,
      options?: UseQueryOptions<MakerOrderSearchFilterOptionsQuery, TError, TData>
    ) =>
    useQuery<MakerOrderSearchFilterOptionsQuery, TError, TData>(
      variables === undefined ? ['MakerOrderSearchFilterOptions'] : ['MakerOrderSearchFilterOptions', variables],
      graphqlFetcher<MakerOrderSearchFilterOptionsQuery, MakerOrderSearchFilterOptionsQueryVariables>(MakerOrderSearchFilterOptionsDocument, variables),
      options
    );
useMakerOrderSearchFilterOptionsQuery.document = MakerOrderSearchFilterOptionsDocument;


useMakerOrderSearchFilterOptionsQuery.getKey = (variables?: MakerOrderSearchFilterOptionsQueryVariables) => variables === undefined ? ['MakerOrderSearchFilterOptions'] : ['MakerOrderSearchFilterOptions', variables];
;

export const MakerOrderSearchDocument = `
    query MakerOrderSearch($query: String, $after: String, $makers: [ID!], $clients: [ID!], $createdAfter: ISO8601DateTime, $createdBefore: ISO8601DateTime, $exFactoryDateAfter: ISO8601DateTime, $exFactoryDateBefore: ISO8601DateTime, $inHandsAfter: ISO8601DateTime, $inHandsBefore: ISO8601DateTime, $statuses: [String!]) {
  makerOrders(
    query: $query
    after: $after
    makers: $makers
    clients: $clients
    createdAfter: $createdAfter
    createdBefore: $createdBefore
    exFactoryDateAfter: $exFactoryDateAfter
    exFactoryDateBefore: $exFactoryDateBefore
    inHandsAfter: $inHandsAfter
    inHandsBefore: $inHandsBefore
    statuses: $statuses
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      ...MakerOrderListItem
    }
  }
}
    ${MakerOrderListItemFragmentDoc}`;
export const useMakerOrderSearchQuery = <
      TData = MakerOrderSearchQuery,
      TError = unknown
    >(
      variables?: MakerOrderSearchQueryVariables,
      options?: UseQueryOptions<MakerOrderSearchQuery, TError, TData>
    ) =>
    useQuery<MakerOrderSearchQuery, TError, TData>(
      variables === undefined ? ['MakerOrderSearch'] : ['MakerOrderSearch', variables],
      graphqlFetcher<MakerOrderSearchQuery, MakerOrderSearchQueryVariables>(MakerOrderSearchDocument, variables),
      options
    );
useMakerOrderSearchQuery.document = MakerOrderSearchDocument;


useMakerOrderSearchQuery.getKey = (variables?: MakerOrderSearchQueryVariables) => variables === undefined ? ['MakerOrderSearch'] : ['MakerOrderSearch', variables];
;

export const MakerProfileOrdersDocument = `
    query MakerProfileOrders($slug: String!, $first: Int!, $after: String) {
  maker(slug: $slug) {
    makerOrders(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        humanId
        createdAt
        humanStatus
        mostRecentEmailSentAt
        showUrl
        clientOrder {
          id
          humanId
          description
          client {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const useMakerProfileOrdersQuery = <
      TData = MakerProfileOrdersQuery,
      TError = unknown
    >(
      variables: MakerProfileOrdersQueryVariables,
      options?: UseQueryOptions<MakerProfileOrdersQuery, TError, TData>
    ) =>
    useQuery<MakerProfileOrdersQuery, TError, TData>(
      ['MakerProfileOrders', variables],
      graphqlFetcher<MakerProfileOrdersQuery, MakerProfileOrdersQueryVariables>(MakerProfileOrdersDocument, variables),
      options
    );
useMakerProfileOrdersQuery.document = MakerProfileOrdersDocument;


useMakerProfileOrdersQuery.getKey = (variables: MakerProfileOrdersQueryVariables) => ['MakerProfileOrders', variables];
;

export const MakerOrderShowDocument = `
    query MakerOrderShow($id: ID!) {
  makerOrder(id: $id) {
    ...MakerOrderShowMaker
  }
}
    ${MakerOrderShowMakerFragmentDoc}`;
export const useMakerOrderShowQuery = <
      TData = MakerOrderShowQuery,
      TError = unknown
    >(
      variables: MakerOrderShowQueryVariables,
      options?: UseQueryOptions<MakerOrderShowQuery, TError, TData>
    ) =>
    useQuery<MakerOrderShowQuery, TError, TData>(
      ['MakerOrderShow', variables],
      graphqlFetcher<MakerOrderShowQuery, MakerOrderShowQueryVariables>(MakerOrderShowDocument, variables),
      options
    );
useMakerOrderShowQuery.document = MakerOrderShowDocument;


useMakerOrderShowQuery.getKey = (variables: MakerOrderShowQueryVariables) => ['MakerOrderShow', variables];
;

export const MakerSearchFilterOptionsDocument = `
    query MakerSearchFilterOptions {
  makerSearchFilterOptions {
    productionCapacities
    certifications(first: 100) {
      nodes {
        id
        name
      }
    }
    makerAttributes {
      id
      text
    }
    costRangeEstimates
    capabilities
    environments
    productCategories {
      id
      name
      productSubcategories {
        nodes {
          id
          name
        }
      }
    }
    shippingCountries {
      id
      iso3166
      name
    }
    materials {
      id
      name
      materialSubcategories {
        nodes {
          id
          name
        }
      }
    }
  }
}
    `;
export const useMakerSearchFilterOptionsQuery = <
      TData = MakerSearchFilterOptionsQuery,
      TError = unknown
    >(
      variables?: MakerSearchFilterOptionsQueryVariables,
      options?: UseQueryOptions<MakerSearchFilterOptionsQuery, TError, TData>
    ) =>
    useQuery<MakerSearchFilterOptionsQuery, TError, TData>(
      variables === undefined ? ['MakerSearchFilterOptions'] : ['MakerSearchFilterOptions', variables],
      graphqlFetcher<MakerSearchFilterOptionsQuery, MakerSearchFilterOptionsQueryVariables>(MakerSearchFilterOptionsDocument, variables),
      options
    );
useMakerSearchFilterOptionsQuery.document = MakerSearchFilterOptionsDocument;


useMakerSearchFilterOptionsQuery.getKey = (variables?: MakerSearchFilterOptionsQueryVariables) => variables === undefined ? ['MakerSearchFilterOptions'] : ['MakerSearchFilterOptions', variables];
;

export const MakerShowDocument = `
    query MakerShow($slug: String!) {
  maker(slug: $slug) {
    ...MakerShowMaker
  }
}
    ${MakerShowMakerFragmentDoc}`;
export const useMakerShowQuery = <
      TData = MakerShowQuery,
      TError = unknown
    >(
      variables: MakerShowQueryVariables,
      options?: UseQueryOptions<MakerShowQuery, TError, TData>
    ) =>
    useQuery<MakerShowQuery, TError, TData>(
      ['MakerShow', variables],
      graphqlFetcher<MakerShowQuery, MakerShowQueryVariables>(MakerShowDocument, variables),
      options
    );
useMakerShowQuery.document = MakerShowDocument;


useMakerShowQuery.getKey = (variables: MakerShowQueryVariables) => ['MakerShow', variables];
;

export const ProductEditDocument = `
    query ProductEdit($id: ID!) {
  product(id: $id) {
    ...ProductEditMaker
  }
}
    ${ProductEditMakerFragmentDoc}`;
export const useProductEditQuery = <
      TData = ProductEditQuery,
      TError = unknown
    >(
      variables: ProductEditQueryVariables,
      options?: UseQueryOptions<ProductEditQuery, TError, TData>
    ) =>
    useQuery<ProductEditQuery, TError, TData>(
      ['ProductEdit', variables],
      graphqlFetcher<ProductEditQuery, ProductEditQueryVariables>(ProductEditDocument, variables),
      options
    );
useProductEditQuery.document = ProductEditDocument;


useProductEditQuery.getKey = (variables: ProductEditQueryVariables) => ['ProductEdit', variables];
;

export const ProductGroupEditDocument = `
    query ProductGroupEdit($id: ID!) {
  productGroup(id: $id) {
    ...ProductGroupEditMaker
  }
}
    ${ProductGroupEditMakerFragmentDoc}`;
export const useProductGroupEditQuery = <
      TData = ProductGroupEditQuery,
      TError = unknown
    >(
      variables: ProductGroupEditQueryVariables,
      options?: UseQueryOptions<ProductGroupEditQuery, TError, TData>
    ) =>
    useQuery<ProductGroupEditQuery, TError, TData>(
      ['ProductGroupEdit', variables],
      graphqlFetcher<ProductGroupEditQuery, ProductGroupEditQueryVariables>(ProductGroupEditDocument, variables),
      options
    );
useProductGroupEditQuery.document = ProductGroupEditDocument;


useProductGroupEditQuery.getKey = (variables: ProductGroupEditQueryVariables) => ['ProductGroupEdit', variables];
;

export const ProductGroupShowDocument = `
    query ProductGroupShow($id: ID!) {
  productGroup(id: $id) {
    ...ProductGroupShowMaker
  }
}
    ${ProductGroupShowMakerFragmentDoc}`;
export const useProductGroupShowQuery = <
      TData = ProductGroupShowQuery,
      TError = unknown
    >(
      variables: ProductGroupShowQueryVariables,
      options?: UseQueryOptions<ProductGroupShowQuery, TError, TData>
    ) =>
    useQuery<ProductGroupShowQuery, TError, TData>(
      ['ProductGroupShow', variables],
      graphqlFetcher<ProductGroupShowQuery, ProductGroupShowQueryVariables>(ProductGroupShowDocument, variables),
      options
    );
useProductGroupShowQuery.document = ProductGroupShowDocument;


useProductGroupShowQuery.getKey = (variables: ProductGroupShowQueryVariables) => ['ProductGroupShow', variables];
;

export const ProductProfileOrdersDocument = `
    query ProductProfileOrders($id: ID!, $first: Int!, $after: String) {
  product(id: $id) {
    clientOrders(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        humanId
        totalQuantity(productId: $id)
        perItemPriceRange(productId: $id)
        msrpRange(productId: $id)
        showUrl
        client {
          id
          name
        }
      }
    }
  }
}
    `;
export const useProductProfileOrdersQuery = <
      TData = ProductProfileOrdersQuery,
      TError = unknown
    >(
      variables: ProductProfileOrdersQueryVariables,
      options?: UseQueryOptions<ProductProfileOrdersQuery, TError, TData>
    ) =>
    useQuery<ProductProfileOrdersQuery, TError, TData>(
      ['ProductProfileOrders', variables],
      graphqlFetcher<ProductProfileOrdersQuery, ProductProfileOrdersQueryVariables>(ProductProfileOrdersDocument, variables),
      options
    );
useProductProfileOrdersQuery.document = ProductProfileOrdersDocument;


useProductProfileOrdersQuery.getKey = (variables: ProductProfileOrdersQueryVariables) => ['ProductProfileOrders', variables];
;

export const ProductGroupProfilePricingAndLogisticsDocument = `
    query ProductGroupProfilePricingAndLogistics($id: ID!) {
  productGroup(id: $id) {
    ...ProductGroupProfilePricingAndLogisticsMaker
  }
}
    ${ProductGroupProfilePricingAndLogisticsMakerFragmentDoc}`;
export const useProductGroupProfilePricingAndLogisticsQuery = <
      TData = ProductGroupProfilePricingAndLogisticsQuery,
      TError = unknown
    >(
      variables: ProductGroupProfilePricingAndLogisticsQueryVariables,
      options?: UseQueryOptions<ProductGroupProfilePricingAndLogisticsQuery, TError, TData>
    ) =>
    useQuery<ProductGroupProfilePricingAndLogisticsQuery, TError, TData>(
      ['ProductGroupProfilePricingAndLogistics', variables],
      graphqlFetcher<ProductGroupProfilePricingAndLogisticsQuery, ProductGroupProfilePricingAndLogisticsQueryVariables>(ProductGroupProfilePricingAndLogisticsDocument, variables),
      options
    );
useProductGroupProfilePricingAndLogisticsQuery.document = ProductGroupProfilePricingAndLogisticsDocument;


useProductGroupProfilePricingAndLogisticsQuery.getKey = (variables: ProductGroupProfilePricingAndLogisticsQueryVariables) => ['ProductGroupProfilePricingAndLogistics', variables];
;

export const ProductProfilePricingAndLogisticsDocument = `
    query ProductProfilePricingAndLogistics($id: ID!) {
  product(id: $id) {
    ...ProductProfilePricingAndLogisticsMaker
  }
}
    ${ProductProfilePricingAndLogisticsMakerFragmentDoc}`;
export const useProductProfilePricingAndLogisticsQuery = <
      TData = ProductProfilePricingAndLogisticsQuery,
      TError = unknown
    >(
      variables: ProductProfilePricingAndLogisticsQueryVariables,
      options?: UseQueryOptions<ProductProfilePricingAndLogisticsQuery, TError, TData>
    ) =>
    useQuery<ProductProfilePricingAndLogisticsQuery, TError, TData>(
      ['ProductProfilePricingAndLogistics', variables],
      graphqlFetcher<ProductProfilePricingAndLogisticsQuery, ProductProfilePricingAndLogisticsQueryVariables>(ProductProfilePricingAndLogisticsDocument, variables),
      options
    );
useProductProfilePricingAndLogisticsQuery.document = ProductProfilePricingAndLogisticsDocument;


useProductProfilePricingAndLogisticsQuery.getKey = (variables: ProductProfilePricingAndLogisticsQueryVariables) => ['ProductProfilePricingAndLogistics', variables];
;

export const ProductProfileTestingAndComplianceDocument = `
    query ProductProfileTestingAndCompliance($id: ID!, $first: Int!, $after: String) {
  product(id: $id) {
    newProductTestUrl
    editUrl
    productTests(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        name
        description
        result
        dateOfCompletion
        editUrl
        document {
          url
          filename
        }
      }
    }
  }
}
    `;
export const useProductProfileTestingAndComplianceQuery = <
      TData = ProductProfileTestingAndComplianceQuery,
      TError = unknown
    >(
      variables: ProductProfileTestingAndComplianceQueryVariables,
      options?: UseQueryOptions<ProductProfileTestingAndComplianceQuery, TError, TData>
    ) =>
    useQuery<ProductProfileTestingAndComplianceQuery, TError, TData>(
      ['ProductProfileTestingAndCompliance', variables],
      graphqlFetcher<ProductProfileTestingAndComplianceQuery, ProductProfileTestingAndComplianceQueryVariables>(ProductProfileTestingAndComplianceDocument, variables),
      options
    );
useProductProfileTestingAndComplianceQuery.document = ProductProfileTestingAndComplianceDocument;


useProductProfileTestingAndComplianceQuery.getKey = (variables: ProductProfileTestingAndComplianceQueryVariables) => ['ProductProfileTestingAndCompliance', variables];
;

export const ProductShowDocument = `
    query ProductShow($id: ID!) {
  product(id: $id) {
    ...ProductShowMaker
  }
}
    ${ProductShowMakerFragmentDoc}`;
export const useProductShowQuery = <
      TData = ProductShowQuery,
      TError = unknown
    >(
      variables: ProductShowQueryVariables,
      options?: UseQueryOptions<ProductShowQuery, TError, TData>
    ) =>
    useQuery<ProductShowQuery, TError, TData>(
      ['ProductShow', variables],
      graphqlFetcher<ProductShowQuery, ProductShowQueryVariables>(ProductShowDocument, variables),
      options
    );
useProductShowQuery.document = ProductShowDocument;


useProductShowQuery.getKey = (variables: ProductShowQueryVariables) => ['ProductShow', variables];
;

export const ProductSearchDocument = `
    query ProductSearch($query: String, $after: String, $sort: ProductSort, $statuses: [String!], $certifications: [ID!], $makerAttributeIds: [ID!], $productAttributeIds: [ID!], $makerIds: [ID!], $makerCapabilities: [String!], $environments: [String!], $productCategoryIds: [ID!], $productSubcategoryIds: [ID!], $materialIds: [ID!], $materialSubcategoryIds: [ID!], $customizations: [String!], $previousBuyers: [String!], $makerTypes: [String!], $countryIds: [ID!], $skus: [String!], $styleNumbers: [String!], $minPrice: Int, $maxPrice: Int, $minUnits: Int, $maxUnits: Int) {
  products(
    query: $query
    after: $after
    sort: $sort
    statuses: $statuses
    certifications: $certifications
    makerAttributeIds: $makerAttributeIds
    productAttributeIds: $productAttributeIds
    makerIds: $makerIds
    makerCapabilities: $makerCapabilities
    environments: $environments
    productCategoryIds: $productCategoryIds
    productSubcategoryIds: $productSubcategoryIds
    materialIds: $materialIds
    materialSubcategoryIds: $materialSubcategoryIds
    customizations: $customizations
    previousBuyers: $previousBuyers
    makerTypes: $makerTypes
    countryIds: $countryIds
    minPrice: $minPrice
    maxPrice: $maxPrice
    minUnits: $minUnits
    maxUnits: $maxUnits
    skus: $skus
    styleNumbers: $styleNumbers
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      ...ProductSearchListItem
    }
  }
}
    ${ProductSearchListItemFragmentDoc}`;
export const useProductSearchQuery = <
      TData = ProductSearchQuery,
      TError = unknown
    >(
      variables?: ProductSearchQueryVariables,
      options?: UseQueryOptions<ProductSearchQuery, TError, TData>
    ) =>
    useQuery<ProductSearchQuery, TError, TData>(
      variables === undefined ? ['ProductSearch'] : ['ProductSearch', variables],
      graphqlFetcher<ProductSearchQuery, ProductSearchQueryVariables>(ProductSearchDocument, variables),
      options
    );
useProductSearchQuery.document = ProductSearchDocument;


useProductSearchQuery.getKey = (variables?: ProductSearchQueryVariables) => variables === undefined ? ['ProductSearch'] : ['ProductSearch', variables];
;

export const ProductSearchFilterOptionsDocument = `
    query ProductSearchFilterOptions {
  productSearchFilterOptions {
    certifications(first: 100) {
      nodes {
        id
        name
      }
    }
    valueAlignments {
      id
      name
    }
    environments
    productCategories {
      id
      name
      productSubcategories {
        nodes {
          id
          name
        }
      }
    }
    makerAttributes {
      id
      text
    }
    productAttributes {
      id
      name
    }
    makers {
      id
      name
    }
    materials {
      id
      name
      materialSubcategories {
        nodes {
          id
          name
        }
      }
    }
    customizations
    previousBuyers
    makerTypes
    makerCapabilities
    countries {
      id
      name
    }
    minPrice
    maxPrice
    minUnits
    maxUnits
  }
}
    `;
export const useProductSearchFilterOptionsQuery = <
      TData = ProductSearchFilterOptionsQuery,
      TError = unknown
    >(
      variables?: ProductSearchFilterOptionsQueryVariables,
      options?: UseQueryOptions<ProductSearchFilterOptionsQuery, TError, TData>
    ) =>
    useQuery<ProductSearchFilterOptionsQuery, TError, TData>(
      variables === undefined ? ['ProductSearchFilterOptions'] : ['ProductSearchFilterOptions', variables],
      graphqlFetcher<ProductSearchFilterOptionsQuery, ProductSearchFilterOptionsQueryVariables>(ProductSearchFilterOptionsDocument, variables),
      options
    );
useProductSearchFilterOptionsQuery.document = ProductSearchFilterOptionsDocument;


useProductSearchFilterOptionsQuery.getKey = (variables?: ProductSearchFilterOptionsQueryVariables) => variables === undefined ? ['ProductSearchFilterOptions'] : ['ProductSearchFilterOptions', variables];
;

export const ShippingPortsDocument = `
    query ShippingPorts($makerId: ID, $locationType: ShippingPortLocation!) {
  shippingPorts(makerId: $makerId, locationType: $locationType) {
    ...ShippingPortListItem
  }
}
    ${ShippingPortListItemFragmentDoc}`;
export const useShippingPortsQuery = <
      TData = ShippingPortsQuery,
      TError = unknown
    >(
      variables: ShippingPortsQueryVariables,
      options?: UseQueryOptions<ShippingPortsQuery, TError, TData>
    ) =>
    useQuery<ShippingPortsQuery, TError, TData>(
      ['ShippingPorts', variables],
      graphqlFetcher<ShippingPortsQuery, ShippingPortsQueryVariables>(ShippingPortsDocument, variables),
      options
    );
useShippingPortsQuery.document = ShippingPortsDocument;


useShippingPortsQuery.getKey = (variables: ShippingPortsQueryVariables) => ['ShippingPorts', variables];
;

export const TimeAndActionDocument = `
    query TimeAndAction($id: ID!) {
  timeAndAction(id: $id) {
    ...TimeAndActionCalendar
  }
}
    ${TimeAndActionCalendarFragmentDoc}`;
export const useTimeAndActionQuery = <
      TData = TimeAndActionQuery,
      TError = unknown
    >(
      variables: TimeAndActionQueryVariables,
      options?: UseQueryOptions<TimeAndActionQuery, TError, TData>
    ) =>
    useQuery<TimeAndActionQuery, TError, TData>(
      ['TimeAndAction', variables],
      graphqlFetcher<TimeAndActionQuery, TimeAndActionQueryVariables>(TimeAndActionDocument, variables),
      options
    );
useTimeAndActionQuery.document = TimeAndActionDocument;


useTimeAndActionQuery.getKey = (variables: TimeAndActionQueryVariables) => ['TimeAndAction', variables];
;

export const TimeAndActionCalendarTemplateEditDocument = `
    query TimeAndActionCalendarTemplateEdit($id: ID!) {
  timeAndActionCalendarTemplate(id: $id) {
    ...TimeAndActionCalendarTemplateEditCalendar
  }
}
    ${TimeAndActionCalendarTemplateEditCalendarFragmentDoc}`;
export const useTimeAndActionCalendarTemplateEditQuery = <
      TData = TimeAndActionCalendarTemplateEditQuery,
      TError = unknown
    >(
      variables: TimeAndActionCalendarTemplateEditQueryVariables,
      options?: UseQueryOptions<TimeAndActionCalendarTemplateEditQuery, TError, TData>
    ) =>
    useQuery<TimeAndActionCalendarTemplateEditQuery, TError, TData>(
      ['TimeAndActionCalendarTemplateEdit', variables],
      graphqlFetcher<TimeAndActionCalendarTemplateEditQuery, TimeAndActionCalendarTemplateEditQueryVariables>(TimeAndActionCalendarTemplateEditDocument, variables),
      options
    );
useTimeAndActionCalendarTemplateEditQuery.document = TimeAndActionCalendarTemplateEditDocument;


useTimeAndActionCalendarTemplateEditQuery.getKey = (variables: TimeAndActionCalendarTemplateEditQueryVariables) => ['TimeAndActionCalendarTemplateEdit', variables];
;

export const UpdateActiveClientOrderDocument = `
    mutation UpdateActiveClientOrder($input: UpdateActiveClientOrderInput!) {
  updateActiveClientOrder(input: $input) {
    clientOrder {
      id
    }
    errors {
      path
      message
    }
  }
}
    `;
export const useUpdateActiveClientOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateActiveClientOrderMutation, TError, UpdateActiveClientOrderMutationVariables, TContext>) =>
    useMutation<UpdateActiveClientOrderMutation, TError, UpdateActiveClientOrderMutationVariables, TContext>(
      'UpdateActiveClientOrder',
      (variables?: UpdateActiveClientOrderMutationVariables) => graphqlFetcher<UpdateActiveClientOrderMutation, UpdateActiveClientOrderMutationVariables>(UpdateActiveClientOrderDocument, variables)(),
      options
    );
export const UpdateClientOrderDocument = `
    mutation UpdateClientOrder($input: UpdateClientOrderInput!) {
  updateClientOrder(input: $input) {
    clientOrder {
      id
      clientOrderProducts {
        nodes {
          editUrl
          product {
            id
          }
        }
      }
    }
    errors {
      path
      message
    }
  }
}
    `;
export const useUpdateClientOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateClientOrderMutation, TError, UpdateClientOrderMutationVariables, TContext>) =>
    useMutation<UpdateClientOrderMutation, TError, UpdateClientOrderMutationVariables, TContext>(
      'UpdateClientOrder',
      (variables?: UpdateClientOrderMutationVariables) => graphqlFetcher<UpdateClientOrderMutation, UpdateClientOrderMutationVariables>(UpdateClientOrderDocument, variables)(),
      options
    );
export const UpdateClientOrderStatusDocument = `
    mutation UpdateClientOrderStatus($input: UpdateClientOrderStatusInput!) {
  updateClientOrderStatus(input: $input) {
    clientOrder {
      id
      status
    }
    errors {
      path
      message
    }
  }
}
    `;
export const useUpdateClientOrderStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateClientOrderStatusMutation, TError, UpdateClientOrderStatusMutationVariables, TContext>) =>
    useMutation<UpdateClientOrderStatusMutation, TError, UpdateClientOrderStatusMutationVariables, TContext>(
      'UpdateClientOrderStatus',
      (variables?: UpdateClientOrderStatusMutationVariables) => graphqlFetcher<UpdateClientOrderStatusMutation, UpdateClientOrderStatusMutationVariables>(UpdateClientOrderStatusDocument, variables)(),
      options
    );
export const UpdateMakerStatusDocument = `
    mutation UpdateMakerStatus($input: UpdateMakerStatusInput!) {
  updateMakerStatus(input: $input) {
    maker {
      id
      status
    }
    errors {
      path
      message
    }
  }
}
    `;
export const useUpdateMakerStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMakerStatusMutation, TError, UpdateMakerStatusMutationVariables, TContext>) =>
    useMutation<UpdateMakerStatusMutation, TError, UpdateMakerStatusMutationVariables, TContext>(
      'UpdateMakerStatus',
      (variables?: UpdateMakerStatusMutationVariables) => graphqlFetcher<UpdateMakerStatusMutation, UpdateMakerStatusMutationVariables>(UpdateMakerStatusDocument, variables)(),
      options
    );
export const UpdateMakerDocument = `
    mutation UpdateMaker($input: UpdateMakerInput!) {
  updateMaker(input: $input) {
    maker {
      id
    }
    errors {
      path
      message
    }
  }
}
    `;
export const useUpdateMakerMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMakerMutation, TError, UpdateMakerMutationVariables, TContext>) =>
    useMutation<UpdateMakerMutation, TError, UpdateMakerMutationVariables, TContext>(
      'UpdateMaker',
      (variables?: UpdateMakerMutationVariables) => graphqlFetcher<UpdateMakerMutation, UpdateMakerMutationVariables>(UpdateMakerDocument, variables)(),
      options
    );
export const UpdateProductDocument = `
    mutation UpdateProduct($input: UpdateProductInput!) {
  updateProduct(input: $input) {
    product {
      id
    }
    errors {
      path
      message
    }
  }
}
    `;
export const useUpdateProductMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductMutation, TError, UpdateProductMutationVariables, TContext>) =>
    useMutation<UpdateProductMutation, TError, UpdateProductMutationVariables, TContext>(
      'UpdateProduct',
      (variables?: UpdateProductMutationVariables) => graphqlFetcher<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, variables)(),
      options
    );
export const UpdateMakerOrderDocument = `
    mutation UpdateMakerOrder($input: UpdateMakerOrderInput!) {
  updateMakerOrder(input: $input) {
    makerOrder {
      id
      shipment {
        id
      }
    }
    errors {
      path
      message
    }
  }
}
    `;
export const useUpdateMakerOrderMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMakerOrderMutation, TError, UpdateMakerOrderMutationVariables, TContext>) =>
    useMutation<UpdateMakerOrderMutation, TError, UpdateMakerOrderMutationVariables, TContext>(
      'UpdateMakerOrder',
      (variables?: UpdateMakerOrderMutationVariables) => graphqlFetcher<UpdateMakerOrderMutation, UpdateMakerOrderMutationVariables>(UpdateMakerOrderDocument, variables)(),
      options
    );
export const CogsValidUntilDocument = `
    query CogsValidUntil($productId: ID!) {
  product(id: $productId) {
    cogsExpiresOn
    pricingOwners(first: 100) {
      nodes {
        value: id
        label: fullName
      }
    }
    pricingOwnerOptions(first: 100) {
      nodes {
        value: id
        label: fullName
      }
    }
  }
}
    `;
export const useCogsValidUntilQuery = <
      TData = CogsValidUntilQuery,
      TError = unknown
    >(
      variables: CogsValidUntilQueryVariables,
      options?: UseQueryOptions<CogsValidUntilQuery, TError, TData>
    ) =>
    useQuery<CogsValidUntilQuery, TError, TData>(
      ['CogsValidUntil', variables],
      graphqlFetcher<CogsValidUntilQuery, CogsValidUntilQueryVariables>(CogsValidUntilDocument, variables),
      options
    );
useCogsValidUntilQuery.document = CogsValidUntilDocument;


useCogsValidUntilQuery.getKey = (variables: CogsValidUntilQueryVariables) => ['CogsValidUntil', variables];
;

export const UpdateCogsExpiresOnDocument = `
    mutation UpdateCogsExpiresOn($input: UpdateProductInput!) {
  updateProduct(input: $input) {
    product {
      availableUntil
    }
  }
}
    `;
export const useUpdateCogsExpiresOnMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCogsExpiresOnMutation, TError, UpdateCogsExpiresOnMutationVariables, TContext>) =>
    useMutation<UpdateCogsExpiresOnMutation, TError, UpdateCogsExpiresOnMutationVariables, TContext>(
      'UpdateCogsExpiresOn',
      (variables?: UpdateCogsExpiresOnMutationVariables) => graphqlFetcher<UpdateCogsExpiresOnMutation, UpdateCogsExpiresOnMutationVariables>(UpdateCogsExpiresOnDocument, variables)(),
      options
    );
export const UpdateProductGroupDocument = `
    mutation UpdateProductGroup($input: UpdateProductGroupInput!) {
  updateProductGroup(input: $input) {
    productGroup {
      id
    }
    errors {
      path
      message
    }
  }
}
    `;
export const useUpdateProductGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductGroupMutation, TError, UpdateProductGroupMutationVariables, TContext>) =>
    useMutation<UpdateProductGroupMutation, TError, UpdateProductGroupMutationVariables, TContext>(
      'UpdateProductGroup',
      (variables?: UpdateProductGroupMutationVariables) => graphqlFetcher<UpdateProductGroupMutation, UpdateProductGroupMutationVariables>(UpdateProductGroupDocument, variables)(),
      options
    );
export const UpdateProductStatusDocument = `
    mutation UpdateProductStatus($input: UpdateProductStatusInput!) {
  updateProductStatus(input: $input) {
    product {
      id
      status
    }
    errors {
      message
    }
  }
}
    `;
export const useUpdateProductStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductStatusMutation, TError, UpdateProductStatusMutationVariables, TContext>) =>
    useMutation<UpdateProductStatusMutation, TError, UpdateProductStatusMutationVariables, TContext>(
      'UpdateProductStatus',
      (variables?: UpdateProductStatusMutationVariables) => graphqlFetcher<UpdateProductStatusMutation, UpdateProductStatusMutationVariables>(UpdateProductStatusDocument, variables)(),
      options
    );
export const UpdateMakerOrderCogsDocument = `
    mutation UpdateMakerOrderCogs($input: UpdateMakerOrderCogsInput!) {
  updateMakerOrderCogs(input: $input) {
    makerOrder {
      id
      showUrl
    }
    errors {
      path
      message
    }
  }
}
    `;
export const useUpdateMakerOrderCogsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMakerOrderCogsMutation, TError, UpdateMakerOrderCogsMutationVariables, TContext>) =>
    useMutation<UpdateMakerOrderCogsMutation, TError, UpdateMakerOrderCogsMutationVariables, TContext>(
      'UpdateMakerOrderCogs',
      (variables?: UpdateMakerOrderCogsMutationVariables) => graphqlFetcher<UpdateMakerOrderCogsMutation, UpdateMakerOrderCogsMutationVariables>(UpdateMakerOrderCogsDocument, variables)(),
      options
    );
export const UpdateTimeAndActionDocument = `
    mutation UpdateTimeAndAction($input: UpdateTimeAndActionInput!) {
  updateTimeAndAction(input: $input) {
    timeAndAction {
      id
      calendar {
        id
        tasks {
          nodes {
            id
            owners {
              nodes {
                id
              }
            }
          }
        }
      }
    }
    errors {
      path
      message
    }
  }
}
    `;
export const useUpdateTimeAndActionMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTimeAndActionMutation, TError, UpdateTimeAndActionMutationVariables, TContext>) =>
    useMutation<UpdateTimeAndActionMutation, TError, UpdateTimeAndActionMutationVariables, TContext>(
      'UpdateTimeAndAction',
      (variables?: UpdateTimeAndActionMutationVariables) => graphqlFetcher<UpdateTimeAndActionMutation, UpdateTimeAndActionMutationVariables>(UpdateTimeAndActionDocument, variables)(),
      options
    );
export const UpdateTimeAndActionCalendarTemplateDocument = `
    mutation UpdateTimeAndActionCalendarTemplate($input: UpdateTimeAndActionCalendarTemplateInput!) {
  updateTimeAndActionCalendarTemplate(input: $input) {
    timeAndActionCalendarTemplate {
      id
      name
      tasks {
        nodes {
          id
        }
      }
    }
    errors {
      path
      message
    }
  }
}
    `;
export const useUpdateTimeAndActionCalendarTemplateMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTimeAndActionCalendarTemplateMutation, TError, UpdateTimeAndActionCalendarTemplateMutationVariables, TContext>) =>
    useMutation<UpdateTimeAndActionCalendarTemplateMutation, TError, UpdateTimeAndActionCalendarTemplateMutationVariables, TContext>(
      'UpdateTimeAndActionCalendarTemplate',
      (variables?: UpdateTimeAndActionCalendarTemplateMutationVariables) => graphqlFetcher<UpdateTimeAndActionCalendarTemplateMutation, UpdateTimeAndActionCalendarTemplateMutationVariables>(UpdateTimeAndActionCalendarTemplateDocument, variables)(),
      options
    );
export const MakerSearchDocument = `
    query MakerSearch($query: String, $after: String, $statuses: [String!]!, $costRangeEstimates: [String!]!, $productionCapacities: [String!], $certifications: [ID!], $makerAttributeIds: [ID!], $shippingCountryIds: [ID!], $environments: [String!], $capabilities: [String!], $productCategoryIds: [ID!], $productSubcategoryIds: [ID!], $materialIds: [ID!], $materialSubcategoryIds: [ID!], $sorts: [MakerSort!]) {
  makers(
    query: $query
    after: $after
    statuses: $statuses
    costRangeEstimates: $costRangeEstimates
    productionCapacities: $productionCapacities
    certifications: $certifications
    makerAttributeIds: $makerAttributeIds
    shippingCountryIds: $shippingCountryIds
    environments: $environments
    capabilities: $capabilities
    productCategoryIds: $productCategoryIds
    productSubcategoryIds: $productSubcategoryIds
    materialIds: $materialIds
    materialSubcategoryIds: $materialSubcategoryIds
    sorts: $sorts
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      ...MakerSearchMaker
    }
  }
}
    ${MakerSearchMakerFragmentDoc}`;
export const useMakerSearchQuery = <
      TData = MakerSearchQuery,
      TError = unknown
    >(
      variables: MakerSearchQueryVariables,
      options?: UseQueryOptions<MakerSearchQuery, TError, TData>
    ) =>
    useQuery<MakerSearchQuery, TError, TData>(
      ['MakerSearch', variables],
      graphqlFetcher<MakerSearchQuery, MakerSearchQueryVariables>(MakerSearchDocument, variables),
      options
    );
useMakerSearchQuery.document = MakerSearchDocument;


useMakerSearchQuery.getKey = (variables: MakerSearchQueryVariables) => ['MakerSearch', variables];
;

export const UpdateTimeAndActionCalendarTaskDocument = `
    mutation UpdateTimeAndActionCalendarTask($input: UpdateTimeAndActionCalendarTaskInput!) {
  updateTimeAndActionCalendarTask(input: $input) {
    timeAndActionCalendarTask {
      id
      status
    }
    errors {
      path
      message
    }
  }
}
    `;
export const useUpdateTimeAndActionCalendarTaskMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateTimeAndActionCalendarTaskMutation, TError, UpdateTimeAndActionCalendarTaskMutationVariables, TContext>) =>
    useMutation<UpdateTimeAndActionCalendarTaskMutation, TError, UpdateTimeAndActionCalendarTaskMutationVariables, TContext>(
      'UpdateTimeAndActionCalendarTask',
      (variables?: UpdateTimeAndActionCalendarTaskMutationVariables) => graphqlFetcher<UpdateTimeAndActionCalendarTaskMutation, UpdateTimeAndActionCalendarTaskMutationVariables>(UpdateTimeAndActionCalendarTaskDocument, variables)(),
      options
    );